import {feats,perks,maneuvers} from "../data.js"
export const fighterPerks = [
    {
        name: "Weapon Training",
        shortDesc: "Choose a weapon type (light, one-handed, two-handed, ranged), gain +1 to attack and damage with those weapons, this increases by +1 every 4 levels after.",
    },        
    {
        name: "Oversized Weapon Specialist",
        shortDesc: "You can wield a two handed weapon in one hand, while doing so it counts as a both a one handed weapon and two handed weapon for all prerequisites for other abilities, however still deals damage as if it were one handed, and you get a -4 to your attack while doing so. You can wield a one handed weapon as a light weapon.",
    },
        {
            name: "Deflective Shield",
            shortDesc: "When wielding a shield you gain a +1 bonus to your touch AC, plus your shields enhancement bonus.",
        },
        {
        name: "Armor Mastery",
        abilityType:"Ex",
        shortDesc: "Gain damage reduction 5/— whenever he is wearing armor or using a shield.",
        },
        {
        name: "Phalanx Fighting",
        fromClass:"Phalanx Soldier Fighter",
        abilityType:"Ex",
        shortDesc: "While wielding a shield you can also use any polearm as a one handed weapon. Reduce the armor check penalty and attack penalty from tower shields by 1 for every 5 levels, (minimum 0)",
        },
        {
        name: "Shield Ally",
        fromClass:"Phalanx Soldier Fighter",
        abilityType:"Ex",
        shortDesc: "While wielding a shield with a base shield bonus of +2 or higher you can as a move action provide partial cover (+2 cover bonus to ac and +1 to reflex saves) to yourself and all adjacent allies until the beginning of your next turn. Alternatively you can provide cover (+4 cover bonus to ac and +2 to reflex) and evasion to one adjacent ally until the beginning of your next turn.",
        },        
        {
        name: "Giant Weapon Wielder",
        fromClass:"Titan Fighter",
        abilityType:"Ex",
        shortDesc: "While wielding a two handed weapon you can choose to take -6 to attacks with it for it to deal damage as if it were one size category larger. This stacks with other size increases, even ones that only treat the weapon as one size category larger. You can only do this once per weapon unless you have this perk multiple times. For every 4 levels you have this penalty reduces by 1 (to minimum 0)",
        },
        {
            name: "Polearm Parry",
            fromClass:"Polearm Master",
            abilityType:"Ex",
            shortDesc: "When an opponent threatened by a polearm master makes a melee attack against an ally, he may take an immediate action to grant his ally a +2 shield bonus to AC and DR 5/— against that attack. He may use this ability to protect himself, but only if the attacking creature is not adjacent to him. If wielding a polearm to use this ability, the shield bonus increases by your polearms enchantment modifier.",
        },
        {
            name: "Relic Channeler",
            fromClass:"Relic Master",
            abilityType:"Su",
            shortDesc: "A relic master can increase the potency of a magic item they wield by investing it with a bit of their vitality as a swift action for 4 spell points. If the item is armor, a shield, or a weapon, its enhancement bonus increases by 1. If the magic item creates a spell or has a save DC, its DC increases by +1, increasing by +1 every 5 levels. This bonus lasts 1 minute.",
        },
        {
        name: "Unstoppable Momentum",
        fromClass:"Titan Fighter",
        abilityType:"Ex",
        shortDesc: "Gain a +1 to CMB and CMD, +1 every 5 levels. You can also attempt bull rush, drag, overrun, reposition, and trip maneuvers on creatures up to two size categories larger than yourself.",
        },
        {
            name: "Centered Senses",
            fromClass:"Sensate",
            abilityType:"Su",
            shortDesc: "a sensate can center his senses as a move action. While centered, a sensate gains a +1 insight bonus on attack rolls, weapon damage rolls, and Will saves. This bonus increases by 1 every 5 levels. A sensate loses his centered state if he gains the confused, dazed, fascinated, staggered, or stunned condition; falls unconscious; or fails a Will save.",
        },
        {
        name: "Combat Maneuver Expert",
        shortDesc: "Gain +1 to CMB and CMD, increasing by 1 every 4 levels, and choose 3 improved combat maneuver feats to gain, including: Grapple, Disarm, Dirty Trick, Bull Rush, Drag, Overrun, Reposition, Sunder, Trip. If you have the greater version already you will be able to select the greater version, but you cannot use this perk to gain both the improved and greater feat at once. If you already have the greater version of a combat maneuver feat you can instead select a combat maneuver expert feat, this feat also stacks with itself.",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context, self)=>{
            let choices = []
            let combatManeuvers = ["Grapple", "Disarm", "Dirty Trick", "Bull Rush", "Drag", "Overrun", "Reposition", "Sunder", "Trip"]
            combatManeuvers.forEach(maneuver =>{                                 
                if(context.stats.lists.feats.filter(feat=> feat.name=="Improved " + maneuver).length > 0){
                    if(context.stats.lists.feats.filter(feat=> feat.name=="Greater " + maneuver).length > 0){
                        choices.push({
                            name:maneuver + " Expert",
                            prereq: "",
                            type:"martial",
                            longDesc:"Gain +1 to " + maneuver + " combat maneuvers, increasing by 1 every 5 levels. This feat stacks with everything including itself."
                        })                        
                    } else{
                        choices.push(feats.filter(feat=>feat.name=="Greater " + maneuver)[0])
                    }
                }else{
                    choices.push(feats.filter(feat=>feat.name=="Improved " + maneuver)[0])
                }                
            })
            self.getFeatChoice(context, choices)
            
        },
        getFeatChoice:(context, choices)=>{
            for(let z = 1; z < 4; z++){
                let options = []
                for(let x = 0; x < choices.length; x++){               
                    options.push(
                        {
                            title:choices[x].name,
                            id: x+1,
                            description: choices[x].longDesc ? choices[x].longDesc : choices[x].shortDesc,
                            feat:choices[x],
                            method:()=>{
                                for(let y = 1; y < context.customDialogArray.length; y++){    
                                    let index = context.customDialogArray[y].options.findIndex(option=>{return option.title == choices[x].name})
                                    if(index != -1){
                                        context.customDialogArray[y].options.splice(index,1)
                                    }
                                }
                                context.stats.lists.feats.push(choices[x])
                            }
                        }
                    )
                }
                context.customDialogArray.push({ title:"Combat Maneuver Expert Choice " + z,  options})
            }
        },
        },
        {
        name: "Armor Specialization",
        shortDesc: "You become adept and using armor to protect yourself, while wearing light armor your armor bonus increases by 1, in medium it increases by 2, and in heavy it increases by 3, additionally add one-quarter of your level to your armor's armor bonus (minimum 0).",
        },
        {
        name: "Ironclad Reactions",
        shortDesc: "Gain +1 attack of opportunity per round, +1 every 3 levels. Once per round when a foe successfully hits you with an attack of opportunity, you can expend a use of an attack of opportunity to take a 5-foot step. You can do this even if you have already taken a 5-foot step.",
        },
        {
        name: "Knocking Blows",
        shortDesc: "If you hit a creature that is no more than one size category larger than you with a Power Attack, the creature you attacked is also knocked off balance. Until the beginning of your next turn, it takes a -4 penalty to its CMD against combat maneuvers that move it or knock it prone.",
        },
        {
        name: "Secured Armor",
        shortDesc: "When you are hit by a confirmed critical hit or a sneak attack, there is a 25% chance that the critical hit or sneak attack is negated and damage is instead rolled normally.",
        },
        {
        name: "Armored Sacrifice",
        shortDesc: "When damage would cause the fighter or an adjacent ally to be knocked unconscious or killed, the fighter can instead direct the damage to a suit of armor that he is wearing or a shield he is using as an immediate action for level spell points. The original target takes no damage, but the armor or shield is treated as if it had only half its normal hardness.",
        },
        {
        name: "Steel Headbutt",
        abilityType:"Ex",
        shortDesc: "While wearing medium or heavy armor, a fighter can deliver a headbutt with his helm as part of a full attack action. This headbutt is in addition to his normal attacks, and is made using the fighter's base attack bonus - 5. A helmet headbutt deals 1d3 points of damage if the fighter is wearing medium armor, or 1d4 points of damage if he is wearing heavy armor (1d2 and 1d3, respectively, for Small creatures), plus an amount of damage equal to 1/2 the fighter's Strength modifier. Treat this attack as a weapon attack made using the same special material (if any) as the armor. The armor's enhancement bonus does modify the headbutt attack.",
        },
        {
        name: "Steel Net",
        abilityType:"Ex",
        fromClass:"Defender",
        shortDesc: "A defender can create a blazing wall of steel to defend himself. When fighting defensively as a full-round action with a one-handed sword with your off-hand empty, the defender's penalties on all attacks in a round are reduced by 2, and his dodge bonus to AC increases by 2 for the same round.",
        },
        {
            name: "Counterattack",
            abilityType:"Ex",
            fromClass:"Defender",
            shortDesc: "Once per round, a defender can make an attack of opportunity against an opponent who hits him with a melee attack so long as the attacking creature is within the his reach. This ability doesn't consume a use of your normal attacks of opportunity per round.",
        },
        {
            name: "Interference",
            abilityType:"Ex",
            fromClass:"Free Hand Fighter",
            shortDesc: "A free hand fighter can make a disarm or trip combat maneuver against a target he threatens as a move action to push his opponent off balance. If successful, the target becomes flat-footed. This condition lasts until the target takes damage from a melee or ranged attack or until the beginning of the free hand fighter's next turn, whichever comes first. This effect also activates if you trip or disarm a creature normally.",
        },
        {
            name: "Free Fighting Style",
            abilityType:"Ex",
            fromClass:"Free Hand Fighter",
            shortDesc: "A freestyle fighter can freely mix two of the styles he knows into a more flexible style. A free-style fighter can have an additional style feat stance active simultaneously with his first style feat stance. He can enter all of his allowed stances as a move action or one stance as a swift action.",
        },
        {
            name: "Trench Warfare",
            abilityType:"Ex",
            fromClass:"Trench Fighter",
            shortDesc: "Choose a specific firearm, you can add your dexterity bonus to its damage rolls. Every 8 levels you can select an additional firearm. Additionally, when behind partial, normal, or improved cover you gain an additional +2 AC bonus from the cover.",
        },
        {
            name: "Active Defenses",
            abilityType:"Ex",
            fromClass:"Shielded Fighter",
            shortDesc: "You gain a +1 dodge bonus to armor class when wielding a shield and fighting defensively, using combat reflexes, or using total defense. This bonus increases by +1 every 4 levels. As a swift action you may share this bonus with one adjacent ally, or half the bonus to all adjacent allies until the beginning of your next turn.",
        },
        {
            name: "Shield Buffet",
            abilityType:"Ex",
            fromClass:"Shielded Fighter",
            shortDesc: "As a move action, a shielded fighter may make a combat maneuver check to use his shield to impede an adjacent enemy. This doesn't provoke and you can add your shields enhancement bonus to the check as if using it to perform the maneuver. If successful, the target suffers a -2 penalty on its attack rolls against the shielded fighter and a -2 penalty to AC on attacks made by the shielded fighter until the beginning of his next turn. At 7th level, a shielded fighter may use this ability as a swift action.",
        },
        {
            name: "Breaker Rush",
            abilityType:"Ex",
            fromClass:"Siegebreaker",
            shortDesc: "A siegebreaker can attempt bull rush or overrun combat maneuvers without provoking attacks of opportunity. When he performs either combat maneuver, he deals an amount of bludgeoning damage equal to his Strength bonus (minimum 1). If you have another way to make a bullrush or overrun manevuer without provoking, such as the improved bullrush feat, the damage dealt by the appropriate maneuver increases by 2 and he adds any enhancement bonus from his armor and shield to the damage. Alternatively he can choose to deal damage as if he had shield bashed them.",
        },
        {
            name: "Armored Vigor",
            abilityType:"Ex",
            fromClass:"Siegebreaker",
            shortDesc: "As a swift action you can spend 2 spell points to gain temporary hit points that last 1 minute. The type of armor you are wearing determines the amount gained, Heavy armor gives 3, medium 2, and light 1, unarmored 4. Every 3 levels this increases by 1 increment.",
        },
        {
            name: "Disorienting Blow",
            abilityType:"Ex",
            fromClass:"Siegebreaker",
            shortDesc: "As an immediate action, a siegebreaker can distract a foe he just hit with an attack or combat maneuver, imposing a -2 penalty on the foe's attack rolls, caster level checks, or skill checks for 1 round. The foe can negate this penalty with a successful Fortitude save (DC = 10 + 1/2 level + Strength modifier). Every 6 levels this penalty increases by an additional -2.",
        },
        {
            name: "Mobile Mastery",
            abilityType:"Ex",
            fromClass:"Skirmisher",
            shortDesc: "You gain a 20% miss chance on attacks against you. This functions even when flat-footed, but not when immobilized or helpless, or when he wears medium or heavy armor.",
        },
        {
        name: "Effortless Dual-Wielding",
        shortDesc: "The fighter treats all one-handed weapons as though they were light weapons when determining his penalties on attack rolls for fighting with two weapons. If he has the two-weapon fighting feat he gains +1 to attack when attacking with both weapons. This bonus increases by +1 every 6 levels",
        },
        {
        name: "Fighters Finesse",
        shortDesc: "The fighter gains the benefits of the Weapon Finesse feat with all melee weapons. He can apply dexterity to damage instead of strength to damage with all light and finessable weapons. If you have weapon finesse you can also apply dexterity to damage instead of strength with all weapons you have with weapon finesse.",
        },
        {
        name: "Weapon Mastery",
        abilityType:"Ex",
        shortDesc: "Choose a single weapon, such as longsword or greataxe. Any attacks with this weapon automatically confirm all critical threats and have their critical damage multiplier increased by 1. Additionally you cannot be disarmed while wielding that type of weapon.",
        },
        {
        name: "Armored Confidence",
        abilityType:"Ex",
        shortDesc: "Gain a bonus on intimidate checks based upon the armor you are wearing, +2 for light, +3 for medium, and +4 for heavy armor. This bonus increases by +1 for each 3 levels you have.",
        },
        {
        name: "Defensive Weapon Training",
        shortDesc: "The fighter gains a +1 shield bonus to his Armor Class. The fighter adds half his weapon's enhancement bonus (if any) to this shield bonus. If you have multiple weapons equipped choose one to gain this bonus with. When you reach level 10, this shield bonus increases to +2. This shield bonus is lost if the fighter is immobilized or helpless.",
        },
        {
        name: "Fighters Tactics",
        shortDesc: "All of the fighter's allies are treated as if they had the same teamwork feats as the fighter for the purpose of determining whether the fighter receives a bonus from his teamwork feats. His allies do not receive any bonuses from these feats unless they actually have the feats themselves. The allies' positioning and actions must still meet the prerequisites listed in the teamwork feat for the fighter to receive the listed bonus. Increase any numerical bonus you gain from teamwork feats by 1, +1 for every 8 levels.",
        },
        {
        name: "Weapon Evoker Mastery",
        shortDesc: "As a swift action while wielding a magic weapon with a weapon special ability that deals extra acid, cold, fire, electricity, or sonic damage on a hit, you deal an additional 1d4 points of damage of the same type with each hit you make with that weapon for 1 round. This deals an additional 1d4 of the associated energy type every 5 levels you have.",
        },
        {
        name: "Trained Grace",
        shortDesc: "When the fighter makes a melee attack with a weapon, using his Dexterity modifier on attack rolls and his Strength modifier on damage rolls, you gain +3 damage, increasing by +3 each 4 BAB. this is increased by 50% if youre using finesse on a two handed weapon",
        },
        {
        name: "Weapon Sacrifice",
        shortDesc: "When damage would cause the fighter or an adjacent ally to be knocked unconscious or killed, as a swift or immediate action for level spell points the fighter can instead direct the damage to a weapon that he is wielding. The original target takes no damage, but the weapon receives only half its normal hardness. He cannot use this option with unarmed attacks.",
        },                
        {
        name: "Armor Training",
        shortDesc: `Reduce your armor check penalty by 1 (to a minimum of 0) and increases the maximum Dexterity bonus allowed by his armor by 1. Every four levels these bonuses increase by +1 each time.
        \nIn addition, a fighter can also move at his normal speed while wearing medium armor. At 7th level, a fighter can move at his normal speed while wearing heavy armor.`,
        },
        {
        name: "Volley",
        fromClass:"Archer",
        shortDesc: "As a full-round action, an archer can make a single bow attack at his highest base attack bonus against any number of creatures in a 15-foot radius burst, making separate attack and damage rolls for each creature.",
        },
        {
            name: "Armored Defense",
            abilityType:"Ex",
            fromClass:"Armor Master",
            shortDesc: "You gain DR 1/- when wearing light armor, 2/- when wearing medium armor, and 3/- when wearing heavy armor. Each of these bonuses increase by 1 increment (+1, +2 or +3) every 6 levels. This stacks with DR granted by your armor, but not other DR, and doesn't apply when stunned or helpless.",
        },
        {
            name: "Fortification",
            abilityType:"Ex",
            fromClass:"Armor Master",
            shortDesc: "When wearing armor you gain a 25% chance to negate critical hits and sneak attacks. This functions like the fortification ability. If you are also wielding a shield this increases to 50%. This stacks with fortification provided by either your shield or your armor (not both), but no other type of fortification. This does not function if you are stunned or helpless.",
        },
        {
            name: "Deadshot",
            abilityType:"Ex",
            fromClass:"Crossbowman",
            shortDesc: "When you make an attack with a ranged weapon as a readied action, you may add your dexterity modifier as a bonus to your damage roll. This stacks even if you were already adding dexterity as a modifier to the damage.",
        },
        {
            name: "Quick Sniper",
            abilityType:"Ex",
            fromClass:"Crossbowman",
            shortDesc: "You gain a bonus equal to 1/2 you level on Stealth checks when sniping. When you are hit with a ranged attack, you can fire a ranged weapon at your attacker as an immediate action if it is loaded and currently in hand.",
        },
        {
            name: "Penetrating Shot",
            abilityType:"Ex",
            fromClass:"Crossbowman",
            shortDesc: "When you confirm a critical hit with a ranged weapon, the shot pierces the target and can strike another creature in line behind it. You must be able to trace a line starting at your space and passing through both targets to make this additional attack. The secondary attack is made at a -6 penalty, in addition to any modifiers for added range. If this attack is also a critical hit, the bolt can continue to hit another target, but the penalties stack. If you are using a crossbow, the penalty to attack is only -4. If you were using any speciality ammunition this perk does not work. Any abilities that modified the initial shot do not affect this shot unless it would affect all attacks in a full round attack.",
        },
        {
        name: "Safe Shot",
        fromClass:"Archer",
        shortDesc: "You do not provoke attacks of opportunity when making ranged attacks.",
        },
        {
            name: "Ranged Defense",
            abilityType:"Ex",
            fromClass:"Archer",
            shortDesc: "You gain DR 5/- against ranged attacks. In additiona, as an immediate action you can catch a ranged attack fired at you and shoot it at a target you choose as if you had the snatch arrows feat. To fire the ammunition caught it requires you to be using the appropriate weapon type.",
        },
        {
            name: "Evasive Archer",
            abilityType:"Ex",
            fromClass:"Archer",
            shortDesc: "You gain a +2 dodge bonus against ranged attacks. Every 5 levels this increases by +1.",
        },
        {
        name: "Indestructable",
        fromClass:"Armor Master",
        shortDesc: "Gain complete immunity to critical hits and sneak attacks while wearing armor. In addition, your armor cannot be sundered while you are wearing it.",
        },
        {
        name: "Payback",
        fromClass:"Cad",
        shortDesc: "Gain a +1 bonus on attack and damage rolls against any creature that has attacked you since the beginning of your last turn. This bonus increases by +1 for every five levels.",
        },
        {
        name: "Deadly Suprise",
        fromClass:"Cad",
        shortDesc: "When you hit an opponent that is denied its Dexterity bonus to AC against him with an attack, you may attempt a dirty trick combat maneuver as an immediate action as part of the attack.",
        },
        {
        name: "Treacherous Blow",
        fromClass:"Cad",
        shortDesc: "When you confirm a critical hit, you can attempt a dirty trick combat maneuver as part of that attack as an immediate action.",
        },
        {
        name: "Disarming Strike",
        fromClass:"Defender",
        shortDesc: "When you successfully disarm an opponent also deals normal damage to the target, but without the normal Strength bonus to damage.",
        },
        {
        name: "Rapid Attack",
        fromClass:"Dervish Of Dawn",
        shortDesc: "A dervish can combine a full attack with a single move. She must forgo the attack at her highest bonus but may take the remaining attacks at any point during her movement. This movement provokes attacks of opportunity as normal.",
        },
        {
        name: "Lightning Strike",
        fromClass:"Dervish of Dawn",
        shortDesc: "As part of a full attack, a dervish can make one additional attack. This attack is at the dervish's highest base attack bonus, but each attack in the round (including the extra one) takes a -2 penalty.",
        },
        {
        name: "Reversal",
        fromClass:"Free Hand Fighter",
        shortDesc: "A free hand fighter can make a disarm combat maneuver against a creature he threatens as an immediate action when he is the target of a melee attack from another creature. If successful, the attack changes to target the target of the free hand fighter's maneuver instead of the free hand fighter himself.",
        },
        {
        name: "Defenders Reflexes",
        fromClass:"High Guardian",
        shortDesc: "You gain Combat Reflexes as a bonus feat, and he can use your Strength modifier instead of his Dexterity modifier to determine the number of additional attacks of opportunity you can make per round. If you already has Combat Reflexes, you instead gains Stand Still as a bonus feat. If you had stand still, you instead gain a random martial feat.",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context, self)=>{
            self.addFeats(context)
        },
        addFeats:(context)=>{
            if(context.stats.lists.feats.filter(feat=> feat.name == "Combat Reflexes").length > 0){
                if(context.stats.lists.feats.filter(feat=> feat.name == "Stand Still").length > 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true}}))
                }else{
                    context.stats.lists.feats.push(feats.filter(feat => feat.name == "Stand Still")[0])
                }
            }else{
                context.stats.lists.feats.push(feats.filter(feat => feat.name == "Combat Reflexes")[0])
            }
        },
        },
        {
        name: "Precise Thrust",
        fromClass:"Learned Duelist",
        shortDesc: "When making an attack as an attack action, such as using vital strike, a Learned duelist adds his highest mental modifier to damage rolls (this bonus to damage is not multiplied on a critical hit). If the duelist confirms a critical hit while using this ability, he automatically deals maximum damage.",
        },
        {
        name: "Surgical Strike",
        fromClass:"Learned Duelist",
        shortDesc: "when a Learned duelist confirms a critical hit with a light or one-handed piercing or slashing weapon, he deals ability damage in addition to the normal bonus damage from the critical hit. The duelist chooses which ability is damaged, and deals an amount of damage equal to the critical multiplier of the wielded weapon.",
        },
        {
        name: "Leaping Attack",
        fromClass:"Mobile Fighter",
        shortDesc: "When a mobile fighter moves at least 5 feet prior to attacking, he gains a +1 bonus on attack and damage rolls. This bonus increases by +1 for every five levels. If you move at least 30 feet before attacking double the bonus.",
        },
        {
        name: "Whirlwind Blitz",
        fromClass:"Mobile Fighter",
        shortDesc: "A mobile fighter can make a full-attack action as a standard action. He may also use the Whirlwind Attack feat as a standard action, though you must still have the feat to use it with this perk.",
        },
        {
        name: "Mutagen",
        fromClass:"Mutagen Warrior",
        shortDesc: "You gain the ability to create and drink a mutagen for 8 spell points as a full round action which provokes attacks of opportunity, select one physical ability score—either Strength, Dexterity, or Constitution. Upon being imbibed, the mutagen causes the alchemist to grow bulkier and more bestial, granting him a +2 natural armor bonus and a +4 alchemical bonus to the selected ability score for the next 10 minutes. In addition, while the mutagen is in effect, the alchemist takes a -4 penalty to one of his mental ability scores. If the mutagen enhances his Strength, it applies a penalty to his Intelligence. If it enhances his Dexterity, it applies a penalty to his Wisdom. If it enhances his Constitution, it applies a penalty to his Charisma. \n\nWhen you reach level 12 The alchemist's mutagen now costs 14 spell points, but grants a +4 natural armor bonus, a +6 alchemical bonus to one physical ability score (Strength, Dexterity, or Constitution), and a +4 alchemical bonus to a second physical ability score. The alchemist takes a -4 penalty on both associated mental ability scores as long as the mutagen persists. \n\nWhen you reach level 20 The mutagen now costs 20 spell points, but grants a +6 natural armor bonus, a +8 alchemical bonus to one ability score (Strength, Dexterity, or Constitution), a +6 alchemical bonus to a second physical ability score, and a +4 alchemical bonus to a third physical ability score. The alchemist takes a -5 penalty to his Intelligence, Wisdom, and Charisma as long as the mutagen persists.",
        },
        {
        name: "Shielded Fortress",
        fromClass:"Phalanx Soldier",
        shortDesc: "A phalanx fighter's shield cannot be disarmed or sundered. He gains evasion (as a rogue) when using a shield (improved evasion when using a kite, tower or great shield). As a move action, a phalanx fighter can provide evasion to all adjacent allies until the beginning of his next turn. As an immediate action, he can provide improved evasion to an adjacent ally against one attack.",
        },
        {
        name: "Pole Fighting",
        fromClass:"Polearm Master",
        shortDesc: "As an immediate action, a polearm master can shorten the grip on his spear or polearm with reach and use it against adjacent targets. This action results in a -4 penalty on attack rolls with that weapon until he spends another immediate action to return to the normal grip. The penalty is reduced by -1 for every four levels. If you already have the ability to attack a creature adjacent to you with a reach weapon you instead gain +4 to the first attack you make against a creature while doing so. This bonus increases by 1 every 6 levels.",
        },
        {
        name: "Step Aside",
        fromClass:"Polearm Master",
        shortDesc: "When a creature threatened by a polearm master takes a 5-foot step into a square adjacent to him, he can take a 5-foot step as an immediate action. This 5-foot step must be subtracted from his movement on the next turn. He also gains a +2 dodge bonus to his AC against that opponent until the end of his next turn.",
        },
        {
        name: "Savage Charge",
        fromClass:"Savage Warrior",
        shortDesc: `When a savage warrior attacks with a natural weapon or unarmed attack at the end of a charge, he gains a bonus on his natural weapon and unarmed attack rolls equal to half his fighter level, while suffering a penalty to his AC equal to half his fighter level. These replace the normal attack roll bonus and AC penalty for charging. This bonus also applies to his CMB for a bull rush or overrun combat maneuvers made when charging. In addition, a savage warrior can charge through friendly creatures.
        \nIf selected a second time: when using savage charge, the AC penalty is reduced to 1/4 his fighter level instead of 1/2 his fighter level. In addition, a savage warrior can charge through difficult terrain.`,
        },
        {
        name: "Precision",
        fromClass:"Sensate",
        shortDesc: "A sensate rolls twice to confirm critical hits, taking the more favorable result. Opponents must roll twice to confirm critical hits against him, taking the less favorable result. The latter ability does not function when the sensate is denied his Dexterity bonus. If you are centered from the 'Centered Senses' ability, you can expend it, losing the centered condition, when confirming a critical hit to increase your critical multiplier by +1.",
        },
        {
        name: "Overhand Chop",
        fromClass:"Two Handed Fighter",
        abilityType:"Ex",
        shortDesc: "When a two-handed fighter makes a single attack (such with the attack action, charge or strike) with a two-handed weapon, he adds an additional 0.5x his Strength bonus on damage rolls. If you gain this perk a second time, you gain this bonus damage on all attacks with two-handed weapons.",
        },
        {
            name: "Piledriver",
            fromClass:"Two Handed Fighter",
            abilityType:"Ex",
            shortDesc: "As an attack action you can make a single melee attack with a two-handed weapon. If the attacks hits you make make a bull rush or trip combat maneuver against the target of your attack as a free action, which does not provoke attacks of opportunity.",
        },
        {
            name: "Defensive Flurry",
            fromClass:"Two-Weapon Fighter",
            abilityType:"Ex",
            shortDesc: "When you attack with both weapons, such as when making a full-round attack, you gain a +1 dodge bonus to AC against melee attacks until the beginning of your next turn. This bonus increases by +1 every 5 levels. If you make multiple actions that each count as two-weapon fighting, such as attacking with both weapons as an attack of opportunity, this dodge bonus stacks with itself, however you only gain 50% of the bonus you normally would (minimum 0).",
        },
        {
        name: "Greater Power Attack",
        fromClass:"Two Handed Fighter",
        shortDesc: "When using Power Attack with a two-handed melee weapon, increase damage by +1, with an additional +1 for every 4 of BAB.",
        },
        {
        name: "Devastating Blow",
        fromClass:"Two Handed Fighter",
        shortDesc: "As a standard action, a two-handed fighter may make a single melee attack with a two-handed weapon at a -5 penalty. If the attack hits, it is treated as a critical threat. Special weapon abilities that activate only on a critical hit do not activate if this critical hit is confirmed.",
        },
        {
        name: "Doublestrike",
        fromClass:"Two Weapon Warrior",
        shortDesc: "A two-weapon warrior may, as a standard action, make one attack with both his primary and secondary weapons. The penalties for attacking with two weapons apply normally.",
        },
        {
        name: "Equal Opportunity",
        fromClass:"Two Weapon Warrior",
        abilityType:"Ex",
        shortDesc: "When a two-weapon warrior makes an attack of opportunity, he may attack once with both his primary and secondary weapons. The penalties for attacking with two weapons apply normally.",
        },
        {
        name: "Deft Doublestrike",
        fromClass:"Two Weapon Warrior",
        abilityType:"Ex",
        shortDesc: "When a two-weapon warrior hits an opponent with both weapons as a during the same action, he can make a disarm or sunder attempt (or trip, if one or both weapons can be used to trip) against that opponent as an immediate action that does not provoke attacks of opportunity. If your weapons provide a bonus to one of those checks, you can apply both weapon's bonuses to this check.",
        },
        {
            name: "Clever Wrestler",
            fromClass:"Unarmed Fighter",
            abilityType:"Ex",
            shortDesc: "An unarmed fighter takes no penalties to Dexterity or on attack rolls while grappled, and retains his Dexterity bonus to AC while pinning an opponent. The unarmed fighter can make attacks of opportunity even when grappled and even against creatures attempting to grapple him if the opponent has the Improved Grapple feat or the grab ability.",
        },
        {
            name: "Trick Throw",
            fromClass:"Unarmed Fighter",
            abilityType:"Ex",
            shortDesc: "When an unarmed fighter successfully trips an opponent within his natural reach, he can attempt a dirty trick combat maneuver against that creature (before the opponent becomes prone) as an immediate action that does not provoke attacks of opportunity.",
        },
        {
            name: "Takedown",
            fromClass:"Unarmed Fighter",
            abilityType:"Ex",
            shortDesc: "If an unarmed fighter succeeds on a drag maneuver or initiates a grapple, he can attempt a trip maneuver against the same target as a swift action that does not provoke attacks of opportunity.",
        },
        {
            name: "Eye Gouge",
            fromClass:"Unarmed Fighter",
            abilityType:"Ex",
            shortDesc: "If you confirm a critical hit with an unarmed strike, or you begin your turn grappled, you may attempt a dirty trick maneuver to blind the target or grappling creature as a swift action, that does not provoke. Unless you have another way to make dirty trick manuevers without provoking, a creature more than 1 size larger than you is unaffected by this.",
        },
        {
            name: "Sucker Punch",
            fromClass:"Unarmed Fighter",
            abilityType:"Ex",
            shortDesc: "When an unarmed fighter strikes a creature that is denied its Dexterity bonus to AC, or that he has successfully pinned with a grapple check, he can attempt a dirty trick or trip combat maneuver against that target as a swift action.",
        },
        {
            name: "Sheer Toughness",
            fromClass:"Unarmed Fighter",
            abilityType:"Ex",
            shortDesc: "An unarmed fighter becomes immune to nonlethal damage and the exhausted, fatigued, and staggered conditions.",
        },
        {
            name: "Stalwart",
            fromClass:"Unbreakable",
            abilityType:"Ex",
            shortDesc: "When an unbreakable succeeds on a Fortitude or Will save against a spell or spell-like ability that has a partial effect even on a successful save, he is completely unaffected by it.",
        },
        {
            name: "Miraculous Recovery",
            fromClass:"Unbreakable",
            abilityType:"Ex",
            shortDesc: "When an unbreakable makes a saving throw to recover from an ongoing effect, he may roll twice and choose the better roll. This only affects rerolls granted by the original effect, not the reroll provided by the Akashic Paths",
        },
        {
            name: "Vengeance",
            fromClass:"Vengeful Hunter",
            abilityType:"Ex",
            shortDesc: "A vengeful hunter deals 1d4 points of bleed damage when he damages a creature that has damaged him since the beginning of his last turn. Whenever a creature takes bleed damage from this effect, it also takes a -1 penalty on attack rolls, weapon damage rolls, saving throws, skill checks, and ability checks for 1 round. This penalty is a pain effect and does not stack with the effects of the sickened condition. This bleed damage increases by 1d4 every 5 levels. You gain temporary hitpoints equal to half of the bleed damage dealt. These last 1 minute and do not stack with each other.",
        },
        {
            name: "Fearsome",
            fromClass:"Viking",
            abilityType:"Ex",
            shortDesc: "a viking can make an Intimidate check to demoralize an opponent as a move action. At 8th level, she can do so as a swift action. At 16th level, she can demoralize a foe as a free action once per round.",
        },
        {
            name: "Hammer to the Ground",
            fromClass:"Foehammer",
            abilityType:"Ex",
            shortDesc: "when a foehammer succeeds at a bull rush combat maneuver, he can make a trip combat maneuver at the end of the bull rush. If he does not move with the target, the force of his blow may still trip his foe, but he takes a -5 penalty on the combat maneuver check to trip. If you can gain this ability a second time, any foe you successfully bull rush becomes tripped at the end of the bull rush.",
        },
        {
            name: "Share Space",
            fromClass:"Swarm Fighter",
            abilityType:"Ex",
            shortDesc: "You can move into the space of another creature at least one size category larger than you. You may end your movement in, and make attacks from, that space. You must succeed at the Acrobatics check for moving through an occupied square to move into a space occupied by an enemy. While sharing the space of another creature, you gain a +2 shield bonus to AC and a +1 circumstance bonus on Reflex saves. Creatures you share the space with do not take any penalties for sharing it. Creatures you share a space with are denied their dexterity bonus to armor class against your attacks.",
        },
        {
            name: "Menacing Stance",
            fromClass:"Brawler Fighter",
            abilityType:"Ex",
            shortDesc: "While adjacent to you, enemies take a -1 penalty on attack rolls and a -4 penalty on concentration checks. These penalties increase by 1 for every 5 levels. Creatures do not take these penalties if you do not threaten them, are dazed, helpless, staggered, or stunned.",
        },
        {
            name: "No Escape",
            fromClass:"Brawler Fighter",
            abilityType:"Ex",
            shortDesc: "Creatures leaving a space adjacent to you with a 5-foot step or withdrawing still provokes an attack of opportunity from you.",
        },
        {
            name: "Chopping Blow",
            fromClass:"Buckler Duelist",
            abilityType:"Ex",
            shortDesc: "As an attack action, a buckler duelist can make a single melee attack with a one-handed weapon. If the attack hits, he may make a sunder combat maneuver against the target of his attack as a free action that does not provoke an attack of opportunity. If you could already make a sunder check without it provoking you gain an additional +2 to the check.",
        },
        {
            name: "Ultimate Payback",
            fromClass:"Cad",
            abilityType:"Ex",
            shortDesc: "Any critical threats a cad makes against an opponent that has attacked him since the beginning of his last turn are automatically confirmed. If the enemy confirmed a critical hit against him on that previous round, he increases his critical damage multiplier against the creature by +1 for his first critical hit on the turn. This stacks.",
        },
        {
        name: "Deadly Defense",
        fromClass:"Two Weapon Warrior",
        shortDesc: "When a two-weapon warrior makes a full-attack with two weapons, every creature that hits him with a melee attack before the beginning of his next turn provokes an attack of opportunity from the warrior.",
        },        
        {
        name: "Deadly Critical",
        fromClass:"Weapon Master",
        shortDesc: "When a weapon master confirms a critical hit he can increase the weapon's critical damage multiplier by +1 as a free action for level spell points. He can only use this ability twice per attack, plus 1 additional time every 8 levels he has. The price increases by your level for each time in a round you have used this ability.",
        },
        {
        name: "Unstoppable Strike",
        abilityType:"Ex",
        fromClass:"Weapon Master",
        shortDesc: "When you get this perk choose a specific weapon, a weapon master can take a standard action to make one attack with his chosen weapon as a touch attack that ignores damage reduction (or hardness, if attacking an object).",
        },
        {
        name: "Reliable Strike",
        abilityType:"Ex",
        fromClass:"Weapon Master",
        shortDesc: "A weapon master for level/2 spell points may reroll an attack roll, critical hit confirmation roll, miss chance check, or damage roll as a free action, but only once per turn. He must accept the second roll even if it is worse",
        },       
        {
        name: "Devastating Critical",
        abilityType:"Ex",
        shortDesc: "You increase the critical damage multiplier of any weapon you use by +1",
        },
]
export const roguePerks = [
    {
    type: "sneak talent",
    name: "Ambuscading Grapple",
    abilityType:"Ex",
    shortDesc: "When you succeed at a combat maneuver check to grapple an opponent who you would qualify for sneak attacka against, you can immediately deal sneak attack damage to the target. This counts as having hit with a sneak attack for the purpose of other abilities and talents.",
    },
    {
        type: "universal",
        name: "Assassin's Edge",
        abilityType:"Ex",
        shortDesc: "On the first round of combat, or for 1 round after a monster enters combat, you gain level/2 bonus as bonus to your sneak attack damage. Even if you dont have any sneak attack damage dice, you can still use this ability to deal sneak attack damage as long as you would qualify for it (attacking a flat-footed creature or a creature you flank.).",
    },
    {
    type: "sneak talent",
    name: "Surprise Spells",
    abilityType:"Ex",
    shortDesc: "An arcane trickster can add their sneak attack damage to any spell that deals damage if the targets are flat-footed. This additional damage only applies to spells that deal hit point damage, and the additional damage is of the same type as the spell. If the spell allows a saving throw to negate or halve the damage, it also negates or halves the sneak attack damage. This damage is only applied once per spell. In the case of fireball this means it affects all targets in the area, with each getting a save to halve the damage (including the sneak attack damage). In the case of magic missile, the extra damage is only added once to one missile, chosen by the caster when the spell is cast.",
    },
    {
    type: "sneak talent",
    name: "Ranged Flanking",
    abilityType:"Ex",
    shortDesc: "When attacking with ranged weapon from a distance of up to 30 feet, if the nearest adjacent space to your target is unoccupied and the opposite space is occupied by a threatening ally, you gain the bonuses of flanking.",
    },
    {
    type: "universal",
    name: "Sneak Attack Pro",
    abilityType:"Ex",
    shortDesc: "You gain 1d6 sneak attack damage. This increases by 1d6 every 5 levels.",
    },
    {
    type: "sneak talent",
    name: "Devastating Sneak Attack",
    abilityType:"Ex",
    shortDesc: "Increase the dice step of your sneak attack by 1 step. 1d6 becomes, 1d8, 1d8 becomes 1d10, 1d10 becomes 1d12, 1d12 becomes 2d8, and so on.",
    },
    {
    type: "universal",
    name: "Assassinate",
    abilityType:"Ex",
    shortDesc: "You can attempt to assassinate a target. To attempt to assassinate a target, you must first study a target for 1 round as a standard action. On the following round, if you make a sneak attack against the target and the target is denied its Dexterity bonus to AC, the sneak attack has the additional effect of possibly killing the target. This attempt automatically fails if the creature is aware of you as an enemy. If the sneak attack is successful and the target of this attack fails a Fortitude save, it dies. The DC of this save is equal to 10 + 1/2 level + highest mental mod. If the save is successful, the target still takes the sneak attack damage as normal, but becomes immune to your assassinate attempts.",
    },
    {
    type: "universal",
    name: "Fatal Opening",
    abilityType:"Ex",
    sphere:"fencing",
    shortDesc: "Whenever you attack a target that has lost its Dexterity bonus to its armor class due to your successful feint, your critical threat range for that attack is doubled. If you're critical threat range is already being doubled you gain a flat +1 to critical threat range that isn't doubled.",
    },
    {
    type: "universal",
    name: "Feint Strike",
    abilityType:"Ex",
    sphere:"fencing",
    shortDesc: "Whenever you succeed at a feint against a creature, you may make a single attack against them with any weapon you are wielding as a swift action. If you can feint as a swift or immediate action, this attack is made as apart of that action.",
    },
    {
        type: "sneak talent",
        fromClass:"Unchained Rogue",
        name: "Debilitating Bewilderment*",
        abilityType:"Ex",
        shortDesc: "Whenever you deal sneak attack damage to a foe you can also cause them to become bewildered for 1 round. A bewildered foe takes a -2 penalty to AC, and an additional -2 penalty to AC against all attacks made by you. At 10th level and 16th level, the penalty to AC against attacks made by you increases by -1 (to a total maximum of -4). These penalties do not stack with themselves.",
        additionalInfoTags:["Sneak Attack Talent"],
    },
    {
        type: "sneak talent",
        fromClass:"Unchained Rogue",
        name: "Debilitating Disorientation*",
        abilityType:"Ex",
        shortDesc: "Whenever you deal sneak attack damage to a foe you can also cause them to become disorientated for 1 round. A disorientated foe takes a -2 penalty on attack rolls. In addition, the target takes an additional -2 penalty on all attack rolls it makes against you. At 10th level and 16th level, the penalty on attack rolls made against you increases by -2 (to a total maximum of -4). These penalties do not stack with themselves.",
        additionalInfoTags:["Sneak Attack Talent"],
    },
    {
        type: "sneak talent",
        fromClass:"Unchained Rogue",
        name: "Debilitating Hampering*",
        abilityType:"Ex",
        shortDesc: "Whenever you deal sneak attack damage to a foe you can also cause them to become hampered for 1 round. A hampered foe's movement speeds are reduced by half (to a minimum of 5 feet). In addition, the target cannot take a 5-foot step. These penalties do not stack with themselves.",
        additionalInfoTags:["Sneak Attack Talent"],
    },

    {
    type: "universal",
    name: "Focusing Feint",
    abilityType:"Ex",
    sphere:"fencing",
    shortDesc: "Whenever you succeed at a feint against a creature, you may regain BAB/2 spell points as a swift action.",
    },
    {
    type: "universal",
    name: "See the Unseen",
    abilityType:"Su",
    shortDesc: "As a swift action you can spend 2 spell points to cast see invisibility. At Level 12 you can spend 18 spell points to instead use this to cast true seeing on yourself.",
    },
    {
    type: "universal",
    name: "Ki Venom",
    abilityType:"Ex",
    shortDesc: "As a full-round action you can spend 5 spell points to create and apply a poison to one of your weapons. The poison can deal 1d4 strength, dexterity, intelligence, wisdom, or charisma damage, creators choice. Additionally you can spend 4 spell points to increase the damage done by once dice step (max 1d8), or 6 to increase the number of saves required to cure (max 3 saves). Poison: injury; fort dc=10+level/2 + highest mental; frequency 1/round for rounds equal to highest mental stat; deal 1d4 ability damage; cure 1 save. If you select this perk multiple times the poisons base damage and the amount of times you can spend spell points to increase its damage are increased by 1 dice step.",
    },
    {
        type: "universal",
        name: "Master Poisoner",
        abilityType:"Ex",
        shortDesc: "The action required to apply a poison to a weapon, such as with Ki Venom, or a vishkanya's spit poison, or when applying blanches to weapons, both decrease by 1 step. Alternatively you can apply then two multiple wielded weapons at the same time, and draw two blanches with the same action. Poison Vials have their action to apply reduced 2 steps. The DC of your poisons increases by +4, or your second highest mental stat, whichever you prefer.",
    },
    {
    type: "universal",
    name: "Kawarimi",
    abilityType:"Su",
    shortDesc: "When a creature makes a successful attack against a ninja, as an immediate action you can spend 4 spell points to make a stealth check opposed by the attackers perception check. If the ninjas check is higher the attack hits an inanimate object the attacker mistook for the ninja, and the ninja may move into an adjacent square and becomes hidden from the attacker until the start of ninja's next turn. If you attack the creature on your next turn, your next attack them the target is flat-footed. You can only use this ability a single time against any specific creature.",
    },
    {
        type: "universal",
        name: "Arcane Backfire",
        abilityType:"Su",
        shortDesc: "Once per round when you attack a creature that has an active spell effect on it that it or an ally created, you can attempt a spellcraft check (dc=10+caster level + spell level) to attempt to overload the spell. If you succeed the attack deals additional damage equal to the level of the spell, and it becomes inactive for 1 round.",
    },
    {
        type: "universal",
        name: "Herbal Compound",
        abilityType:"Ex",
        shortDesc: `As a movement action you can spend 5 spell points to create and and ingest a herbal compound. You can only have a single herbal compound active at a time, and they last rounds equal to your level. The herbal compound can have 1 of 3 effects:
        \n1: -2 AC and reflex saves, +4 alchemical bonus to will saves
        \n2: -2 will saves and attack rolls, +4 alchemical bonus to fortitude
        \n3: -2 fortitude saves and damage rolls, +6 alchemical bonus to reflex saves.`,
    },
    {
    type: "universal",
    name: "Misdirected Attack",
    abilityType:"Su",
    sphere:"scoundrel",
    shortDesc: "Whenever you provoke an attack of opportunity due to leaving a creature's threatened square, you gain a dodge bonus to your AC equal to 1/4 your ranks in Stealth (minimum 1). If an attack of opportunity provoked in this way misses you, you can expend an attack of opportunity to choose to redirect the attack to a creature within the attacker's reach (other than the attacker themselves), adding a bonus to the attack roll equal to the dodge bonus granted by this talent.",
    },
    {
    type: "universal",
    name: "Shadow Split",
    abilityType:"Su",
    shortDesc: "This trick allows the ninja to create an illusory double of herself that moves away from her, allowing the ninja to create a distraction. When she uses this ability, an illusory double appears and moves away from the ninja, heading in one direction. The double climbs walls, jumps pits, or simply passes through obstacles, moving at twice the ninja's speed in the direction indicated by the ninja when the ability is used. Its course cannot be changed. The double persists for 1 round per level of the ninja. Those who interact with the double receive a Will saving throw to recognize that it is fake. The DC of this save is 10 + 1/2 level + highest mental modifier. Each use of this ability uses up 2 spell points and is activated as a standard action.",
    },
    {
        type: "universal",
        name: "Card Sharp",
        abilityType:"Ex",
        shortDesc: "You have a deck of playing cards on hand, this counts as a thown weapon with a range of 10 feet, dealing 1d2 piercing damage, has a crit range of 19-20x2. You can hold these cards in your sleeves or other folds of clothing and allow you to withdraw them as a free actions, meaning you can throw as many on your turn as you have attacks. If you have quickdraw you can throw an additional card as apart of a full-round action.",
    },
    {
        type: "universal",
        name: "Escaping Stunt",
        abilityType:"Ex",
        shortDesc: "You can as an immediate action use an escape artist check in place of a reflex saving throw against any effect that would entangle you. Additionally when you are grappled, you can spend level spell points to attempt an escape artist check as an immediate action.",
    },
    {
        type: "sneak talent",
        name: "Obscuring Blow*",
        abilityType:"Ex",
        shortDesc: "For level spell points as a swift action when making an attack, the rogue can forgo their potential to deal sneak attack damage to attempt to cloud an opponent's vision. They must declare the use of obscuring blow before they makes the attack. If the attack hits, it does normal damage but, instead of dealing sneak attack damage (and any effect that triggers when the rogue deals sneak attack damage), the target treats all other creatures as if they had concealment, suffering a 20% miss chance on all attack rolls for a number of rounds equal to 1/2 level. A successful Fortitude saving throw reduces this effect to 1 round. The DC of this saving throw is equal to 10 + 1/2 level + highest mental.",
        additionalInfoTags:["Sneak Attack Talent"],   
    },
    {
        type: "universal",
        name: "Mien of Despair",
        abilityType:"Ex",
        shortDesc: "When a rogue with this talent successfully demoralizes an opponent using the Intimidate skill or performs a successful feint against an opponent, the opponent loses any morale bonuses and cannot benefit from any morale bonuses for 1d4+1 rounds.",
    },
    {
    name: "Dispatchment",
    fromClass:"Unchained Ninja",
    abilityType:"Ex",
    shortDesc: "Whenever a ninja attacks an opponent that would be denied a Dexterity bonus to AC or when she flanks her target, they gain a +2 bonus on their attack roll. Every 5 levels you have this bonus increases by +1",
    },        
    {
    name: "Unwitting Ally",
    fromClass:"rogue",
    abilityType:"Ex",
    shortDesc: "A rogue with this talent can spend a swift action to attempt to make an opponent act like an ally for purposes of providing a flank until the beginning of the rogue's next turn. The opponent must be able to hear and see the rogue, and the rogue must succeed at a Bluff or diplomacy check opposed by the opponent's Sense Motive. If the check succeeds, the opponent acts as an ally for the purpose of providing a flank. Whether or not the check succeeds, the rogue cannot use this trick again on the same opponent for the next 24 hours. If the rogue fails the check by 5 or more, she cannot use the unwitting ally ability on any opponent within line of sight of the failed attempt for 24 hours.",
    },
    {
    type: "sneak talent",
    name: "Armor Piercer*",
    abilityType:"Ex",
    shortDesc: "When you hit with an attack that deals sneak attack damage, you can forgo one or more sneak attack dice to reduce the target's natural armor bonus by that amount (minimum natural armor bonus of +0) until the end of your next turn. A creature cannot be affected by this ability again for 1 minute.",
    additionalInfoTags:["Sneak Attack Talent"],    
    },
    {
    type: "universal",
    name: "Ambush",
    abilityType:"Ex",
    shortDesc: "When you act during a surprise round you can take a move, standard and swift action, not just a move or standard.",
    },
    {
    type: "universal",
    name: "Slippery Mind",
    abilityType:"Ex",
    shortDesc: "When you are rerolling a will save against a mind-effecting effect that you have already failed the save for and has affected you, you can roll twice and take the higher result.",
    },
    {
    type: "sneak talent",
    name: "Sneak Stab",
    abilityType:"Ex",
    shortDesc: "Your sneak attack damage increases by 1 step with light melee weapons, and reduces by 1 step for all other weapons.",
    },
    {
    type: "universal",
    name: "Swinging Reposition",
    abilityType:"Ex",
    shortDesc: "If you are wearing light or no armor, you do not have to move in a straight line while making a charge attack or bull rush. Once you complete your attack or combat maneuver you can immediately move 5 feet as a free action, even if the charge ends your turn. This movement does not provoke attacks of opportunity.",
    },
    {
    type: "sneak talent",
    name: "Elemental Execution",
    abilityType:"Su",
    shortDesc: "You can treat creatures with the elemental subtype as though they were vulnerable to sneak attack, but you only deal half as much sneak attack damage as you normally would. You can confirm critical hits against such creatures as well, though only 50% of the time. If you gain this a second time it also applies to all outsiders who are normally immune to sneak attack and critical hits.",
    },
    {
    type: "universal",
    name: "Trap Finder",
    abilityType:"Ex",
    shortDesc: "You can add your level to your perception checks and disable device checks to disable traps",
    },
    {
    type: "universal",
    name: "Let Fate Decide",
    abilityType:"Ex",
    shortDesc: "For level/2 spell points You can declare two different actions that rely on two different types of rolls or checks, such as attacking a creature(attack roll) or rolling acrobatics to move away from the creature(an acrobatics check). As a standard action you roll a d2, a 1 being the first action, a 2 being the second, if you then perform that action before the end of your next turn you gain a luck bonus on the roll type required for that activity equal to your level for highest mental rounds. If you choose the other action you gain a negative to all d20 rolls equal to your highest mental stat for 1 minute.",
    },
    {
    type: "sneak talent",
    name: "Brutal Beating",
    abilityType:"Ex",
    shortDesc: "Whenever you deal sneak attack damage you can forgo 1d6 points of sneak attack damage to make the target sickened for rounds equal to half your level. This does not stack, but can refresh the duration.",
    },
    {
    type: "sneak talent",
    name: "Liquid Disruption",
    abilityType:"Ex",
    shortDesc: "She can deal sneak attack damage to oozes and creatures with the water subtype that are normally immune to precision damage (such as water elementals)",
    },
    {
    type: "sneak talent",
    name: "Precise Splash Weapons",
    abilityType:"Ex",
    shortDesc: "An underground chemist can deal sneak attack damage with splash weapons. The attack must be her first attack that round, qualify for dealing sneak attack damage (such as against a flat-footed target), and be directed at a creature rather than a square.",
    },
    {
    type: "universal",
    name: "Limb-Climber",
    abilityType:"Ex",
    shortDesc: `When adjacent to or in the space of a corporeal creature at least one size category larger than herself, you can climb that creature's body with a successful Climb check against a DC equal to the target creature's CMD. Although you are holding on to the creature, this action isn't a grapple; it doesn't provoke attacks of opportunity from the creature, and neither you or the creature you climb gains the grappled condition. While the you are on the climbed creature, the creature takes a penalty on attack rolls against you equal to half of your level, and you can flank the climbed creature with any ally adjacent to that creature. If you deal sneak attack damage to a creature you are climbing on you can add a bonus to that damage equal to half your level. The creature can roll a CMB check that provokes against you to remove you, if they succeed they can choose to either grapple you or knock you prone, and you are no longer climbing them.`,
    },
    {
    type: "universal",
    name: "Staggering Reflexes",
    abilityType:"Ex",
    shortDesc: `You gain a bonus on initiative checks equal to half your level (miniumum 1) if you act in a surprise round and are never flat-footed at the start of combat (even if you fail to act in the surprise round)`,
    },
    {
    type: "universal",
    name: "Sniper",
    abilityType:"Ex",
    shortDesc: "Reduce all range increment penalties by half, and increase the range in which you can deal sneak attack by 10 feet +10 feet for every 3 levels.",
    },
    {
    type: "universal",
    name: "Combat Advisor",
    abilityType:"Ex",
    shortDesc: "Whenever you miss with a melee attack against an opponent you can designate 1 ally with 30 feet of the target to receive a +1 insight bonus on their next attack againt that opponent before your next turn. This bonus increases by 1 every 4 levels you have.",
    },
    {
    type: "sneak talent",
    name: "Scout's Charge",
    abilityType:"Ex",
    shortDesc: `Whenever you make a charge, you deal sneak attack damage as if the target were flat-footed. Foes with uncanny dodge are immune to any of the effects of this ability, including its higher level versions.
    \nIf you select this ability a second time whenever you move at least 10 feet in a round and make an attack the attack deals sneak attack as if the target were flat-footed. If you make more than one attack this turn it applies only to the first attack.
    \nIf you select this ability a third time whenever you move 10 feet in a round apply sneak attack damage to all attacks as if this target were flat-footed.`,
    },        
    {
    type: "universal",
    name: "Assault Leader",
    shortDesc: "When you miss an attack against an enemy you are flanking, for level x2 spell points you can choose any ally that is also flanking the creature, and they can make a melee attack as an immediate action.",
    },
    {
        type: "universal",
        name: "Sudden Disguise",
        shortDesc: "You can spend a swift action and 2 spell points to use the disguise self spell as a swift action.",
    },
    {
        type: "universal",
        name: "Black Market Connections",
        shortDesc: "Once per floor, you can reduce the price of buying an item by 25%.",
    },
    {
    type: "sneak talent",
    name: "Befuddling Strike*",
    shortDesc: "When the rogue deals sneak attack damage against an opponent, that opponent takes a -2 penalty on attack rolls against the rogue for 1d4 rounds.",
    additionalInfoTags:["Sneak Attack Talent"],
    },
    {
    type: "sneak talent",
    name: "Bleeding Attack*",
    shortDesc: "Cause opponents damaged by your sneak attack to bleed for 1 point per sneak attack dice on the start of each of its turns. it can be healed with a dc 15 heal check or any magical healing. this doesn't stack with itself",
    additionalInfoTags:["Sneak Attack Talent"],
    },
    {
        type: "sneak talent",
        name: "Ki Block*",
        shortDesc: `Your sneak attack stops a creature from accessing their inner energies. They must make a will save (dc=10+level/2+highest mental) or be unable to spend ki, grit, panache, the DC's of their spells, maneuvers, and supernatural abilities are lowered by -4. This lasts rounds equal to your sneak attack dice and does not stack, though the duration does refesh.`,
        additionalInfoTags:["Sneak Attack Talent"],
    },
    {
    type: "universal",
    name: "Castling",
    abilityType:"Ex",
    shortDesc: "You treat soft cover granted by creatures of your size or larger as though it were cover instead.",
    },
    {
        type: "universal",
        name: "Cloying Shades",
        abilityType:"Su",
        shortDesc: "Whenever you teleport willingly, all creatures adjacent to you at the start and end of your teleportation are entangled by grasping shadows for 1 round (although the creatures are not anchored in place). A successful Reflex saving throw negates this effect. The DC of this saving throw is equal to 10 + 1/2 level + highest mental mod.",
    },
    {
    type: "sneak talent",
    name: "Distracting Attack*",
    shortDesc: "Cause an enemy hit by your sneak attack to become flat-footed, by forgoing the additional damage from sneak attack. choose one target the creature becomes flat-footed against until the beginning of your next turn. The rogue cannot designate themself as the creature gaining the benefit of this talent",
    additionalInfoTags:["Sneak Attack Talent"],    
    },
    {
    type: "universal",
    name: "Eerie Disappearance",
    abilityType:"Ex",
    shortDesc: "As a full-round action, the rogue can move up to her speed. If she successfully reaches a location that offers her cover or concealment, any creature observing her must attempt a Perception check opposed by the rogue's Stealth check. On a failed check, the observer loses track of the rogue and fails to note where she moved to. The rogue does not take a penalty on this Stealth check for moving up to her speed.",
    },
    {
    type: "universal",
    name: "Eldritch Conduit",
    abilityType:"Su",
    shortDesc: "You can use two potions, two wands, or two scrolls as a full-round action, this includes the action for drawing such items, but this provokes 2 attacks of opportunity.",
    },
    {
        type: "universal",
        name: "Overextending Feint",
        abilityType:"Ex",
        shortDesc: "When you feint a creature, instead of causing them become flat-footed, you cause them to overextend themselves, until the start of your next turn they take a -2 penalty to all attacks, and the next attack provokes attacks of opportunity. For every 5 you beat the DC of the feint, the penalty to attack increases by -1.",
    },
    {
        type: "universal",
        name: "Nimble Dodge",
        abilityType:"Ex",
        shortDesc: "As an immediate action in response to an attack against you, but before it is rolled, you gain a dodge bonus to your armor class equal to 2 + highest mental stat. If the attack hits you anyway, the damage is reduced by half.",
    },
    {
        type: "universal",
        name: "Clever Gambit",
        abilityType:"Ex",
        fromClass:"rogue",
        shortDesc: "You do not provoke attacks of opportunity for leaving a square threaten by a creature you have personally successfully identified with a knowledge check (dc=20+HD).",
    },
    {
        type: "universal",
        name: "Unbalancing Blow",
        abilityType:"Ex",
        shortDesc: "When you successfully confirm a critical hit against an enemy, they are flat-footed against your attacks until the end of your turn.",
    },
    {
        type: "universal",
        name: "Underhanded Teamwork",
        abilityType:"Ex",
        shortDesc: "When you or an ally uses an action that causes an enemy to provoke attacks of opportunity from allies, such as the greater trip feat, the allies gain a +2 bonus to attack and damage on such attacks. This doesn't apply to the ally that used the action if they would also get an attack of opportunity.",
    },
    {
        type: "sneak talent",
        name: "Harder They Fall",
        abilityType:"Ex",
        shortDesc: "When you successfully trip a foe you deal your sneak attack damage.",
    },
    {
    type: "sneak talent",
    name: "Emboldening Strike*",
    abilityType:"Ex",
    shortDesc: "When you hit a creature with a melee attack and deal sneak attack damage, you gain a +1 circumstance bonus on saving throws for every 2 sneak attack dice rolled (minimum +1) for 1 round.",
    additionalInfoTags:["Sneak Attack Talent"],
    },
    {
    type: "universal",
    name: "Expert Acrobat",
    shortDesc: "When making jump checks, you are always considered to have a running start, you gain a +4 bonus when making acrobatics checks to move through threatened space, and a +8 when moving through a foes space. Also, when you deliberately fall, you take half fall damage.",
    },
    {
    type: "sneak talent",
    name: "Fast Getaway",
    shortDesc: "After successfully making a sneak attack you can spend a move action to take the withdraw action. You can move no more than your speed during this movement. At the end of the movement if you have cover you can make a stealth check without having to reduce your speed, however you gain a -10 penalty to the check.",
    },
    {
    type: "universal",
    name: "Feint from Shadows",
    abilityType:"Ex",
    shortDesc: "You can feint against a foe within 30 feet that you have concealment (but not full concealment) from, using a ranged weapon and cause the opponent to lose his Dexterity modifier against your next melee or ranged attack.",
    },
    {
    type: "universal",
    name: "Fortified Position",
    abilityType:"Ex",
    shortDesc: "Increase the bonus you gain to reflex saves and armor class from cover by 50%. You also gain a bonus to your fortitude saves equal to the reflex saves you would gain from cover before it was modified by this ability.",
    },
    {
    type: "sneak talent",
    name: "Shadow Strike",
    abilityType:"Ex",
    shortDesc: "You can deal sneak attack damage to creatures that have concealment but not total concealment. If you gain this perk a second time you can deal sneak attack damage to creatures with total concealment",
    },
    {
    type: "universal",
    name: "Got Your Back",
    abilityType:"Ex",
    shortDesc: "Once per round as an immediate action, you may expend an attack of opportunity to attempt an aid another check to improve an ally's attack. You and your ally must both be flanking the same opponent. This counts as an attack of opportunity.",
    },
    {
    type: "sneak talent",
    name: "Offensive Defense*",
    shortDesc: "When a rogue with this talent hits a creature with a melee attack that deals sneak attack damage, the rogue gains a +1 dodge bonus to AC for each sneak attack die rolled for one round. The dodge bonus only applies against the creature you sneak attacked, and the dodge bonus does not stack with itself.",
    additionalInfoTags:["Sneak Attack Talent"],
    },
    {
    type: "universal",
    name: "Peerless Maneuver",
    shortDesc: "For level/2 spell points a rogue with this talent can roll two dice while making an Acrobatics check, and take the better result. She must choose to use this talent before making the Acrobatics check",
    },
    {
    type: "universal",
    name: "Pierce the Darkness",
    abilityType:"Ex",
    shortDesc: "Gain blindsense out to a range of 5 feet. She still suffers the normal miss chance for attacking creatures with concealment",
    },
    {
    type: "universal",
    name: "Positioning Attack",
    shortDesc: "For level x2 spell points, when a rogue with this talent hits a creature with a melee attack, she can move up to 30 feet without provoking attacks of opportunity. The movement must end in a space adjacent to the creature hit with the melee attack.",
    },
    {
    type: "sneak talent",
    name: "Powerful Sneak*",
    shortDesc: "Treat all 1s on sneak attack damage dice as 2s",
    additionalInfoTags:["Sneak Attack Talent"],
    },
    {
    type: "universal",
    name: "Resiliency",
    shortDesc: "For level spell points but never 2 rounds in a row a rogue with this ability can gain a number of temporary hit points equal to the rogue's level. Activating this ability is an immediate action that can only be performed when she is brought to below 0 hit points. This ability can be used to prevent her from dying. These temporary hit points last for 1 minute. If the rogue's hit points drop below 0 due to the loss of these temporary hit points, she falls unconscious and is dying as normal.",
    },
    {
    type: "universal",
    name: "Rogue Crawl",
    shortDesc: "Move at half speed while prone, A rogue with this talent can take a 5-foot step while crawling.",
    },
    {
    type: "universal",
    name: "Sacrifice Self",
    shortDesc: "Provide an adjacent ally the benefits of evasion instead of yourself, essentially halving the damage that ally would normally take. If you also have improved evasion you can attempt a secondary save against the ally's dmg. If successful, neither takes any damage. If you don't have evasion, or would just rather this benefit you can instead reduce your reflex save by up to your level to increase theirs by that amount.",
    },
    {
    type: "sneak talent",
    name: "Set-Up",
    abilityType:"Ex",
    shortDesc: "When you successfully hit a target with a sneak attack in melee, you can choose to forgo your additional sneak attack damage to make the target more vulnerable to one of your allies adjacent to it. The first melee attack that ally makes against the target before the beginning of your next turn treats the target as flanked, even if your ally is not flanking the target. This has no effect on creatures you could not flank with that ally, even if the ally was properly positioned.",
    },
    {
    type: "universal",
    name: "Shadow Duplicate",
    abilityType:"Sp",
    shortDesc: "For 2 spell points as an immediate action when the rogue is hit, the rogue can create a single shadow duplicate of herself, as per mirror image. The GM randomly determines whether the attack hit the rogue or the shadow duplicate. The shadow duplicate lasts for a number of rounds equal to the rogue's level, or until the shadow duplicate is dispelled or destroyed. This ability can stack with the mirror image spell or itself. The caster level for this ability is equal to the rogue's level.",
    },
    {
    type: "universal",
    name: "Shove Aside",
    abilityType:"Ex",
    shortDesc: "When you and an adjacent ally are both in the area of an attack that requires a saving throw, you can take a -4 penalty on your saving throw to grant your ally a +4 bonus on his saving throw. You lose the evasion ability against this attack. If you have improved evasion, it is reduced to evasion for this attack instead. ",
    },
    {
    type: "sneak talent",
    name: "Silencing Strike*",
    abilityType:"Su",
    shortDesc: "When a creature is damaged by your sneak attack you can spend level/2 spell points to magically renders the creature mute for 1 round unless it succeeds at a Will save (DC = 10 + 1/2 level + highest mental modifier).",
    additionalInfoTags:["Sneak Attack Talent"],
    },
    {
    type: "sneak talent",
    name: "Slow Reactions*",
    shortDesc: "Opponents damaged by your sneak attack may not make attacks of opportunity for 1 round.",
    additionalInfoTags:["Sneak Attack Talent"],
    },
    {
    type: "sneak talent",
    name: "Sneaky Maneuver*",
    shortDesc: "Anytime you hit an opponent with a melee sneak attack on your turn, you may take a -2 attack penalty to the attack and choose not to deal sneak attack damage, if you do and the attack succeeds you deal weapon damage as normal and then attempt a dirty trick, disarm, steal, sunder, or trip combat maneuver as a swift action. This still provokes as normal.",
    additionalInfoTags:["Sneak Attack Talent"],
    },        
    {
    type: "universal",
    name: "Stand Up",
    shortDesc: "Stand up from a prone position as a free action, this still provokes attacks of opportunity",
    },
    {
        type: "universal",
        name: "Superior Sniper",
        shortDesc: "Gain Expert Sniper and master sniper as a bonus feats. If you have one of these feats they will be upgraded to grandmaster sniper or as bonuses to stealth checks while sniping.",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            for(let x = 0; x < 2; x++){
                if(context.stats.lists.feats.filter(feat => feat.name == "Expert Sniper")){
                    if(context.stats.lists.feats.filter(feat => feat.name == "Master Sniper")){
                        if(context.stats.lists.feats.filter(feat => feat.name == "Expert Sniper")){
                            let sniperExpert = {name: "Sniper Expert", type: "martial", uiType: "feat",longDesc: "You reduce the penalty on your Stealth checks to stay hidden while sniping by an additional 5."}
                            context.stats.lists.feats.push(sniperExpert)
                        }else{
                            context.stats.lists.feats.push(feats.filter(feat => feat.name == "Grandmaster Sniper")[0])
                        }                        
                    }else{
                        context.stats.lists.feats.push(feats.filter(feat => feat.name == "Master Sniper")[0])
                    }
                }else{
                    context.stats.lists.feats.push(feats.filter(feat => feat.name == "Expert Sniper")[0])
                }
            }                   
        },
    },
    {
        type:"universal",
        name: "Evasion",
        abilityType:"Ex",
        shortDesc: "If you make a successful Reflex saving throw against an attack that normally deals half damage on a successful save, you instead take no damage. Evasion can be used only if you are wearing light or no armor, and you are not helpless. Gaining This perk additional times will grant the improved versions.",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let evasions = context.stats.lists.perks.filter(perk => perk.name == "Evasion")       
            if(evasions.length > 1){
                let evasions = context.stats.lists.perks.filter(perk => perk.name == "Improved Evasion")  
                if(evasions.length > 0){
                    evasions = context.stats.lists.perks.filter(perk => perk.name == "Greater Evasion")  
                    if(evasions.length > 0) context.stats.characterStats.misc.reflex += 4
                    let evasion = perks.filter(perk => perk.name == "Greater Evasion")[0]
                    evasions = context.stats.lists.perks.filter(perk => perk.name == "Evasion")
                    let specific = evasions[evasions.length-1]
                    specific.name = "Greater Evasion"
                    specific.shortDesc = evasion.shortDesc
                }
                else{
                    let evasion = perks.filter(perk => perk.name == "Improved Evasion")[0]
                    let evasions = context.stats.lists.perks.filter(perk => perk.name == "Evasion")
                    let specific = evasions[evasions.length-1]
                    specific.name = "Improved Evasion"
                    specific.shortDesc = evasion.shortDesc
                }
            }
        },
    },
    {
        type: "universal",
        name: "Improved Evasion",            
        shortDesc: "When making a reflex saving throw to avoid damage, you take half damage even if you fail the saving throw, and none of you succeed on the saving throw. You must not be helpess or wearing armor heavier than light to use this ability. Having this ability additional times instead will grant greater evasion.",
        prereq:"Evasion",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let evasions = context.stats.lists.perks.filter(perk => perk.name == "Improved Evasion")  
            if(evasions.length > 1){
                evasions = context.stats.lists.perks.filter(perk => perk.name == "Greater Evasion")  
                if(evasions.length > 0){
                    context.stats.characterStats.misc.reflex += 4
                }
                let evasion = perks.filter(perk => perk.name == "Greater Evasion")[0]
                evasions = context.stats.lists.perks.filter(perk => perk.name == "Improved Evasion")
                let specific = evasions[evasions.length-1]
                specific.name = "Greater Evasion"
                specific.shortDesc = evasion.shortDesc
            }
        },
    },
    {
        type: "universal",
        name: "Greater Evasion",            
        shortDesc: "When making a reflex save to avoid damage while wearing medium or heavier armor, if you pass the DC you take half damage, if you beat the DC by more than your armor check penalty, you take no damage. Having this ability additional times instead will grant a +4 to reflex saving throws.",
        prereq:"Improved Evasion",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let evasionCount = context.stats.lists.perks.filter(perk => perk.name == "Greater Evasion")            
            if(evasionCount.length > 1){
                context.stats.characterStats.misc.reflex += 4
            }
        },
    },
    {
    type: "universal",
    name: "Without a Trace",
    abilityType:"Ex",
    shortDesc: "When the rogue successfully uses evasion or improved evasion to avoid taking damage, she can attempt to hide as an immediate action. The rogue attempts a Stealth check with a -20 penalty, but gains a +1 bonus on her check for every die of damage the avoided attack would have dealt. The rogue can attempt this check even while being observed, as long as she has cover or concealment or an ability that allows her to use the Stealth skill while being observed without cover or concealment.",
    },
    {
    type: "universal",
    name: "Dance of Disorienting Shadows",
    abilityType:"Ex",
    shortDesc: "A rogue with this talent can attempt a Perform check in place of a combat maneuver check when attempting a reposition or trip combat maneuver.",
    },
    {
    type: "universal",
    name: "Acceleration of Form",
    shortDesc: "As a standard action you can spend level/2 spell points to gain the benefits of the displacement and haste spells for 1 round per 2 levels.",
    },
    {
    type: "universal",
    name: "Acrobatic Master",
    shortDesc: "Expend 2 spell points as an immediate action to gain +20 bonus on one Acrobatics check",
    },
    {
        type: "universal",
        name: "Covering Assist",
        shortDesc: "You can expend an attack of opportunity to attempt an aid another action when an ally is either attempting to make an acrobatics check so long as at some point during the check they are adjacent or in your space, or when an ally within your reach provokes an attack of opportunity within your reach.",
    },
    {
    type: "universal",
    name: "Blood Debt",
    shortDesc: "A ninja with this ability gains In Harm's Way as a bonus feat, even if she doesn't meet the prerequisites. When the ninja intercepts an attack using this feat, she can spend 1 ki point to impose a blood debt on the aided ally. The ninja's ki pool is reduced by 1 until she ends this effect, which she may do as an immediate action. If the ninja ends the blood debt in response to a successful attack against her by a creature the indebted ally threatens, the ally (who must be willing) takes full damage from that attack and any associated effects instead of the ninja.",
    hasCustomMethod:true,
    customMethod:()=>{
    },
    catchUpMethod:(context)=>{
        context.stats.lists.feats.push(feats.filter(feat => feat.name == "In Harm's Way")[0])
    },
    },
    {
    type: "sneak talent",
    name: "Deadly Range",
    shortDesc: "Increase range of dealing sneak attack damage by 15 feet.",
    },
    {
    type: "universal",
    name: "Fast Stealth",
    shortDesc: "Move at full speed using the Stealth skill without penalty.",
    },
    {
    type: "universal",
    name: "Feather Fall",
    shortDesc: "Expend 2 spell points as a free action you can take even when not your turn to cast the Feather fall spell.",
    },
    {
    type: "universal",
    name: "Flurry of Stars",
    shortDesc: "When making a full-round attack with throwing weapons, you can use a swift action and spend 4 spell points to make two additional thrown weapon attacks. These additional attacks are made at your highest attack bonus, but all attacks during the round including these additional attacks takes a -2 penalty.",
    },
    {
    type: "universal",
    name: "High Jumper",
    shortDesc: "When you make a high jump, you can jump heights as if it was a long jump.",
    },
    {
    type: "universal",
    name: "Kamikaze",
    shortDesc: "Expend level spell points to give unarmed strikes and weapons the vicious weapon special ability for 1 round per level. The ninja can spend level/2 spell point to dismiss this effect.",
    },
    {
    type: "universal",
    name: "Ki Charge",
    shortDesc: "A ninja with this trick can invest a portion of her ki into a single thrown weapon, such as a shuriken, and throw it as a standard action. The thrown weapon explodes on impact in a 5-foot burst, dealing 1d6 points of fire damage +1d6 every odd level after first. Creatures caught in the blast receive a Reflex save to halve the damage. The DC of this save is 10 + 1/2 level + highest mental. If the thrown weapon hits a creature, that creature takes a -2 penalty on the saving throw. If the thrown weapon misses, treat it as a thrown splash weapon. Using this ability expends 2 spell points",
    },
    {
    type: "sneak talent",
    name: "Pressure Points*",
    shortDesc: "A ninja with this trick can strike at an opponent's vital pressure points, causing weakness and intense pain. Whenever the ninja deals sneak attack damage, she also deals 1 point of Strength or Dexterity damage, decided by the ninja. Unlike normal ability damage, this damage can be healed by a DC 15 Heal check. Each successful check heals 1 point of damage caused by this trick.",
    additionalInfoTags:["Sneak Attack Talent"],
    },
    {
    type: "universal",
    name: "Redirect Force Maneuver",
    shortDesc: "If the ninja has a feat that allows her to attempt a combat maneuver without provoking attacks of opportunity, she can choose to provoke them anyway when she performs that maneuver. If she does so and takes damage from the attack of opportunity, the ninja adds the damage as a bonus on her attack roll instead of as a penalty.",
    },
    {
        type: "universal",
        name: "Breath of the Ancestors",
        abilityType:"Su",
        shortDesc: "When you select this perk choose a damage type (piercing, fire, electricity, sonic) and range (30 foot line, 15 foot cone). As a standard action you can expend level spell points to exhale a breath weapon that deals 1d6 damage of the chosen element, increasing by 1d6 every odd level after, and also increasing by any sneak attack damage you can deal. Creatures caught in it may make a reflex saving throw to reduce the damage by half (dc=10+ level/2 + highest mental). Once used you cannot use this ability for 1d4 rounds. If you have an ability that you can use to augment smoke bombs, such as choking bomgs or poison bombs, you can add them to this effect.",
    },
    {
        type: "sneak talent",
        name: "Swarming Attack",
        shortDesc: "You are able to share a space with an ally your size or smaller without squeezing or otherwise being hampered. You grant an ally who's square you share a bonus on their damage rolls equal to your sneak attack dice. If you are also a ratfolk you also gain this bonus damage on attacks.",
    },
    {
        type: "universal",
        name: "Shadow Clone Jutsu",
        shortDesc: "Expend 5 spell points as a standard action to create 1d4 mirror images of yourself. These mirror images function the same as the mirror image spell, however they are also semi-tangible. When you are making a full round attack, these shadow clones will attack with you. They make attacks at your highest bonus -5, and the first time each turn a shadow clone strikes a creature the creature makes a will saving throw (DC=10+leve/2 + highest mental) to disbelieve them, if they succeed they only deal 20% damage, otherwise they deal 50% damage. These attacks gain no bonuses from augmented attacks such as boosts, strikes, or vital strikes.",
    },        
    {
        type: "universal",
        name: "Shadow Clone Ultimate Jutsu",
        shortDesc: "Expend 5 additional spell points when using shadow clone jutsu to turn it into ultimate jutsu. When you activate it you summon 1d4 + 1 shadow per 6 levels instead, and these shadow clones are able to move away from you your square, each having a movement speed equal to your own, acting on your turn. They are able to return to your square to continue acting as mirror images. Additionally, they can make their attacks whether you are making an attack as single attack or full-round attack on your turn, each able to attack anything within their reach as normal, though they can only attack once a round. Their attacks otherwise act the same as normal Shadow Clone Jutsu. These clones have no ability to interact with physical things otherwise. You can only have a single activation of Shadow Clone Justsu or Ultimate jutsu active at once.",
        prereq:"Shadow Clone Jutsu"
    },
    {
        type: "universal",
        name: "Shadow Clone Combined Attack",
        shortDesc: "If you have shadow clones active from Shadow Clone Jutsu or Ultimate Jutsu, you can expend them when making an attack to increase the damage of the attack by 20% per clone expended, or increase the DC of a maneuver by +2, or spell by +1.",
        prereq:"Shadow Clone Jutsu"
    },
    {
    type: "universal",
    name: "Smoke Bomb",
    shortDesc: "Expend 2 spell points as a standard action to throw bomb creating 15′ radius smoke cloud as if using a smoke stick. You can throw as a ranged touch attack with a range increment of 20 feet.",
    },
    {
        type: "universal",
        name: "Choking Bomb",
        shortDesc: "When throwing a smoke bomb, you can increase the cost by 4 spell points to turn it into a choking bomb. All living creatures inside the smoke bombs radius when it is thrown must make a fortitude save dc 10+level/2+highest mental stat or be staggered for 1d4 rounds. This is a poison effect.",
        prereq:"Smoke Bomb"
    },
    {
        type: "universal",
        name: "Poison Bomb",
        shortDesc: "When throwing a smoke bomb, you can increase the cost by 5 spell points to turn it into a poison bomb. All living creatures inside the smoke bombs radius when it is thrown must make a fortitude save dc 10+level/2+highest mental stat or become poisoned for 4 rounds (allowing a new save each turn as normal). The poison deals a damage of choice, 1d2 constitution, 1d4 dexterity, 1d3 strength. This is a poison effect.",
        prereq:"Smoke Bomb"
    },
    {
        type: "universal",
        name: "Blinding Bomb",
        shortDesc: "When throwing a smoke bomb, you can increase the cost by 4 spell points to turn it into a blinding bomb. All living creatures inside the smoke bombs radius when it is thrown must make a fortitude save dc 10+level/2+highest mental stat or become blinded for 1d4 rounds.",
        prereq:"Smoke Bomb"
    },

    {
    type: "universal",
    name: "Catch Arrows",
    shortDesc: "Gain the Deflect Arrows and Snatch Arrows feats",
    hasCustomMethod:true,
    customMethod:()=>{
    },
    catchUpMethod:(context)=>{
        let feat = feats.filter(feat => feat.name == "Deflect Arrows")[0]
        context.stats.lists.feats.push(feat)
        let feat2 = feats.filter(feat => feat.name == "Snatch Arrows")[0]
        context.stats.lists.feats.push(feat2)
    },
    },
    {
        type: "universal",
        name: "Vanishing Trick",
        shortDesc: "As a swift action, the ninja can disappear for 1 round per level. This ability functions as invisibility. Using this ability uses up 2 spell points. If you gain this a second time it becomes the Invisible Blade rogue perk.",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let vanishCount = context.stats.lists.perks.filter(perk => perk.name == "Vanishing Trick")            
            if(vanishCount.length > 1){
                let index = context.stats.lists.perks.findIndex(perk => perk.name == "Vanishing Trick")
                let perk = roguePerks.filter(perk => perk.name == "Invisible Blade")[0]
                perk.uiType = "perk"
                context.stats.lists.perks.splice(index, 1, perk)
            }                      
        },
    },
    {
        type: "universal",
        name: "Invisible Blade",
        shortDesc: "When using vanishing trick, you instead spend 4 spell points and it acts like greater invisibility. If you gain this multiple times, you gain +2 attack while invisible.",
        prereq:"Vanishing Trick"
    },
    {
    type: "universal",
    name: "Wall Climber",
    shortDesc: "Gain climb speed of 20 feet on vertical surfaces.",
    },
    {
    type: "universal",
    name: "Another Day",
    shortDesc: "Once per combat, when you would be reduced to 0 or fewer hit points by a melee attack, she can take a 5-foot step as a free action. If the movement takes her out of the reach of the attack, she takes no damage from the attack. The rogue is staggered for 1 round on her next turn.",
    },
    {
    type: "universal",
    name: "Against the Wall",
    shortDesc: "You are considered to be flanking any opponent adjacent to a stone wall (whether the stone is worked or unworked).",
    },
    {
    type: "universal",
    name: "Defensive Roll",
    shortDesc: "the rogue can roll with a potentially lethal blow to take less damage from it than she otherwise would. For level spell points, when she would be reduced to 0 or fewer hit points by damage in combat (from a weapon or other blow, not a spell or special ability), the rogue can attempt to roll with the damage. To use this ability, the rogue must attempt a Reflex saving throw (DC = damage dealt). If the save succeeds, she takes only half damage from the blow; if it fails, she takes full damage. She must be aware of the attack and able to react to it in order to execute her defensive roll—if she is denied her Dexterity bonus to AC, she can't use this ability. Since this effect would not normally allow a character to make a Reflex save for half damage, the rogue's evasion ability does not apply to the defensive roll.",
    },
    {
    type: "sneak talent",
    name: "Entanglement of Blades",
    shortDesc: "When a rogue with this talent hits a creature with a melee attack that deals sneak attack damage, the target cannot take a 5-foot step until the beginning of the rogue's next turn.",
    },
    {
    type: "universal",
    name: "Redirect Force",
    shortDesc: "Once per combat, when a rogue with this talent is hit with a melee attack, she can redirect the attack to strike at an adjacent creature with a free action. The creature targeted must be within melee reach of the attack that hit the rogue, and the creature that made the attack against the rogue must make a new attack roll against the new target.",
    },
    {
    type: "universal",
    name: "Opportunist",
    shortDesc: "Once per round, the rogue can make an attack of opportunity against an opponent who has just been struck for damage in melee by another character. This attack counts as an attack of opportunity for that round. Even a rogue with the Combat Reflexes feat can't use the opportunist ability more than once per round.",
    },
    {
    type: "sneak talent",
    name: "Hunters Surprise",
    abilityType:"Ex",
    shortDesc: "For level spell points a rogue with this talent can designate a single enemy she is adjacent to as her prey. Until the end of her next turn, she can add her sneak attack damage to all attacks made against her prey, even if she is not flanking it or it is not flat-footed. You can only use this on an individual creature a single time.",
    },          
    {
    type: "universal",
    name: "Weapon Snatcher",
    abilityType:"Ex",
    shortDesc: "You can roll a stealth or sleight of hand check instead of cmb to disarm opponents",
    },
    {
    type: "sneak talent",
    name: "Sneak Attack Mastery",
    abilityType:"Ex",
    shortDesc: "You can apply an additional sneak attack talent (talents marked with an *) to sneak attacks. If the talent would reduce how many sneak attack dice you deal the second talent uses the new modified amount of sneak attack to determine its penalty",
    },
    {
    type: "universal",
    name: "Shank",
    abilityType:"Ex",
    shortDesc: `When using a light melee weapon you can change the base damage to 1d6 and the critical threat range to 19-20. You can only use both or neither benefit. This does not modify a weapons critical damage multiplier.
    Each time you select this perk the base dice increases by 1 step, and the critical threat range increases by one more.`,
    },
    {
        type: "universal",
        name: "Armor Skin",
        abilityType:"Ex",
        shortDesc: `Your armor is like a second skin, you dont apaply your armor check penalty while wearing light armor from either your armor or clothing to your acrobatics, escape artist, stealth, or disable device checks.`,
    },
    {
        type: "universal",
        name: "Blind Spot",
        abilityType:"Ex",
        shortDesc: `The vigilante is so skilled at stealth, he can use the Stealth skill to hide from creatures with unusual senses that normally automatically detect creatures. This includes senses such as blindsense, blindsight, lifesense, scent, or tremorsense. For each such ability that the creature possesses, if the vigilante is not bypassing the sense in another way—such as the negate aroma spell for scent or flying for tremorsense—the creature gains a stacking +20 circumstance bonus on all Perception checks to notice the vigilante, rather than automatically noticing the vigilante.`,
    },
    {
        type: "universal",
        name: "Expose Weakness",
        abilityType:"Ex",
        shortDesc: `You can use dirty trick to reduce a creature's damage reduction or hardness by 10. This does not stack with itself and does not work against DR/- or DR/legendary/mythic.`,
    },
    {
        type: "universal",
        name: "Favoured Maneuver",
        abilityType:"Ex",
        shortDesc: `Pick a strike, when you use that strike you can deal an additional 1d6 points of damage on attacks during it, this becomes 2d6 if the strike would also apply sneak attack. This is precision damage.`,
    },
    {
        type: "universal",
        name: "Close the Gap",
        fromClass:"vigilante",
        abilityType:"Ex",
        shortDesc: `Each round, at the start of his turn, the vigilante can designate one foe within 20 feet that isn't adjacent to him. When he moves, he doesn't provoke attacks of opportunity from that foe as long as he ends his move adjacent to that foe. If he charges that foe, he does not take the -2 penalty to his AC on any attacks made by the designated foe.`,
    },
    {
        type: "universal",
        name: "Hide in Plain Sight",
        fromClass:"vigilante",
        abilityType:"Ex",
        shortDesc: `The vigilante can use Stealth to hide even when being observed at a -10 penalty.`,
    },
    {
        type: "universal",
        name: "Slip Away",
        abilityType:"Ex",
        shortDesc: `When you are grappled you can spend level/2 spell points as an immediate action to make an escape artist check with a bonus equal to half your level. If you select this ability a second time you can also make an attack with a light weapon as part of the action of escaping if you succeed on your escape artist check against the creature who was grappling you.`,
    },
    {
        type: "universal",
        name: "Lethal Grace",
        fromClass:"vigilante",
        abilityType:"Ex",
        shortDesc: `When you make a melee attack using your Dexterity bonus on attack rolls and your Strength bonus on damage rolls, you also adds half your level on damage rolls. This bonus damage is not reduced or increased if you are wielding a weapon two-handed or in an off-hand.`,
    },
    {
        type: "sneak talent",
        name: "Mighty Ambush*",
        fromClass:"vigilante",
        abilityType:"Ex",
        shortDesc: `Once per round, when the vigilante succeeds at a hidden strike, he can instantly drop the damaged enemy unconscious for 1 round. A successful Fortitude saving throw negates this effect (DC = 10 + 1/2 level + the higher of Strength and Dexterity modifiers). Whether or not a creature's saving throw is successful, it can't be affected by that vigilante's mighty ambush again.`,
        additionalInfoTags:["Sneak Attack Talent"],
    },
    {
        type: "universal",
        name: "Perfect Vulnerability",
        fromClass:"vigilante",
        abilityType:"Ex",
        shortDesc: `As a standard action, the vigilante can cleverly strike his foe where that foe is weakest. This attack targets the foe's touch AC, and the foe is denied her Dexterity bonus against the attack. Once a foe has been the target of perfect vulnerability, she can't be the target of the same vigilante's perfect vulnerability for 24 hours.`,
    },
    {
        type: "sneak talent",
        name: "Twisting Fear",
        fromClass:"vigilante",
        abilityType:"Ex",
        shortDesc: `Whenever the vigilante causes an opponent to gain the shaken, frightened, or panicked condition, that opponent takes an amount of nonlethal damage equal to your sneak attack damage, as the stress wears upon its body. A creature can't take damage from twisting fear more than once per round. Panicked creatures that take damage from twisting fear are too winded even to scream as they flee in terror.`,
    },
    {
        type: "sneak talent",
        name: "Up Close and Personal",
        fromClass:"vigilante",
        abilityType:"Ex",
        shortDesc: `When the vigilante attempts an Acrobatics check to move through an opponent's space during a move action, he can attempt a single melee attack against that opponent as a swift action. If the Acrobatics check succeeds, this attack applies sneak attack damage as if the foe were flat-footed.`,
    },
    {
        type: "universal",
        name: "Surprise Strike",
        fromClass:"vigilante",
        abilityType:"Ex",
        shortDesc: `Whenever you make an attack against a foe that is denied their Dexterity bonus to AC, you gain a +1 bonus on your attack roll. This bonus increases by +1 every 7 levels.`,
    },
    {
        type: "sneak talent",
        name: "Leave an Opening",
        fromClass:"vigilante",
        abilityType:"Ex",
        shortDesc: `You successfully deal sneak attack damage to a creature you unbalance your foe, if at the start of the foe's next turn you still threaten it the foe provokes an attack of opportunity against it. Multiple sneak attacks in a round don't create multiple openings in the same round, but if you attack several foes you can make an attack against each.`,
    },
    

]
export const ragePerks = [
{
    type: "universal",
    name: "A Barbarian's Secret",
    shortDesc: `You can use abilities that require you to be raging, even when you are not raging. Abilities that have usages per rage become usages per floor.`,
},
{
    type: "universal",
    name: "Animal Fury",
    shortDesc: `Gain a bite attack. If used as part of a full attack action, the bite attack is made at the barbarian's full base attack bonus -5. If the bite hits, it deals 1d4 points of damage plus half the barbarian's Strength modifier. you can make a bite attack as part of the action to maintain or break free from a grapple. This attack is resolved before the grapple check is made. If the bite attack hits, any grapple checks made by the barbarian against the target this round are at a +2 bonus. 
    \nEach time you select this perk the bite attack deals damage as if you were one size larger.`,
},
    {
    type: "rage",
    name: "Arcane Rage",
    fromClass: "Arcane Bloodrager",
    shortDesc: "When entering a rage you can automatically affect yourself with one spell from your spell list. This spell can only be a spell that can affect you, and if it otherwise would affect multiple targets it only affects you, and it must have a duration of at least rounds per level. The spell now lasts until you stop raging instead of its normal duration. Spells that end when triggered still end normally.",
    },
    {
    type: "universal",
    name: "Berserk",
    sphere:"berserker",
    shortDesc: "At the start of your turn as a free action you can choose to take a -2 to armor class to gain temporary hit points equal to 3 + bab until the start of your next turn.",
    },
    {
    type: "universal",
    name: "Deathless",
    sphere:"berserker",
    shortDesc: `The number of hit points you can be reduced to below 0 without dying is doubled, and when reduced below 0 hit points, you may choose to act as if you were disabled, rather than dying. You must make this decision as soon as you are reduced to negative hit points (even if it isn't your turn). If you do not choose to act as if you were disabled, you immediately fall unconscious.
    \nWhen using this ability, you are staggered. You can take a move action without further injuring yourself, but if you perform any standard action (or any other action deemed as strenuous, including some swift actions, such as casting a quickened spell) you take 1 point of damage after completing the act. If your negative hit points are equal to or greater than twice your Constitution score, you immediately die.`,
    },
    {
    type: "universal",
    name: "Decapitate",
    sphere:"berserker",
    shortDesc: `You do not provoke attacks of opportunity when delivering a coup de grace, and you may deliver a coup de grace as a standard action.`,
    },        
    {
    type: "universal",
    name: "Sword Eater",
    sphere:"berserker",
    shortDesc: `You can activate this ability as a swift action for level/3 spell points to enter this stance which lasts until the start of your next turn, but. While in this stance, when a creature targets you with a manufactured melee weapon attack, you may attempt to sunder the weapon used to make the attack as an attack of opportunity after it resolves. If the creature attacking you is battered, you may resolve your sunder attempt prior to their attack being resolved.`,
    },
    {
    type: "universal",
    name: "Absolute Determination",
    sphere:"berserker",
    shortDesc: `At the start of your turn as a free action you can choose to take a -2 penalty to armor class to gain a +1 bonus on saving throws against mind-affecting effects and the DC to Intimidate you, increasing by +1 for every 5 base attack bonus you possess. Whenever you would attempt a save against a mind-affecting effect, you may roll twice, taking the better result. Both the penalty to AC and bonus to saves last for 1 round.
    \nIn addition, you may level/2 spell points as an immediate action to attempt a save against a mind-affecting effect (using the effect's original DC) or reduce your current level of fear by 1 step (panicked to frightened, frightened to shaken, shaken to not affected by a fear effect). You may only attempt a new save against a specific mind-affecting effect (for example, a specific instance of charm) once per day.`,
    },
    {
    type: "universal",
    name: "Dreadnought",
    sphere:"berserker",
    shortDesc: `At the start of your turn as a free action you can choose to take a -2 penalty to armor class to gain a +1 bonus on saving throws and to your CMD against effects that would slow or impair your movement (such as entangled, grappled, paralyzed, staggered, or other similar effects), increasing by +1 for every 4 base attack bonus you possess. Whenever you would attempt a save against an effect that would slow or immobilize you, you may roll twice, taking the better result. Both the penalty to AC and bonus to saves last for 1 round.
    \nIn addition, once per round, you may expend level/2 spell points as an immediate action to attempt a save against an effect which has slowed or impaired your movement, or make a combat maneuver or other appropriate check to escape a grapple, Lancer impale, or other similar effect.`,
    },
    {
    type: "universal",
    name: "Executioner",
    sphere:"berserker",
    shortDesc: `At the start of your turn as a free action for level/2 spell points you can choose to take a -2 penalty to armor class until the start of your next turn to allow you to choose a single attack roll during this round for which you can roll twice and take the better result. You must decide to use this before the roll is made. You may choose an additional attack roll to roll twice on each round for every 9 base attack bonus you possess.`,
    },
    {
    type: "universal",
    name: "Sanguine Invigoration",
    sphere:"berserker",
    shortDesc: `Whenever you reduce a creature to 0 hit points or fewer with a melee or thrown weapon attack, you gain temporary hit points equal to your base attack bonus for 1 round. The creature must have a CR of at least half your character level (rounded down, minimum 1/2). Whenever this ability would be triggered, you may spend bab/2 spell points as an immediate action to remove the fatigued condition, or lessen the exhausted condition to fatigued.`,
    },
    {
    type: "universal",
    name: "Juggernaut",
    sphere:"berserker",
    shortDesc: `At the start of your turn as a free action you can choose to take a -2 penalty to armor class to ignore difficult terrain when you charge, run, or withdraw. You can also charge through squares that contain allies. When using the charge action, you do not take a penalty to your AC and increase the bonus on attack rolls and bull rush combat maneuvers at the end of a charge by 1, increasing by +1 for every 8 base attack bonus you possess. Both the bonuses and penalties last for 1 round`,
    },
    {
    type: "universal",
    name: "Marauder",
    sphere:"berserker",
    shortDesc: `At the start of your turn as a free action you can choose to take a -2 penalty to armor class to gain a +5 feet circumstance bonus on all forms of movement (such as land, climb, burrow, fly, or swim), increasing by +5 feet for every 3 points of base attack bonus you have. In addition, you gain a competence bonus on all Acrobatics, Climb, Fly, and Swim checks equal to half your base attack bonus (minimum 1). Both the bonuses and penalties last for 1 round`,
    },
    {
    type: "universal",
    name: "Promethean",
    sphere:"berserker",
    shortDesc: `At the start of your turn as a free action you can choose to take a -2 penalty to armor class to choose one element, (acid, cold, electricity, fire) and gain resistance 5 + BAB/2 against the chosen element, which stacks with all other forms of element resistance. When you use this perk you can expend BAB/2 spell points to instead gain 10 + BAB resistance against the chosen element. Whenever the elemental resistance gained by this perk prevents you from taking damage you regain BAB/2 spell points, this can only activate once per round, and only once per individual effect. Both the bonuses and penalties last 1 round.`,
    },
    {
    type: "universal",
    name: "Specter",
    sphere:"berserker",
    shortDesc: `At the start of your turn as a free action you can choose to take a -2 penalty to armor class and expend 2 spell points to designate one foe within 20 feet that is not adjacent to you, increasing by +5 feet for every 3 points of base attack bonus you possess. Your movement does not provoke attacks of opportunity from that foe as long as you end your movement adjacent to that foe. In addition, you gain a +2 dodge bonus to your AC against all attacks of opportunity that you provoke, increasing by +1 for every 3 points of base attack bonus you possess.`,
    },
    {
    type: "universal",
    name: "Shatter Earth",
    sphere:"berserker",
    shortDesc: `You may attack the ground around you with a savage blow. You may make an attack against the corner of a square within your reach as a full-round action. You may reduce this to a standard action by spending bab/2 spell points. This attack automatically hits and deals damage normally. If you manage to deal more damage than the floor's hardness, you cause a 5 ft. radius, 10 ft. cone, or 15 ft. line (your choice) to become difficult terrain. Radius' increase by 5 ft. per 8 base attack bonus, cones by 5 ft. per 4 base attack bonus, and lines by 10 ft. per 4 base attack bonus. A square can be cleared as a standard action (provoking an attack of opportunity) or repaired with a spell`,
    },
    {
    type: "rage",
    name: "Phoenix Fire",        
    shortDesc: "The power of the phoenix brings righteous destruction to any who oppose it. while raging, you gain the following effects: your melee attacks deal an additional 2d6 points of fire damage, any enemies within 20 feet of you must succeed at a Reflex save (DC = 10 + 1/2 your bloodrager level + your Constitution modifier) or take 4d6 points of fire damage at the start of their turn, and any creature that attacks you with a natural or non-reach weapon takes 1d6 points of fire damage (no save) with each successful hit.",
    },
    {
    type: "universal",
    name: "Big Game Hunter",   
    abilityType:"Ex",
    fromClass:"Titan Mauler Barbarian",
    shortDesc: "You gain a +1 bonus on melee attack rolls and a +1 dodge bonus to AC against melee attacks made by creatures larger than you for each size category larger than you they are.",
    },
    {
        type: "universal",
        name: "Bloody Counter",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: "As an immediate action, when a creature targets you with a melee attack, before the attack roll is made you may allow the attack to automatically strike you (although the roll is still made to determine if the attack threatens a critical hit). After the damage is determined, you may make an targeting that creature as a free action that may be taken even when it isn't your turn, if it is in range. If the attack hits, the creature takes a -2 penalty to its CMD, and it cannot make attacks of opportunity in response to CMB checks (If the check would already not provoke, they gain an +2 bonus on the check) against it until the end of your next turn. You may also spend spell points equal to your BAB/2 to increase the damage of the attack by 2x your BAB.",
    },
    {
        type: "universal",
        name: "Brutal Strike",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: "As an attack action, you may make a melee attack against a target. Creatures damaged by a brutal strike become battered, taking a -2 penalty to their CMD and it cannot make attacks of opportunity in response to CMB checks (If the check would already not provoke, they gain an +2 bonus on the check) against it until the end of your next turn. You may expend BAB/2 spell points to have the attack deal additional damage equal to twice your base attack bonus.",
    },
    {
        type: "universal",
        name: "Bell Ringer",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: "Creature damaged by your brutal strike take a -1 penalty on concentration checks and Will saves for as long as the creature is battered. This penalty increases by -1 at base attack bonus +4 and every 4 points of base attack bonus thereafter. This penalty does not stack with other uses of the same talent.",
        prereq:"Brutal Strike"
    },        
    {
        type: "universal",
        name: "Beat Down",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: "When you inflict the battered condition with a brutal strike, the condition lasts for an additional number of rounds equal to your highest mental modifier (minimum 1).",
        prereq:"Brutal Strike"
    },
    {
        type: "universal",
        name: "Bone-Breaker",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: "The creature damaged by your brutal strike takes a -1 penalty on all attack and damage rolls for as long as it is battered. This penalty increases by -1 for every 4 points of base attack bonus you possess. Multiple uses of this talent do not stack.",
        prereq:"Brutal Strike"
    },
    {
        type: "universal",
        name: "Flesh Carver",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: `Your weapons rend through flesh, sinew, and bone alike. The creature damaged by your brutal strike has their damage reduction reduced by an amount equal to 1/2 your base attack bonus (minimum 1). This reduction lasts for as long as the target has the battered condition. This reduction does not stack with itself.
        The benefits of this talent are halved (minimum 1) when applied to damage reduction that cannot be overcome or is overcome only by epic weapons (such as DR 3/- or DR 20/epic).`,
        prereq:"Brutal Strike"
    },
    {
        type: "universal",
        name: "Heart Crusher",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: "The creature damaged by your brutal strike suffers a -1 penalty on all Fortitude saves for as long as the creature is battered. This penalty increases by -1 for every 4 points of base attack bonus you possess. This penalty does not stack with other uses of the same talent. If the target was battered when struck, they additionally reduce all temporary hit points and healing they receive by 50% for as long as they are battered (Will negates). This does not affect healing gained from fast healing or regeneration.",
        prereq:"Brutal Strike"
    },
    {
        type: "universal",
        name: "Heavy Swing",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: "Creature damaged by your brutal strike must succeed on a Fortitude save (dc=10+level/2+highest mental) or be staggered for 1 round plus 1 round per 4 base attack bonus. If the target is battered, it is instead staggered for 1 round on a successful save, or dazed for 1 round then staggered as normal on a failed save. If the target failed the Fortitude save, for the duration of the staggered condition, it also counts the damage from the attack as ongoing damage for the purpose of concentration checks. Creatures immune to the dazed condition are instead staggered for the round they would have been dazed.",
        prereq:"Brutal Strike"
    },
    {
        type: "universal",
        name: "Leg-Smasher",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: "Creature damaged by your brutal strike take a -1 penalty on AC and Reflex saves for as long as the creature is battered. This penalty increases by -1 at base attack bonus +4 and every 4 points of base attack bonus thereafter. This penalty does not stack with other uses of the same talent.",
        prereq:"Brutal Strike"
    },
    {
        type: "universal",
        name: "Shieldbreaker",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: "When you make a sunder attempt against a piece of armor, a shield, or a manufactured weapon with a brutal strike, you may ignore a number of points of the item's hardness equal to your base attack bonus. If the item is destroyed, any excess damage is applied to the item's wielder. No damage is transferred if you decide to leave the item with 1 hit point. When targeting a battered creature, you may roll the sunder check twice and take the best result.",
        prereq:"Brutal Strike"
    },
    {
        type: "universal",
        name: "Shrapnel",   
        abilityType:"Ex",
        fromSphere:"Berserker",
        shortDesc: "When you attack an unattended object with a brutal strike, if you destroy the object, you may send fragments of it flying in a cone dealing damage to any creature in an area based on its size. Small or smaller objects create a 10 ft. cone and the size of the cone increases by 5 ft. for every size category above Small. This shrapnel does 1d6 points of bludgeoning, piercing, and slashing damage dealt by the same material or materials that the object was primarily composed of. This damage increases by 1d6 at +3 base attack bonus and every 2 points of base attack bonus thereafter. The damage also increases by 1d6 for every 5 points of hardness the object possessed, to a maximum increase of 10d6 additional damage. Creatures that take damage are also battered. A Reflex save (dc=10+level/2+highest mental) halves this damage and prevents the battered condition. A battered creature must roll twice and take the worse result on their Reflex save.",
        prereq:"Brutal Strike"
    },
    {
        type: "universal",
        name: "Break Dancing",   
        abilityType:"Ex",
        fromClass:"Berserker Sphere",
        shortDesc: "After making a sunder attempt, you may attempt an Acrobatics or Perform (dance) check as a swift action with a DC equal to the target of your sunder's CMD. If you succeed, you may move up to half your speed. This movement does not provoke attacks of opportunity. If you succeed at this check by 10 or more, your sweet moves restore your BAB/2 spell points.",
    },
    {
        type: "universal",
        name: "Raging Leaper",   
        abilityType:"Ex",
        shortDesc: "The barbarian adds half her level as an enhancement bonus on all Acrobatics skill checks made to jump, or quarter of her level on all other acrobatics checks. When making a jump in this way, the barbarian is always considered to have a running start. If you have rage, these bonuses double while raging.",
    },
    {
        type: "universal",
        name: "Knockback",   
        abilityType:"Ex",
        shortDesc: "Once per round, the barbarian can make a bull rush attempt against one target in place of a melee attack. If successful, the target takes damage equal to the barbarian's Strength modifier and is moved back as normal. The barbarian does not need to move with the target if successful. This does not provoke an attack of opportunity. If it already would not provoke, you gain a +2 bonus on the attempt.",
    },
    {
        type: "universal",
        name: "Savage Dirty Trick",   
        abilityType:"Ex",
        shortDesc: `When you use the dirty trick combat maneuver, you gain a +2 bonus on the checks, and on successful attempts the target takes damage equal to your strength modifier, and the target must make a fortitude saving throw (dc=10 + level/2 + mod that determines your CMB bonus) or take an additional penalty depending on the trick performed:\nInitial Penalty: Additional Penalty\nBlinded:Staggered\nDazzled:Dazed\nDeafened:Staggered\nEntangled: Anchored in place\nSickened: Nauseated.
        \nThis additional penalty lasts 1 round and can be removed with a move action. The initial effect also cannot be removed by mundane means until the additional penalty is removed. If the target would be immune to the initial penalty, it is also immune to the additional penalty.`,
    },
    {
        type: "universal",
        name: "Savage Jaw",   
        abilityType:"Ex",
        shortDesc: `As a swift action for 4 spell points you can cause your bite attack to gain the grab ability until the end of your turn.`,
    },
    {
        type: "rage",
        name: "Knockdown",   
        abilityType:"Ex",
        shortDesc: "Once per rage, the barbarian can make a trip attack against one target they have just struck with a melee attack. If successful, the target takes damage equal to the barbarian's Strength modifier and is knocked prone. This does not provoke an attack of opportunity. If it already would not provoke, you gain a +2 bonus on the attempt.",
    },
    {
        type: "universal",
        name: "Guarded Life",   
        abilityType:"Ex",
        shortDesc: "If you would be reduced below 0 hit points by an attack, the attack has its damage reduced by 1 point per level. This cannot reduce the damage of the attack below 1 point of damage, or reduce the damage below what would reduce you to -1. This effect cannot activate if you also would remain conscious when reduced to negative hit points. If you are at negative hit points due to lethal damage, you immediately stabilizes.",
    },
    {
        type: "universal",
        name: "Improved Guarded Life",   
        abilityType:"Ex",
        shortDesc: "Guarded life has the damage it reduces to 2x your level. This does not modify any of the restrictions on guarded life.",
        prereq:"Guarded Life"
    },
    {
        type: "rage",
        name: "Ground Breaker",   
        abilityType:"Ex",
        shortDesc: "Once per rage, the barbarian can attack the floor around her as a standard action. This attack automatically hits and deals damage normally. If the barbarian manages to deal more damage than the floor's hardness, the space she occupies and all of the squares adjacent to her become difficult terrain. Creatures in these squares, except the barbarian, must make a DC 15 Reflex save or be knocked prone.",
    },
    {
        type: "rage",
        name: "Improved Ground Breaker",   
        abilityType:"Ex",
        shortDesc: "When using the ground breaker rage power, the barbarian can extend the radius of the effect by 5 feet.",
        prereq:"Ground Breaker"
    },
    {
        type: "rage",
        name: "Flesh Wound",   
        abilityType:"Ex",
        shortDesc: "Once per rage, the barbarian can try to avoid serious harm from an attack. The barbarian must make a Fortitude save with a DC equal to the damage that would be dealt by the attack. The barbarian's armor check penalty applies on this saving throw. If the save succeeds, the barbarian takes half damage from the attack and the damage is nonlethal. The barbarian must elect to use this ability after the attack roll is made, but before the damage is rolled.",
    },
    {
        type: "rage",
        name: "Improved Flesh Wound",   
        abilityType:"Ex",
        shortDesc: "When using flesh wound, if you fail the save against the damage, you still reduce the damage by the result of the save, and instead that that damage as non-lethal damage.",
        prereq:"Flesh Wound"
    },
    {
        type: "rage",
        name: "Greatear Flesh Wound",   
        abilityType:"Ex",
        shortDesc: "When using flesh wound, if you fail the save against the damage, you still reduce the damage by the result of the save, and half the remaining damage becomes non-lethal.",
        prereq:"Improved Flesh Wound"
    },
    {
    type: "rage",
    name: "Indomitable Will",   
    abilityType:"Ex",
    fromClass:"Barbarian",
    shortDesc: "While in rage, a barbarian gains a +4 bonus on Will saves to resist enchantment spells. This bonus stacks with all other modifiers, including the morale bonus on Will saves she also receives during her rage.",
    },
    {
    type: "universal",
    name: "Jotungrip",   
    abilityType:"Ex",
    fromClass:"Titan Mauler Barbarian",
    shortDesc: "A titan mauler may choose to wield a two-handed melee weapon in one hand with a -2 penalty on attack rolls while doing so. The weapon must be appropriately sized for her, and it is treated as one-handed when determining the effect of Power Attack, Strength bonus to damage, and the like.",
    },
    {
    type: "universal",
    name: "Evade Reach",   
    abilityType:"Ex",
    fromClass:"Titan Mauler Barbarian",
    shortDesc: "As a swift action, a titan mauler may choose one creature within her line of sight. Until the end of her turn, that target's reach is treated as if it were 5 feet shorter with respect to reaching the titan mauler, and this reduction increases by 5 feet for every five levels. You cannot reduce a monsters reach below 5 feet with this perk.",
    },
    {
    type: "universal",
    name: "Massive Weapons",   
    abilityType:"Ex",     
    fromClass:"Titan Mauler Barbarian",
    shortDesc: "You can increase your weapons damage while wielding it by 1 size step by taking a -6 to attack. At level 3 and every 3 levels after that reduce this penalty by 1 (minimum 0)",
    },
    {
    type: "rage",
    name: "Focused Rage",   
    abilityType:"Ex",     
    fromClass:"Primal Hunter Barbarian",
    shortDesc: "While raging you gain a +2 bonus on ranged attack rolls. This bonus increases by +1 every 8 levels.",
    },
    {
    type: "rage",
    name: "Consume Vigor",   
    abilityType: "Ex",     
    fromClass: "Raging Cannibal Barbarian",
    shortDesc: "Your bite attack damage increases by 1 size step if you have one. Whenever you reduce a creature to 0 or fewer hit points with your bite attack while raging, you can consume a chunk of its body to gain a portion of its power. If the creatures CR equals or exceeds your level you restore spell points equal to 2x your rage cost, and gain 1d8+con temporary health that lasts 10 minutes. Each 4 levels you restore an additional round of rage and gain an additional 1d8 temporary health.",
    },
    {
    type: "rage",
    name: "Technologist Rage",   
    abilityType: "Ex",     
    fromClass: "Savage Technologist Barbarian",
    shortDesc: "When you begin raging you can choose your rage to give a morale bonus to dexterity and constitution instead of its normal ability score bonuses, and your rage no longer penalizes your AC. If you have an ability that increases your strength bonus to rage, it instead applies to dexterity.",
    },
    {
    type: "rage",
    name: "Sword and Crack Shot",   
    abilityType: "Ex",     
    fromClass: "Savage Technologist Barbarian",
    shortDesc: "While wielding a light or one handed melee weapon in one hand, and a firearm in the other you gain the benefits of two-weapon fighting feat, and you no longer provoke attacks of opportunity while firing a firearm if all your attacks in a turn are made with those weapons. You can add your dexterity to your damage with firearms while raging.",
    },
    {
    type: "rage",
    name: "Raging Drunk",   
    abilityType: "Ex",     
    fromClass: "Drunken Brute Barbarian",
    shortDesc: "While raging you can drink potions as a move action and it doesn't provoke an attacks of opportunity. Otherwise while raging you can spend a movement action that doesn't provoke to drink an alcoholic drink to gain your rage cost spell points. When your rage ends for each alcoholic drink you had while raging you become nauseated for 1 round on top of becoming fatigued as normal. Each drink increases the rounds nauseated.",
    },
    {
    type: "rage",
    name: "Drunken Rage",   
    abilityType: "Ex",     
    fromClass: "Drunken Rager Barbarian",
    shortDesc: "You can choose to enter rage as a standard action instead of a free action, if you do you gain evasion for as long as that rage lasts, and a +1 bonus on saves against effects that would nauseate, poison, or sicken, this bonus increases by 1 every 5 levels.",
    },
    {
    type: "rage",
    name: "Drunken Swing",   
    abilityType: "Ex",     
    fromClass: "Drunken Rager Barbarian",
    shortDesc: "While raging you can spend a standard action to drink an alcoholic drink and gain a drunken rage point (max level/2), then within the next hour while raging you can expend a drunken rage point to make a drunken swing as a swift action right before you make an attack roll to increase the critical threat range of that attack by 1. This is a flat bonus that is never doubled. At level 8 and 16 you can expend an additional drunken rage point to increase the critical threat chance by 1 more.",
    },
    {
    type: "universal",
    name: "Internal Fortitude",   
    abilityType: "Ex",     
    fromClass: "Barbarian",
    shortDesc: "While raging you become immune to the sickened and nauseated condition.",
    },
    {
    type: "rage",
    name: "Titanic Rage",   
    abilityType:"Su",     
    fromClass:"Tital Mauler Barbarian",
    shortDesc: "When you enter rage you can choose to gain the benefits of the enlarge person spell for the rest of the rage. While the rage is in effect it costs an additional 1 spell point per round, and you become exhausted instead of fatigued when your rage ends.",
    },
    {
    type: "universal",
    name: "Naked Courage",   
    abilityType:"Ex",     
    fromClass:"Savage Barbarian",
    shortDesc: "You gain a +1 dodge bonus to AC and a +1 morale bonus on saving throws against fear while wearing no armor (clothes and shields are allowed). This bonus increases by 1 every 4 levels.",
    },
    {
    type: "universal",
    name: "Natural Toughness",   
    abilityType:"Ex",     
    fromClass:"Savage Barbarian",
    shortDesc: "You gain a +1 racial natural armor bonus to AC when wearing no armor (clothes and shields are allowed). This bonus increases by +1 every 4 levels.",
    },
    {
    type: "universal",
    name: "Pack Tactics",
    fromClass:"Mad Dog Barbarian",
    abilityType:"Ex",
    shortDesc: "You gain +4 bonus on attack rolls while flanking instead of +2.",
    },
    {
    type: "universal",
    name: "Throat Cutter",
    fromClass:"Mad Dog Barbarian",
    abilityType:"Ex",
    shortDesc: "Whenever an ally succeeds at a bull rush, drag, grapple, overrun or trip combat maneuver agaisnt an opponent threatened by you, you can make an attack of opportunity against the opponent.",
    },
    {
    type: "universal",
    name: "Hard Hitter",
    fromClass:"Liberator Barbarian",
    abilityType:"Ex",
    shortDesc: "Damage you deal to creatures with hardness and objects ignores hardness equal to half your level",
    },
    {
    type: "universal",
    name: "Disruptor",
    fromClass:"Liberator Barbarian",
    abilityType:"Ex",
    shortDesc: "Any foe in your threatened area has the DC to cast spells defensively increased by 1. This increases by +1 every 4 levels.",
    },
    {
    type: "universal",
    name: "Wild Fighting",
    fromClass:"Wild Rager Barbarian",
    abilityType:"Ex",
    shortDesc: "When making a full-round attack action you can make one extra attack per round at your highest base atttack bonus. If you choose to do this you gain a -4 to all attack rolls and a -4 penalty to ac until the start of your next turn.",
    },
    {
    type: "universal",
    name: "Rage Conversion",
    fromClass:"Wild Rager Barbarian",
    abilityType:"Ex",
    shortDesc: "When you fail a saving throw against a mind-affecting effect you can attempt a new saving throw, if this second roll succeeds the affect is negated, you then enter a rage, gaining +4 morale bonus to strength and constitution, +2 to will save and -2 to AC, and you become confused, but each turn act as if you rolled 'Attack nearest creature'. Both of these effects last the duration of the original effect, but at the start of each turn you can attempt a new saving throw at the dc of the original triggering effect to end both the rage and confusion.",
    },
    {
    type: "universal",
    name: "Destructive",
    fromClass:"Breaker Barbarian",
    abilityType:"Ex",
    shortDesc: "When you sunder or attack an object you add half your level to the damage (minimum +1)",
    },
    {
    type: "universal",
    name: "Battle Scavenger",
    fromClass:"Breaker Barbarian",
    abilityType:"Ex",
    shortDesc: "You suffer no penalties to attack rolls with a broken weapon, and gain +1 to damage for every 3 levels while wielding an improvised or broken weapon. You can take a -4 to attack (as if using an improvised weapon) to gain this bonus.",
    },
    {
    type: "universal",
    name: "Savage Grapple",
    fromClass:"Brutal Pugalist Barbarian",
    abilityType:"Ex",
    shortDesc: `You take only half the normal penalties to dexterity, attack rolls, and combat maneuver checks while you have the grappled condition. You can also make attacks of opportunity against creatures trying to grapple you even if they posses the improved grapple feat or the grab special attack. If you hit with this attack of opportunity you gain a +2 circumstance bonus to your CMD agaisnt the grapple attempt. You cannot use this attack of opportunity once the grapple has succeeded.
    If you select this perk a second time you gain no penalties to dexterity, attack rolls, and combat maneuver checks while you have the grappled condition, and you are treated as one size larger when determining whether you can be grappled using the grab ability or swallow whole ability.`,
    },
    {
        type: "universal",
        name: "Improved Savage Grapple",
        fromClass:"Brutal Pugalist Barbarian",
        abilityType:"Ex",
        shortDesc: `You gain no penalties to dexterity, attack rolls, and combat maneuver checks while you have the grappled condition, and you are treated as one size larger when determining whether you can be grappled using the grab ability or swallow whole ability.`,
        prereq:"Savage Grapple"
    },
    {
    type: "universal",
    name: "Pit Fighter",
    fromClass:"Brutal Pugalist Barbarian",
    abilityType:"Ex",
    shortDesc: "Select a combat maneuver when you gain this perk, you gain a +1 insight bonus to your CMB or CMD in that maneuver. This bonus increases by 1 every 3 levels, and is doubled if you're not wearing armor (clothing and shields are allowed)",
    },
    {
    type: "rage",
    name: "Flame Runner",
    fromClass:"Burn Rider Barbarian",
    abilityType:"Ex",
    shortDesc: "Once per rage you can move at incredible speed, your movement speed increases by 10 feet until the end of your turn. This speed bonus increases by 10 feet every 5 levels.",
    },
    {
    type: "universal",
    name: "Cinder Dance",
    fromClass:"Burn Rider Barbarian",
    abilityType:"Ex",
    shortDesc: "When you succeed a reflex save to avoid fire, cold, acid, or electrictiy damage you can spend an immediate action to move up to half your speed. If this movement ends you outside the area of the effect you take no damage from the effect. After this sudden movement you are staggered on your next turn.",
    },
    {
    type: "universal",
    name: "Give me Fire",
    fromClass:"Burn Rider Barbarian",
    abilityType:"Ex",
    shortDesc: "Whenever you take fire damage you gain 1 spell point, +1 every 5 levels. You only gain this if the damage bypasses or exceeds any energy resistance or protection effect you have. If you are raging when you take fire damage the spell point gain is doubled.",
    },
    {
    type: "rage",
    name: "Dead Calm",
    fromClass:"Dreadnought Barbarian",
    abilityType:"Ex",
    shortDesc: "When you activate your rage you can choose to gain only half the normal bonuses, take no penalty to ac, and also be able to use any skills and abilities that require concentration, and you are not fatigued when your rage ends. You cannot run or change while using this type of rage.",
    },
    {
    type: "universal",
    name: "Steady Gait",
    fromClass:"Dreadnought Barbarian",
    abilityType:"Ex",
    shortDesc: "You always keep moving until your enemies are destroyed, gain a +1 bonus on saving throws and to your CMD against effects that would slow or immbolize you. This bonus increases by 1 every 6 levels.",
    },
    {
    type: "universal",
    name: "Fearless Killer",
    fromClass:"Dreadnought Barbarian",
    abilityType:"Ex",
    shortDesc: "While raging you are immune to fear effects.",
    },
    {
    type: "universal",
    name: "Keen Senses",
    fromClass:"Superstitious Barbarian",
    abilityType:"Ex",
    shortDesc: "Gain low-light vision. At level 6 gain darkvision 60 feet. At level 10 gain scent 30 feet. At level 14 gain blindsense 30 feet. At level 18 gain blindsight 30 feet.",
    },
    {
    type: "universal",
    name: "Elemental Fury",
    fromClass:"Elemental Kin Barbarian",
    abilityType:"Ex",
    shortDesc: "Whenever you take an amount of energy damage equal to or greater than your level while raging you gain 1 spell point, +1 every 5 levels. If raging while taking the energy damage the spell point gain is doubled.",
    },
    {
    type: "universal",
    name: "Bloodlust",
    fromClass:"Fearsome Defender Barbarian",
    abilityType:"Ex",
    shortDesc: "A fearsome defender's eagerness for bloodshed makes her quicker to act in a fight. She adds her highest mental modifier to initiative checks and always acts during the surprise round. If the fearsome defender is surprised during the surprise round, she acts last in that round and then determines initiative order normally for the remainder of combat. If you are on a map with spawning waves (such as arena maps) you can when a wave spawns spend an immediate action to make up to your movement speed.",
    },
    {
        type: "rage",
        name: "Brawler",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "While raging your unarmed and light weapons have their damage dice increases by 1 step.",
    },
    {
        type: "rage",
        name: "Improved Brawler",
        fromClass:"Barbarian",
        abilityType:"Ex",
        prereq:"Brawler",
        shortDesc: "While raging your unarmed and light weapons have their damage dice increases by an additional 1 step.",
    },
    {
        type: "rage",
        name: "Greater Brawler",
        fromClass:"Barbarian",
        abilityType:"Ex",
        prereq:"Improved Brawler",
        shortDesc: "While raging your unarmed and light weapons have their damage dice increases by an additional 1 step, and their critical damage multiplier increases by 1 step.",
    },
    {
        type: "universal",
        name: "Rolling Dodge",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "The barbarian gains a +1 dodge bonus to her Armor Class against ranged attacks for a number of rounds equal to the barbarian's current Constitution modifier (minimum 1). This bonus increases by +1 for every 5 levels the barbarian has attained. Activating this ability is a move action that does not provoke an attack of opportunity.",
    },
    {
        type: "universal",
        name: "Battle Roar",
        fromClass:"Barbarian",
        abilityType:"Su",
        shortDesc: "Whenever you use the intimidate skill to demoralize an enemy, they take 1d6 points of sonic damage. Every 6 levels this increases by 1d6. This does not function when you would be unable to shout or be heard by the intimidated creature.",
    },
    {
        type: "universal",
        name: "Reflexive Dodge",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "The barbarian gains a +1 bonus to reflex saves for a number of rounds equal to the barbarian's current Constitution modifier (minimum 1). This bonus increases by +1 for every 5 levels the barbarian has attained. Activating this ability is a move action that does not provoke an attack of opportunity.",
    },
    {
        type: "universal",
        name: "Overbearing Advance",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "The barbarian inflicts damage equal to her Strength bonus whenever she succeeds at an overrun combat maneuver.",
    },
    {
        type: "universal",
        name: "Overbearing Onslaught",
        fromClass:"Barbarian",
        abilityType:"Ex",
        prereq:"Overbearing Advance",
        shortDesc: "While raging, the barbarian may overrun more than one target per round, with a -2 penalty on her CMB for each overrun check after the first.",
    },    
    {
        type: "universal",
        name: "Sharpened Accuracy",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "You can spend 4 spell point as a swift action to ignore the miss chance for concealment and treats total concealment as concealment. You also ignores cover penalties except those from total cover. If you have the surprise accuracy ability you can activate this and that ability as apart of the same action.",
    },
    {
        type: "universal",
        name: "Witch Hunter",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "The barbarian gains a +1 bonus on damage rolls against creatures possessing spells or spell-like abilities. This damage bonus increases by +1 for every three levels.",
    },
    {
        type: "rage",
        name: "Spell Sunder",
        fromClass:"Barbarian",
        abilityType:"Su",
        shortDesc: "Once per rage, the barbarian can attempt to sunder an ongoing spell effect by succeeding at a combat maneuver check. For any effect other than one on a creature, the barbarian must make her combat maneuver check against a CMD of 15 plus the effect's caster level. To sunder an effect on a creature, the barbarian must succeed at a normal sunder combat maneuver against the creature's CMD + 5, ignoring any miss chance caused by a spell or spell-like ability. If successful, the barbarian suppresses the effect for 1 round, or 2 rounds if she exceeded the CMD by 5 to 9. If she exceeds the CMD by 10 or more, the effect is dispelled.",
    },
    {
        type: "universal",
        name: "Strength Surge",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "You can spend level/2 spell points as an immediate action to gain a bonus equal to your level on your strength or combat maneuver check, or to be added to your CMD against the next maneuver against you.",
    },
    {
        type: "universal",
        name: "Terrifying Howl",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "The barbarian unleashes a terrifying howl as a standard action. All shaken enemies within 30 feet must make a Will save (DC=10 + level/2 + Strength modifier) or be panicked for 1d4+1 rounds. Once a creature has made a save against this ability it becomes immune to it, whether the save was successful or not.",
    },
    {
        type: "rage",
        name: "Good for What Ails You",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "You drink an alcoholic drink as a standard action as if drinking a potion, then you may attempt a new saving throw against one of the following affects that may be afflicting you: blinded, confused, dazzled, deafened, exhausted, fatigued, frightened, nauseated, panicked, shaken, or sickened (you can use this ability as a movement action if you are nauseated). If the save succeeds, the effect is suppressed for the duration of the rage. You may also attempt a new saving throw if poisoned; a successful save counts against those required for a cure, but a failed save has no ill effect. If you use this ability and fail the save, you are nauseated for 1 round, or dazed if you were nauseated. Only the specific condition from the specific source is suppressed, so if it is reapplied to you it still affects you as normal.",
    },
    {
        type: "rage",
        name: "Moment of Clarity",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "Once per rage the barbarian does not gain any benefits or take any of the penalties from rage for 1 round. Activating this power is a swift action. This includes the penalty to Armor Class and the restriction on what actions can be performed. You must still spend the spell points required to maintain rage during this round.",
    },
    {
        type: "rage",
        name: "Perfect Clarity",
        fromClass:"Barbarian",
        abilityType:"Ex",
        prereq:"Moment of Clarity",
        shortDesc: "While using her moment of clarity rage power, the barbarian can roll twice for any miss chance or Will saving throws to disbelieve illusions, taking the better result.",
    },
    {
        type: "rage",
        name: "Rage Caster",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "While raging, you can spend a swift action to remove the bonuses and penalties from rage for 1 round. When you do, you add your constitution bonus to the save DC of all spells cast while raging.",
    },
    {
        type: "rage",
        name: "Indomitable Caster",
        fromClass:"Barbarian",
        abilityType:"Ex",
        shortDesc: "You add your constitution bonus on concentration checks and can cast healing spells while raging without the added spell point cost.",
    },
    {
        type: "rage",
        name: "Ultimate Clarity",
        fromClass:"Barbarian",
        abilityType:"Ex",
        prereq:"Perfect Clarity",
        shortDesc: "Once per rage, the character can refine her senses, seeing through normal and magical darkness (including from magical effects such as blur and displacement), invisibility, and illusions; she can also discern the exact locations of creatures with concealment. This lasts for 1 round. The character does not need to be using moment of clarity to use this rage power.",
    },
    {
    type: "universal",
    name: "Surprise Accuracy",
    fromClass:"Barbarian",
    abilityType:"Ex",
    shortDesc: "You can spend 1 spell point as a swift action to gain a +1 bonus on your next melee attack roll. The bonus and price increases by 1 every 3 levels. This bonus is doubled when confirming a critical hit.",
    },
    {
        type: "universal",
        name: "Lethal Surprise",
        fromClass:"Barbarian",
        abilityType:"Ex",
        prereq:"Surprise Accuracy",
        shortDesc: "Your attacks modified by Surprise accuracy have their critical multiplier for damage increases by +1.",
    },
    {
        type: "universal",
        name: "Surprising Lethality",
        fromClass:"Barbarian",
        abilityType:"Ex",
        prereq:"Surprise Accuracy",
        shortDesc: "Your attacks modified by Surprise accuracy have their critical threat range increased by a flat +1.",
    },
    {
    type: "universal",
    name: "Extreme Endurance",
    fromClass:"Invulnerable Rager Barbarian",
    abilityType:"Ex",
    shortDesc: "Gain half your level in fire and cold resistance.",
    },
    {
    type: "universal",
    name: "Terrifying Visage",
    fromClass:"Scarred Rager Barbarian",
    abilityType:"Ex",
    shortDesc: "Add half your level on intimdate checks, and the DC of all fear effects you create also go up by +1.",
    },
    {
    type: "universal",
    name: "Scarification",
    fromClass:"Scarred Rager Barbarian",
    abilityType:"Ex",
    shortDesc: "Ignore 1 point of bleed damage per round, +1 every 3 levels. You reduce the damage you take from critical hits by 1, +1 per 3 levels. This stacks with DR and applies after other reductions.",
    },
    {
    type: "universal",
    name: "Tolerance",
    fromClass:"Scarred Rager Barbarian",
    abilityType:"Ex",
    shortDesc: `A scarred rager who fails a save against an effect that causes her to become nauseated, sickened, fatigued, or exhausted can make a second save to negate the effect on the start of her next turn. Only one additional save is allowed. If the effect does not allow a saving throw, its duration is halved instead (minimum of 1 round).`,
    },
    {
        type: "universal",
        name: "Improved Tolerance",
        fromClass:"Scarred Rager Barbarian",
        abilityType:"Ex",
        prereq:"Tolerance",
        shortDesc: `You can use Tolerance on the additional conditions: dazed, frightened, shaken, or stunned.`,
    },
    {
    type: "universal",
    name: "Skilled Thrower",
    fromClass:"Hurtler Barbarian",
    abilityType:"Ex",
    shortDesc: "Increase the range increment of all thrown weapons by 10 feet.",
    },
    {
    type: "rage",
    name: "Invulnerability",
    fromClass:"Invulnerable Rager Barbarian",
    abilityType:"Ex",
    shortDesc: "the invulnerable rager gains DR/— equal to half her barbarian level. This damage reduction is doubled against nonlethal damage.",
    },
    {
    type: "rage",
    name: "Raging Tactician",
    fromClass:"Pack Rager Barbarian",
    abilityType:"Ex",
    shortDesc: `When raging you grant a single teamwork feat you know to all allies within 30 feet who can see and hear you. You choose the feat at the start of the rage and cannot change it during the rage. An ally who moves further than 30 feet away from loses acces to the feat, but regains it if they move back within 30 feet of you.
    Each 8 levels you can select an additional teamwork feat to share with all teammates.
    At level 10 teammates only need to stay within 60 feet of you.
    At level 18 all allies within 60 feet have access to the teamwork feats as long as you are raging.`,
    },
    {
    type: "rage",
    name: "Beast Totem",
    shortDesc: `While raging, the barbarian gains two claw attacks. These attacks are considered primary attacks and are made at the barbarian's full base attack bonus. The claws deal 1d6 points of slashing damage plus the barbarian's Strength modifier. Getting this multiple times increases the damage of the claw attacks by 1 size step.`,
    },
    {
        type: "rage",
        name: "Improved Beast Totem",
        prereq:"Beast Totem",
        shortDesc: `While raging, the barbarian gains +1 natural armor bonus. This bonus increases by +1 for every three levels the barbarian has attained.`,
    },
    {
        type: "rage",
        name: "Greater Beast Totem",
        prereq:"Improved Beast Totem",
        shortDesc: `While raging, the barbarian gains the pounce special ability, allowing her to make a full attack at the end of a charge. In addition, the damage from her claw attacks granted by beast totem increase by 1 step their critical damage multiplier increases by +1.`,
    },
    {
        type: "rage",
        name: "Atavism Totem",
        shortDesc: `While raging you gain a bite attack. If you already had a bite attack, it deals damage as if it was 1 size larger.`,
    },
    {
        type: "rage",
        name: "Improved Atavism Totem",
        prereq:"Atavism Totem",
        shortDesc: `While raging you gain the ferocity ability: You remains conscious and can continue fighting even if your hit point total is below 0, you are still staggered and loses 1 hit point each round.`,
    },
    {
        type: "rage",
        name: "Greater Atavism Totem",
        prereq:"Improved Atavism Totem",
        shortDesc: `While raging you gain the Trample ability: As a full-round action, a creature with the trample ability can attempt to overrun any creature that is at least one size category Smaller than itself. This works just like the overrun combat maneuver, but the trampling creature does not need to make a check, it merely has to move over opponents in its path. Targets of a trample take an amount of damage equal to the trampling creature's slam damage + 1-1/2 times its Str modifier. Targets of a trample can make an attack of opportunity, but at a -4 penalty. If targets forgo an attack of opportunity, they can attempt to avoid the trampling creature and receive a Reflex save to take half damage. The save DC against a creature's trample attack is 10 + 1/2 the creature's HD + the creature's Str modifier (the exact DC is given in the creature's descriptive text). A trampling creature can only deal trampling damage to each target once per round, no matter how many times its movement takes it over a target creature.`,
    },
    {
        type: "rage",
        name: "Celestial Totem",
        shortDesc: `While raging you and subject to a spell or ability that magically cures hit point damage, you heals 1 additional point of damage per the caster's level. This does not affect fast healing or regeneration.`,
    },
    {
        type: "rage",
        name: "Improved Celestial Totem",
        prereq:"Celestial Totem",
        shortDesc: `While raging you are granted a halo of gleaming light that shines as if it were daylight and triggers an invisibility purge effect in adjacent squares. The invisibility purge only affects non-good creatures.`,
    },
    {
        type: "rage",
        name: "Greater Celestial Totem",
        prereq:"Improved Celestial Totem",
        shortDesc: `While raging you gain spell resistance equal to 11 + the level against spells with the evil descriptor. You also gains a +2 bonus on all saving throws against spells and effects from evil creatures.`,
    },
    {
        type: "rage",
        name: "Ancestor Totem",
        shortDesc: `When you enter a rage, you select a skill of your choice, which must be one you can use while raging, such as Climb or Intimidate. While raging, you gains a +4 insight bonus to the chosen skill.`,
    },
    {
        type: "rage",
        name: "Improved Ancestor Totem",
        prereq:"Ancestor Totem",
        shortDesc: `The insight bonus to your chosen skill increases to +8. You can now select any skill to receive this bonus, even a Charisma-, Dexterity-, or Intelligence-based skill or a skill that requires patience or concentration; if you select such a skill, ypu can use it even while raging.`,
    },
    {
        type: "rage",
        name: "Greater Ancestor Totem",
        prereq:"Improved Ancestor Totem",
        shortDesc: `The insight bonus to your chosen skill increases to +12. Once per rage, you can spend one round of rage as an immediate action to reroll a skill check in the chosen skill. You must take the result of the second roll, even if it is lower.`,
    },
    {
        type: "rage",
        name: "Chaos Totem",
        shortDesc: `While raging, the barbarian gains a +1 deflection bonus to AC against the attacks of lawful creatures and a +1 resistance bonus on saving throws against confusion, insanity, polymorph, and effects with the lawful descriptor. This bonus increases by +1 for each chaos totem rage power she possesses.`,
    },
    {
        type: "rage",
        name: "Improved Chaos Totem",
        prereq:"Chaos Totem",
        shortDesc: `While raging, the barbarian's form becomes infused with chaos. She gains a +4 bonus on Escape Artist checks and has a 25% chance to ignore extra damage from critical hits and sneak attacks.`,
    },
    {
        type: "rage",
        name: "Greater Chaos Totem",
        prereq:"Improved Chaos Totem",
        shortDesc: `While raging, the barbarian gains DR/lawful equal to 1/2 her barbarian level. Her weapons and natural weapons are considered chaotic for the purpose of overcoming damage reduction. This stacks with all other damage reduction.`,
    },
    {
        type: "rage",
        name: "Cult Totem",
        shortDesc: `While the barbarian is raging, any morale bonuses or bonuses for flanking she gains on attacks rolls are added to her damage rolls instead of her attack rolls. They are still morale bonuses, and they don't stack with other morale bonuses on damage rolls.`,
    },
    {
        type: "rage",
        name: "Improved Cult Totem",
        prereq:"Cult Totem",
        shortDesc: `The barbarian can make an attack of opportunity against a creature within her reach who damages an ally of the barbarian with a melee attack. Only the enemy, not the barbarian's ally, needs to be within the barbarian's melee reach in order for the barbarian to make this attack of opportunity. Once the barbarian makes an attack of opportunity against a creature with this ability, she can't use this ability to make an attack of opportunity against the same creature for 24 hours.`,
    },
    {
        type: "rage",
        name: "Greater Cult Totem",
        prereq:"Improved Cult Totem",
        shortDesc: `While the barbarian is raging, when she takes hit point damage that would render her dying or dead, she remains conscious and raging until the end of her next turn after taking that damage, though she is disabled during that turn. She becomes dying or dead at the end of her next turn as normal for her current hit point total.
        \nThis ability has no effect if the barbarian dies from a cause other than hit point damage, such as from a death effect or if her Constitution damage exceeds her Constitution score.`,
    },
    {
        type: "rage",
        name: "Daemon Totem",
        shortDesc: `While raging, the barbarian gains a +4 bonus on saving throws against acid damage, death effects, disease, and poison. This bonus increases by +2 for each daemon totem rage power the barbarian has, excluding this one.`,
    },
    {
        type: "rage",
        name: "Improved Daemon Totem",
        prereq:"Daemon Totem",
        shortDesc: `While the barbarian is raging, her melee attacks impose a temporary negative level on her opponent on a successful critical hit. After 1 hour, these temporary negative levels disappear automatically (without a saving throw).`,
    },
    {
        type: "rage",
        name: "Greater Daemon Totem",
        prereq:"Improved Daemon Totem",
        shortDesc: `If the barbarian kills an intelligent creature with a CR equal to at least half her character level while raging, she heals level hit points. If she is already at her maximum number of hit points, she instead gains 5 temporary hit points, which stack if she kills multiple creatures.`,
    },
    {
        type: "rage",
        name: "Dragon Totem",
        shortDesc: `The barbarian must select a single color of dragon (black, blue, brass, bronze, copper, gold, green, red, silver, or white) as her totem. While raging, she gains a +2 bonus on Perception checks and a +2 morale bonus on saving throws against fear, paralysis, and sleep effects. This bonus increases by +2 for each additional dragon totem rage power (such as dragon totem resilience and dragon totem wings) the barbarian possesses.`,
    },
    {
        type: "rage",
        name: "Improved Dragon Totem",
        prereq:"Dragon Totem",
        shortDesc: `While raging, the barbarian gains resistance to the energy type that is associated with her dragon totem—acid (black, copper, green), cold (silver, white), electricity (blue, bronze), or fire (brass, gold, red). This resistance equals half her level; this energy resistance increases by 4 for each dragon totem rage power she possesses, including this one.`,
    },
    {
        type: "rage",
        name: "Greater Dragon Totem",
        prereq:"Improved Dragon Totem",
        shortDesc: `While raging and wearing medium or lighter armor, the barbarian can spend a standard action to manifest a pair of spiritual dragon wings that grant her a fly speed equal to her base speed (average maneuverability). She can expend 2 rounds of her rage to instead spend an immediate action to gain this fly speed. She can end her fly speed at any time, even when it is not her turn. Each round she spends raging and flying counts as 2 rounds of rage. Her ability to fly ends automatically when she ceases raging.`,
    },
    {
        type: "rage",
        name: "Fiend Totem",
        shortDesc: `While raging, the barbarian grows a pair of large horns, gaining a gore attack. This attack is a primary attack (unless she is also attacking with weapons, in which case it is a secondary attack) and is made at the barbarian's full base attack bonus (-5 if it is a secondary attack). The gore attack deals 1d8 points of piercing damage (1d6 if Small) plus the barbarian's Strength modifier (1/2 if it is a secondary attack).`,
    },
    {
        type: "rage",
        name: "Improved Fiend Totem",
        prereq:"Fiend Totem",
        shortDesc: `While raging, the barbarian sprouts dozens of wicked barbs from her body. Anyone striking the barbarian with a melee weapon, an unarmed strike, or a natural weapon takes 1d6 points of piercing damage.`,
    },
    {
        type: "rage",
        name: "Greater Fiend Totem",
        prereq:"Improved Fiend Totem",
        shortDesc: `While raging, the barbarian is surrounded by an aura of menace. Good creatures adjacent to the barbarian are shaken and take 2d6 points of slashing damage at the beginning of the barbarian's turn as dozens of small cuts open across their flesh. Neutral creatures that are adjacent to the barbarian are shaken, but do not take any damage. Evil creatures are unaffected.`,
    },
    {
        type: "rage",
        name: "Moon Totem",
        shortDesc: `While raging, the barbarian gains darkvision with a range of 30 feet. If the barbarian already has darkvision, the range of her darkvision increases by 30 feet while she is raging.`,
    },
    {
        type: "rage",
        name: "Improved Moon Totem",
        prereq:"Moon Totem",
        shortDesc: `While raging, the barbarian gains a bonus equal to her level on Perception checks to pinpoint the location of an unseen creature, and unseen attackers gain no bonus on attacks against the barbarian.`,
    },
    {
        type: "rage",
        name: "Greater Moon Totem",
        prereq:"Improved Moon Totem",
        shortDesc: `While raging, the barbarian ignores the miss chance for concealment and treats total concealment as concealment.`,
    },
    {
        type: "rage",
        name: "Lunar Totem",
        shortDesc: `While raging, the barbarian gains a +2 insight bonus to AC and on saving throws against undead and creatures with the shapechanger subtype. This bonus increases by +1 for each lunar totem rage power the barbarian possesses, excluding this one.`,
    },
    {
        type: "rage",
        name: "Improved Lunar Totem",
        prereq:"Lunar Totem",
        shortDesc: `While raging, the barbarian increases her bite damage die type with her bite attack by one die type, and the bite deals x3 damage on a critical hit. She always adds her full strength bonus to her bite attack, even when performing a full attack with other weapons. When making a full attack with manufactured weapons and her bite attack (and no other natural weapons), the penalty for using her bite decreases to -2.`,
    },
    {
        type: "rage",
        name: "Greater Lunar Totem",
        prereq:"Improved Lunar Totem",
        shortDesc: `When raging, the barbarian gains DR/silver equal to half her barbarian level. She also gains a +4 bonus on saving throws against curses while raging.`,
    },
    {
        type: "rage",
        name: "Death Totem",
        shortDesc: `While raging, the barbarian gains DR 5/bludgeoning and a +2 resistance bonus against cold-based spells and effects.`,
    },
    {
        type: "rage",
        name: "Improved Death Totem",
        prereq:"Death Totem",
        shortDesc: `While raging, whenever the barbarian makes a Fortitude saving throw, she can roll twice and choose the best result.`,
    },
    {
        type: "rage",
        name: "Greater Death Totem",
        prereq:"Improved Death Totem",
        shortDesc: `While raging, the death energy that surrounds the barbarian becomes dangerous to any enemy adjacent to the savage. Living enemies adjacent to the barbarian at the start of her turn take 1d8 points of negative energy damage. In addition, any living enemy within 10 feet of the barbarian must make a Fortitude saving throw (DC 10 + ½ level + Constitution modifier) or become sickened for 1d6 rounds.`,
    },
    {
        type: "rage",
        name: "Shadow Totem",
        abilityType:"Su",
        shortDesc: `While raging, each time the barbarian confirms a critical hit her weapon surges with draining shadows. The target must succeed at a Fortitude saving throw (DC = 10 + 1/2 level + Constitution modifier) or take 1d4 Strength damage. The DC of this increases by +2 for every additional shadow totem perk you possess. This is a negative energy effect.`,
    },
    {
        type: "rage",
        abilityType:"Su",
        name: "Improved Shadow Totem",
        prereq:"Shadow Totem",
        shortDesc: `Once per rage as a swift action, the barbarian can take on a shadowy form until the end of her turn. While in this form, she gains the incorporeal subtype. She takes half damage from corporeal sources as long as they are magic (and no damage from non-magic weapons and objects). Likewise, any magical effects she creates deal only half damage to corporeal creatures. Her manufactured and natural weapons count as ghost touch weapons while incorporeal in this manner. Spells and other effects that do not deal damage function normally. She can pass through a wall or other surface that is up to 5 feet thick per barbarian level while she is incorporeal. She must exit the solid material by the end of her turn.`,
    },
    {
        type: "rage",
        abilityType:"Su",
        name: "Greater Shadow Totem",
        prereq:"Improved Shadow Totem",
        shortDesc: ` While raging, the barbarian gains the see in darkness ability, allowing her to see perfectly to any distance in darkness, including magical darkness. She is immune to blindness while raging. In addition, the Strength damage she deals on critical hits from her lesser shadow totem increases to 1d6.`,
    },
    {
        type: "rage",
        name: "Honor Totem",
        shortDesc: `When you activate rage, you choose a target you can see and can hear you, and you shout a challenge at them. You take a -4 penalty to attack creatures other than this creature until it has been defeated, and you take a -4 penalty on AC against all creatures other than them, However you gain a +4 bonus on damage against the challenged creature. For each additional honor totem you possess, this bonus damage increases by +2.`,
    },
    {
        type: "rage",
        name: "Improved Honor Totem",
        prereq:"Honor Totem",
        shortDesc: `Once you have slain the target of your challenge, you can choose to challenge a new creature as a swift action, without having to end your rage. Additionally, after slaying the target of a challenge, you also gain a honor point you can use (even lasting through floors), this honor point can be used for one of the various effects:
        \nDetermined: As a standard action to supress the fatigued, shaken, or sickened conditions for 1 hour. At level 8 you can also supress frightened, nauseated, or staggered.
        \nResolute: As an immediate action before you make a fortitude or will saving throw, you can roll twice taking the better result
        \nUnstoppable: As an immediate action when reduced below 0 hit points but not slain, you instantly stabalize and remain conscious. You are staggered, but do not fall unconscious unless you take additional damage.`,
    },
    {
        type: "rage",
        name: "Greater Honor Totem",
        prereq:"Improved Honor Totem",
        shortDesc: `You can spend honor points in additional ways:
        \nUnfliching: As an immediate action when a critical hit is confirmed against you, you can turn it into a regular hit.
        \nTrue Resolve: As an immediate action you spend all honor points you have, but at least 2, when you do, you reduce the damage of a single source of damage to 0.`,
    },
    {
        type: "rage",
        name: "Spire Totem",
        shortDesc: `While raging, the barbarian gains a +2 morale bonus on attacks against any creature that has targeted one of her allies with an attack or a harmful spell within the last round. For each additional spire totem perk you have, this bonus increases by +2.`,
    },
    {
        type: "rage",
        name: "Improved Spire Totem",
        prereq:"Spire Totem",
        shortDesc: `While raging, the barbarian takes no penalties for using a weapon to deal nonlethal damage. When dealing nonlethal damage, the barbarian adds a bonus equal to half her barbarian level on her damage rolls.`,
    },
    {
        type: "rage",
        name: "Greater Spire Totem",
        prereq:"Improved Spire Totem",
        shortDesc: `While the barbarian is raging, all allies within 30 feet gain a +2 morale bonus on Will saves.
        When attempting a Will save against a fear effect, all allies within this area can roll twice and use the better result.`,
    },
    {
        type: "rage",
        name: "Spirit Totem",
        shortDesc: `While raging, the barbarian is surrounded by spirit wisps that harass her foes. These spirits make one slam attack each round against a living foe that is adjacent to the barbarian. This slam attack is made using the barbarian's full base attack bonus, plus the barbarian's highest mental modifier. The slam deals 1d4 points of negative energy damage, plus the barbarian's highest mental modifier.`,
    },
    {
        type: "rage",
        name: "Improved Spirit Totem",
        prereq:"Spirit Totem",
        shortDesc: `While raging, the spirits that surround the barbarian make it difficult for her enemies to see her. The spirits grant the barbarian a 20% miss chance against ranged attacks and melee attacks made by creatures that are not adjacent to the barbarian (typically due to reach).`,
    },
    {
        type: "rage",
        name: "Greater Spirit Totem",
        prereq:"Improved Spirit Totem",
        shortDesc: `While raging, the spirits that surround the barbarian become dangerous to any enemy adjacent to the barbarian. Living enemies adjacent to the barbarian at the start of her turn take 1d8 points of negative energy damage. In addition, the spirit wisps can now attack foes that are up to 15 feet away from the barbarian and the slam attack deals 1d6 points of negative energy damage.`,
    },             
    {
        type: "rage",
        name: "World Serpent Totem",
        shortDesc: `While raging, the barbarian gains a +2 insight bonus to AC against outsiders and aberrations. This bonus increases by +2 for each world serpent rage power the barbarian possesses, excluding this one.`,
    },
    {
        type: "rage",
        name: "Improved World Serpent Totem",
        prereq:"World Serpent Totem",
        shortDesc: `While raging, the barbarian considers her weapons to be chaotic-, evil-, good-, and lawful-aligned for the purposes of overcoming damage reduction. She also gains a +1 resistance bonus on saving throws against spells and effects that have an alignment descriptor or come from an outsider or aberration. This bonus increases by +1 for each world serpent rage power the barbarian possesses, excluding this one.`,
    },
    {
        type: "rage",
        name: "Greater World Serpent Totem",
        prereq:"Improved World Serpent Totem",
        shortDesc: `While raging, the barbarian gains a +10 bonus to land speed and cannot be knocked prone. She also doubles her world serpent totem insight bonus to AC against attack rolls made by an outsider or aberration to confirm a critical hit against her.`,
    },
    {
        type: "universal",
        name: "Hurling Charge",
        shortDesc: `making a charge attack, the barbarian may draw and throw a hurled weapon during her charge, gaining the normal +2 attack roll bonus on the thrown weapon attack as well as on the melee attack at the end of the charge. The barbarian must move at least 10 feet before using a thrown weapon and at least 10 additional feet before making a melee attack at the end of her charge. The barbarian must have a thrown weapon in hand or have one hand free at the beginning of her charge.`,
    },
    {
        type: "universal",
        name: "Enduring Rage",
        shortDesc: `You gain your constitution modifier as a bonus to your spell points. Every 6 levels add it again. Temporary changes to your constitution do not modify this.`,
    },  
    {
        type: "universal",
        name: "Disemboweling Attacks",
        shortDesc: `When you confirm a critical hit with a natural attack, you can spend 4 spell points to deal 1d2 points of constitution damage in addition to the normal damage.`,
    },
    {
        type: "universal",
        name: "Bloody Fist",
        shortDesc: `The barbarian may attempt to punch through an opponent's flesh and rip out one of its vital organs. In order to do so, the barbarian must confirm a critical hit against an opponent with a natural attack, light weapon, or natural attack, and then spend 8 spell points. The barbarian deals damage as normal for a critical hit and the opponent must succeed at a Fortitude save (DC = 10 + 1/2 level + Strength modifier) or take 1d4 points of Constitution damage as one of its vital organs is ripped free from its body.`,
    },
    {
        type: "universal",
        name: "Feast on Blood",
        prereq:"Bloody Fist",
        shortDesc: `After successfully ripping out a creature's vital organ, the barbarian may eat the organ within 1 minute of extracting it as a full-round action that provokes attacks of opportunity.
        \nOnce the organ is consumed, the barbarian recovers a number of hit points equal to 2x Hit Dice of the organ's owner. In addition, the barbarian gains any energy immunities or resistances the victim had, though the effectiveness of these resistances is halved (for instance, a barbarian who eats the heart of a creature with resist cold 10 would gain resist cold 5; energy immunities are reduced to resist energy 20). This energy resistance lasts for a number of rounds equal to half the Hit Dice of the creature whose organ was consumed.`,
    },
    {
        type: "universal",
        name: "Crippling Blow",
        shortDesc: `A a swift action for level/2 spell points you can empower your next melee attack taken this round to deal additional ability score damage. The damage is 1 point per 4 levels, and the target can make a fortitude save dc=10+ level/2 + strength mod to halve the damage.`,
    },
    {
        type: "universal",
        name: "Bloody Attacks",
        shortDesc: `Your natural attacks deal 1d6 points of bleed damage in addition to any other damage they deal.`,
    },
    {
        type: "universal",
        name: "Quick Reflexes",
        shortDesc: `You gain 1 additional attack of opportunity a round, for every 5 BAB you have you gain another attack of opportunity. Additionally, when making an attack of opportunity you gain a +1 bonus to the attack and damage roll, increasing by +1 every 4 levels.`,
    },
    {
        type: "universal",
        name: "Primal Scent",
        shortDesc: `If you have the scent special ability, you gain a bonus equal to your level to perception checks to determine a creatures square, and if you do determine it, you treat the creature as having concealment instead of total concealment.`,
    },
    {
    type: "universal",
    name: "Beastial Leaper",
    shortDesc: "The barbarian can take a move action to move and can take her normal standard action at any point during the move.",
    },        
    {
    type: "universal",
    name: "Boasting Taunt",
    shortDesc: "The barbarian can incite a creature to attack her by making an Intimidate check to demoralize. If you have an ability that allows you to intimidate multiple creatures roll once and all creatures can make a will save again that check. If the check succeeds, the target is also shaken as long as the barbarian is visible or until it makes a melee attack against the barbarian. This is a language-dependent mind-affecting effect, and it relies on audible components",
    },
    {
    type: "universal",
    name: "Body Bludgeon",
    shortDesc: "If you pin an opponent that is your size or smaller, you can then use that opponent as a two-handed improvised weapon that deals 1d8 points of bludgeoning damage, assuming the opponent is sized Small. For each size larger than small the creature is the damage dice goes up by 2 dice steps. If the creature you are wielding is the same size as the you, you gain a -4 to attack. You can make a single attack using the pinned opponent as part of the action you use to maintain the grapple, using your highest attack bonus. Whenever you hit using the pinned opponent as a weapon, you deals damage to your target normally, and the grappled opponent used as a bludgeon also takes the same damage you dealt to the target. If the pinned opponent is unable to resist being pinned for any reason, you can use that opponent as an improvised weapon without grappling or pinning the opponent, until the creature is reduced to 0 or fewer hit points, at which point the creature becomes useless as an improvised weapon.",
    },
    {
    type: "universal",
    name: "Clear Mind",
    shortDesc: "As an immediate action for 4 spell points, A barbarian may reroll a failed Will save. This power is used after the first save is attempted, but before the results are revealed by the GM. The barbarian must take the second result, even if it is worse.",
    },
    {
        type: "universal",
        name: "Energy Resistance",
        shortDesc: "Choose one energy type, gain energy resistance to it equal to half your level.",
        
    },
    {
        type: "universal",
        name: "Improved Energy Resistance",
        shortDesc: "Once per rage, or once per day if you do not have rage, a barbarian can reduce damage by half from a single attack against which she has energy resistance (halve the damage, then apply resistance).",
        prereq:"Energy Resistance"
    },
    {
        type: "universal",
        name: "Greater Energy Resistance",
        shortDesc: "Once per rage, or once per day if you do not have rage, the barbarian can absorb energy from a single attack of her chosen energy type. She does not make a saving throw against the effect but takes no damage from it, instead gaining 1 temporary hit point per 3 points of damage the attack would have inflicted. These temporary hit points last until the end of the barbarian's rage, or your highest mental modifier if you do not have rage.",
        prereq:"Improved Energy Resistance"
    },
    {
        type: "universal",
        name: "Energy Eruption",
        shortDesc: "You can use Greater Energy Resistance an additional time per rage or day. When you use it, your attacks with melee weapons deal an additional 1d6 points of damage of that energy type during the duration of the temporary hit points (whether you still have temporary hit points left or not). You can end this effect as a standard action to unleash the energy absorbed as a breath weapon, either in a 60-foot line or 30-foot cone, it deals damage equal to the amount of damage absorbed, but creatures may make a reflex save (DC 10+ level/2 + con mod) to half the damage, even if the original effect did not allow a save.",
        prereq:"Greater Energy Resistance"
    },
    {
    type: "universal",
    name: "Deathless Frenzy",
    shortDesc: "For 3 spell points, you can ignore the effects of being at 0 or fewer hit points until you have been at 0 or fewer hit points for 1 round, at which point the appropriate consequences for your current hit point total take effect. Even death can be postponed this way, potentially allowing you to survive if you receive sufficient healing before the round is up.",
    },
    {
    type: "rage",
    name: "Disruptive",
    shortDesc: "When raging, the DC to cast spells defensively increases by +4 for all enemies that are within your threatened area.",
    },
    {
    type: "rage",
    name: "Eater of Magic",
    shortDesc: "Once per rage, when a barbarian fails a saving throw against a spell, supernatural ability, or spell-like ability, she can reroll the saving throw against the effect (this is not an action). If she succeeds at the second saving throw, she is not affected by the spell, supernatural ability, or spell-like ability and gains a number of temporary hit points equal to the effect's caster level (in the case of spell or spell-like abilities) or the CR of the effect's creator (in the case of supernatural abilities). These temporary hit points last until damage is applied to them or 1 minute, whichever occurs first",
    },
    {
    type: "rage",
    name: "Elemental Rage",
    shortDesc: `As a swift action for 2 spell points, the barbarian can cause her melee attacks to deal an additional 1d6 points of energy damage (acid, cold, electricity, or fire) for 1 round.`,
    },
    {
        type: "rage",
        name: "Improved Elemental Rage",
        shortDesc: `While raging, all of the barbarian's melee attacks deal an additional 1d6 points of energy damage (acid, cold, electricity, or fire). The type is chosen when the barbarian begins her rage. You can still spend a swift action to add an additional 1d6 damage, and it costs 1 spell point less.`,
        prereq:"Elemental Rage"
    },
    {
        type: "rage",
        name: "Greater Elemental Rage",
        shortDesc: `While raging, all of the barbarian's critical hits made with melee weapons deal an additional 1d10 points of energy damage per crit multiplier of the weapon. The type of this damage is the same as the type chosen for the improved elemental rage power. Using elemental rage as a swift action now only costs 1 spell point, however you can spend 4 additional spell points to activate it as a free action instead (you can still only activate elemental rage once per round).`,
        prereq:"Improved Elemental Rage"
    },
    {
    type: "universal",
    name: "Fearless Rage",
    shortDesc: "You are immune to the shaken and frightened conditions.",
    },
    {
    type: "universal",
    name: "Feasting Bite",
    shortDesc: "When the barbarian confirms a critical hit with her bite attack, she regains a number of hit points equal to half the damage dealt. Activating this ability consumes 4 spell points.",
    },
    {
    type: "universal",
    name: "Fueled by Vengeance",
    shortDesc: "whenever you deal weapon damage to a creature that dealt damage to you since the end of your last turn, gain spell points equal to the cost of 1 round of rage. If you dont have rage you can regain 1 spell point instead. This affect can only activate once per round.",
    },
    {
    type: "universal",
    name: "Increased Damage Reduction",
    shortDesc: "The barbarian's damage reduction increases by 2/—. This stacks with all other forms of DR.",
    },
    {
        type: "universal",
        name: "Penetrating Ferocity",
        shortDesc: "Your natural attacks is treated as a magic weapon for the purposes of penetrating damage reduction and attacking incorporeal creatures.At 7th level, your natural attacks are also treated as cold iron and silver for the purpose of overcoming damage reduction. At 10th level, your natural attacks are also treated as a chaotic weapon for the purpose of overcoming damage reduction. At 16th level, your natural attacks are treated as an adamantine weapon for the purpose of overcoming damage reduction and bypassing hardness.",
    },
    {
        type: "universal",
        name: "Powerful Blow",
        shortDesc: "For 1 spell points you can as swift action gain a +2 bonus to the damage of your next weapon attack. Every 3 levels the bonus increases by +2, and the cost increases by 1 spell point.",
    },
    {
        type: "universal",
        name: "Come and Get Me",
        shortDesc: "As a free action you may spend 4 spell points to leave yourself open to attack while preparing devastating counterattacks. Enemies gain a +4 bonus on attack and damage rolls against you until the beginning of your next turn, but every attack against you provokes an attack of opportunity from you, which is resolved prior to resolving each enemy attack.",
    },
    {
    type: "universal",
    name: "Mighty Swing",
    shortDesc: "When you threaten a critical hit, you can spend 8 spell points as an immediate action to automatically confirm it.",
    },
    {
    type: "universal",
    name: "No Escape",
    shortDesc: "The barbarian can move up to double her normal speed as an immediate action but she can only use this ability when an adjacent foe uses a withdraw action to move away from her. She must end her movement adjacent to the enemy that used the withdraw action. The barbarian provokes attacks of opportunity as normal during this movement.",
    },
    {
    type: "rage",
    name: "Renewed Vigor",
    abilityType:"Ex",
    shortDesc: `As a movement action while raging you can spend 5 spell points to heal a number of hit points of damage equal to 1d8+level. You can use this ability as a standard action to instead heal 2d8 + level x2 hit points, or as a full-round action to heal 4d8 + levelx2 hit points.`,
    },
    {
        type: "rage",
        name: "Renewed Vitality",
        abilityType:"Ex",
        shortDesc: `The barbarian gains fast healing 1 for every 6 levels she has after using her renewed vigor rage power until her current rage ends. She regains hit points from fast healing at the start of each of her turns. This doesn't stack with itself.`,
        prereq:"Renewed Vigor"
    },
    {
        type: "rage",
        name: "Renewed Life",
        abilityType:"Ex",
        shortDesc: `The barbarian ignores the effect of one temporary negative level per four barbarian levels she has. Once per day, when a barbarian with temporary negative levels ends her rage, she can attempt saving throws to remove a number of negative levels equal to the number of levels she could ignore while raging.`,
        prereq:"Renewed Vitality"
    },
    {
    type: "rage",
    name: "scent",
    shortDesc: "The barbarian gains the scent ability while raging and can use this ability to locate unseen foes (see Special Abilities for rules on the scent ability).",
    },
    {
        type: "universal",
        name: "Raging Grappler",
        shortDesc: "Whenever you succeed at a check to start a grapple, you can choose to deal damage with a natural attack or unarmed attack, as if maintaining a grapple. In addition, whenever you succeed at a combat maneuver check to maintain a grapple, you can choose to give yourself, the target of your grapple, or both the prone condition as a free action while continuing to maintain the grapple.",
    },
    {
    type: "rage",
    name: "Raging Caster",
    shortDesc: "You can cast spells without increasing their cost while raging.",
    },
    {
        type: "rage",
        name: "Raging Destruction",
        shortDesc: "While raging, your damage spells deal an additional 1 damage per dice rolled, and their DC increases by +1. When you reach level 5,10, and 16, the bonus to damage per dice and DC's both increase by +1.",
        },
    {
        type: "universal",
        name: "Intimidating Glare",
        shortDesc: "You can make an Intimidate check against one adjacent foe as a move action. If you successfully demoralizes the opponent, the foe is shaken for 1d4 rounds + 1 round for every 5 points by which your check exceeds the DC.",
    },
    {
        type: "universal",
        name: "Hurling",
        shortDesc: "Increase the damage dice of all thrown weapons by 1 step. When throwing rocks, it instead becomes 2 steps.",
    },
    {
        type: "universal",
        name: "Improved Hurling",
        prereq:"Hurling",
        shortDesc: "Increase the damage dice of all thrown weapons by 1 step, and their range increment by 10 feet. When throwing rocks, it instead becomes 2 steps, and increase their range increment by 20 feet. These bonuses stack with those provided by other hurling perks.",
    },
    {
        type: "universal",
        name: "Greater Hurling",
        prereq:"Improved Hurling",
        shortDesc: "Increase the damage dice of all thrown weapons by 1 step, and their range increment by 10 feet. When throwing rocks, it instead becomes 2 steps, increase their range increment by 20 feet, and rocks gain a +2 bonus on their critical damage multiplier. These bonuses stack with those provided by other hurling perks.",
    },
    {
    type: "rage",
    name: "Spellbreaker",
    shortDesc: "When raging, enemies in your threatened area that fail their checks to cast spells defensively provoke attacks of opportunity from you.",
    },
    {
    type: "universal",
    name: "Unexpected Strike",
    shortDesc: "The barbarian can spend 5 spell points to make an attack of opportunity against a foe that moves into any square threatened by the barbarian, regardless of whether or not that movement would normally provoke an attack of opportunity.",
    },
    {
    type: "rage",
    name: "Superstition",        
    shortDesc: "The barbarian gains a +2 morale bonus on saving throws made to resist spells, supernatural abilities, and spell-like abilities. This bonus increases by +1 for every 3 levels the barbarian has attained. While raging the barbarian cannot be a willing target of any spell and must make saving throws to resist all spells, even those cast by allies.",
    },
    {
    type: "universal",
    name: "Accurate Stance",
    shortDesc: "The barbarian can focus her strikes. She gains a +1 competence bonus on melee attack rolls and thrown weapon attack rolls. This bonus increases by 1 for every 4 levels the barbarian has. This is a stance rage power and can stack with other stances that aren't barbarian stances and be used even while not raging.",
    },
    {
    type: "universal",
    name: "Guarded Stance",
    shortDesc: "The barbarian can take on a more defensive posture. This grants her a +1 dodge bonus to her Armor Class. This bonus increases by 1 for every 4 levels the barbarian has. This is a stance rage power and can stack with other stances that aren't barbarian stances and be used even while not raging.",
    },
    {
    type: "universal",
    name: "Lethal Accuracy",
    shortDesc: "The barbarian's critical multiplier for damage increases by +1 (a ×2 multiplier becomes ×3, a ×3 multiplier becomes ×4, and a ×4 multiplier becomes ×5 etc.).",
    },
    {
    type: "universal",
    name: "Powerful Stance",
    shortDesc: "The barbarian can focus her ferocity. She gains a +1 bonus on melee damage rolls and thrown weapon damage rolls. This bonus increases by 1 for every 4 levels the barbarian has. This is a stance rage power and can stack with other stances that aren't barbarian stances and be used even while not raging.",
    },
    {
    type: "universal",
    name: "Reckless Abandon",
    shortDesc: "The barbarian can attack with abandon at the expense of her defense. She gains a +1 bonus on attack rolls, but takes a -1 penalty to AC. This bonus and penalty increase by 1 at 4th level and every 4 levels thereafter.",
    },
    {
        type: "universal",
        name: "Inspire Ferocity",
        prereq:"Reckless Abandon",
        shortDesc: "You can use a move action to impart your reckless abandon modifier to all willing allies within 30 feet for a number of rounds equal to your highest mental modifier (minimum 1). When you do this, you also increase the bonus to attack and AC you gain by 50% for those rounds.",
    },
    {
    type: "universal",
    name: "Regenerative Stance",
    shortDesc: "The barbarian can continually replenish her health. At the start of her turn, she regains 1 temporary hit point for every 4 levels she has. You cannot gain more than 2 temporary hitpoints per level at a single time. This is a stance rage power and can stack with other stances that aren't barbarian stances and be used even while not raging.",
    },
    {
    type: "universal",
    name: "Strength Stance",
    shortDesc: "The barbarian can summon mighty strength. She gains a +1 competence bonus on combat maneuvers and to her CMD. These bonuses increase by 1 for every 4 levels the barbarian has. In addition, she gains a +8 competence bonus on Strength checks to lift, push, bend, or break objects (this does not apply to combat maneuvers). This is a stance rage power and can stack with other stances that aren't barbarian stances and be used even while not raging.",
    },
    {
    type: "rage",
    name: "Roused Anger",
    shortDesc: "The barbarian can enter a rage even when fatigued. If the barbarian enters a rage while fatigued, she loses the fatigued condition and she does not gain temporary hit points from rage. Once this rage ends, the barbarian is exhausted for 10 minutes",
    },
    {
    type: "universal",
    name: "Shove Aside ",
    shortDesc: "Whenever the barbarian charges, she may push past one of her allies. That ally does not block the path of the charge as long as the ally is not adjacent to the target of the charge. This does not move the ally's position; it simply allows the barbarian to move past.",
    },
    {
    type: "universal",
    name: "Swift Foot",
    shortDesc: "The barbarian gains a 10-foot enhancement bonus to her base speed, which increases by an additional 5 feet if the barbarian is raging",
    },
    {
    type: "universal",
    name: "Taunting Stance",
    shortDesc: "The barbarian can leave herself open to attacks while preparing devastating counterattacks. Enemies gain a +4 bonus on attack and damage rolls against the barbarian while she's in this stance, but every attack against the barbarian provokes an attack of opportunity from her, which is resolved prior to each provoking attack. This is a stance rage power and can stack with other stances that aren't barbarian stances and be used even while not raging.",
    },                
]
export const gambits = [
{
    name: "Acrobatic Gambit",
    requirement: "The warlord makes an Acrobatics check to move through a creature's threatened area without provoking attacks of opportunity.",
    bonus: "The warlord and each of his allies gains a morale bonus equal to the warlord's initiation modifier on the damage roll of the next attack they make against that creature before the start of the warlord's next turn.",
    },
    {
    name: "Brave Gambit",
    requirement: "The warlord makes a charge attack (if he has the ability to make multiple attacks on a charge, only the first attack roll gains the benefits of the gambit, and that attack must be successful for the gambit to succeed).",
    bonus: "The warlord and each of his allies gain a morale bonus equal to the warlord's initiation modifier on the damage roll of the next attack they make before the start of the warlord's next turn.",
    },
    {
    name: "Battering Ram Gambit",
    requirement: "The warlord attempts an overrun combat maneuver against an opponent.",
    bonus: "Other allies adjacent to the overruned opponent may make an attack of opportunity against that creature.",
    },
    {
    name: "Chessmaster's Gambit",
    requirement: "The warlord attempts a reposition combat maneuver against an opponent.",
    bonus: "The warlord is able to move the opponent into an undesirable position, and that opponent takes a penalty to their AC equal to the warlord's initiation modifier until the start of the warlord's next turn.",
    },
    {
    name: "Dastardly Gambit",
    requirement: "The warlord makes a dirty trick attempt.",
    bonus: "The warlord and each of his allies gain a morale bonus equal to the warlord's initiation modifier on the damage roll of the next attack they make before the start of the warlord's next turn.",
    },
    {
    name: "Duelist's Gambit",
    requirement: "The warlord makes a disarm attempt.",
    bonus: "The warlord can make an attack of opportunity against the disarmed opponent. If he hits, he gain a morale bonus on the damage roll equal to his warlord initiation modifier.",
    },
    {
    name: "Flanker's Gambit",
    requirement: "The warlord attacks an opponent adjacent to one of the warlord's other allies.",
    bonus: "The warlord is considered to be flanking that opponent until the end of her next turn, even if the warlord is not in a position that would allow him to flank them.",
    },
    {
    name: "Gatecrasher Gambit",
    requirement: "The warlord makes a bull rush attempt.",
    bonus: "The opponent is so rattled by the warlord's deft bull rush, that he suffers a penalty equal to his warlord initiation modifier for one round on all d20 rolls.",
    },
    {
    name: "Grappler Gambit",
    requirement: "The warlord makes a grapple attempt (but not a grapple check in response to being grappled).",
    bonus: "When the warlord has the successfully grappled opponent pinned, the warlord gains a morale bonus on damage rolls when dealing damage as part of a grapple check equal to his warlord initiation modifier. This ability lasts until the opponent escapes the grapple.",
    },
    {
    name: "Oxen's Gambit",
    requirement: "The warlord attempts a drag combat maneuver against an opponent.",
    bonus: "The warlord boldly grabs his target and drags them around while inspiring his allies to action; for every 5 feet the warlord drags the opponent, his allies (other than himself himself) may move 5 feet without provoking attacks of opportunity as a free action, even if it isn't their turns.",
    },
    {
    name: "Pinhole Gambit",
    requirement: "The warlord makes a ranged attack against an opponent that is adjacent to one of his other allies.",
    bonus: "The warlord gains a bonus to his armor class equal to his warlord initiation modifier until the start of his next turn.",
    },
    {
    name: "Rascal's Gambit",
    requirement: "The warlord makes a feint attempt.",
    bonus: "The creature the warlord successfully feinted at becomes flat-footed until the start of its next turn.",
    },
    {
    name: "Ravager's Gambit",
    requirement: "The warlord makes a sunder attempt.",
    bonus: "The warlord's sundering attack ignores a number of points of the targeted object's hardness equal to his warlord initiation modifier.",
    },
    {
    name: "Sweeping Gambit",
    requirement: "The warlord makes a trip attempt.",
    bonus: "The warlord can make an attack of opportunity against the tripped opponent. If he hits, he gain a morale bonus on the damage roll equal to his warlord initiation modifier.",
    },
    {
    name: "Coward's Gambit",
    requirement: "The hidden blade attacks a flat-footed opponent or an opponent she is flanking.",
    bonus: "The hidden blade's allies gain a bonus on damage rolls against that opponent equal to the hidden blade's initiation modifier for one round.",
    },
    {
    name: "Stealth Gambit",
    abilityType:"Su",
    requirement: "The hidden blade makes a Stealth check to hide.",
    bonus: "The hidden blade becomes invisible for a number of rounds equal to her initiation modifier, as if under the effect of an invisibility spell.",
    },
    {
    name: "Unbreakable Gambit",
    requirement: "The warlord makes a Fortitude or Will save against a non-harmless extraordinary ability, maneuver, power, spell, spell-like or supernatural ability ability. Unlike other gambits, unbreakable gambit can be activated as an immediate action.",
    bonus: "The warlord regains a number of hit points equal to three times his warlord initiation modifier.",
    },
    {
    name: "Victory Gambit",
    requirement: "Unlike other gambits, the warlord must activate this gambit at the start of his turn, before taking other actions. When he does so, he chooses an opponent. If he reduces that opponent to 0 or fewer hit points this turn, the gambit is a success. Otherwise, it is a failure. This gambit does not add the warlord's initiation modifier as a luck bonus on any d20 rolls.",
    bonus: "The warlord and each of his allies gain a morale bonus on their next attack roll during this encounter equal to the warlord's initiation modifier.",
    },
]
export const kiPerks = [
    {
    name: "Underfoot Grace",
    abilityType:"Su",
    fromClass:"Underfoot Adept",
    shortDesc: "When using the Acrobatics skill to avoid attacks of opportunity by moving through a threatened area or an enemy's space, he only takes a -5 penalty when doing so at full speed, instead of the normal -10 penalty. Every 6 levels you gain an additional +5 bonus when making such checks.",
    },
    {
        name: "Diamond Body",
        abilityType:"Su",
        shortDesc: "You become immune to poison.",
    },
    {
        name: "Monki Freedom",
        abilityType:"Su",
        fromClass:"Treetop Monk",
        shortDesc: "You may expend 8 spell points as a swift action to gain the effects of freedom of movement for 1 round.",
    },
    {
        name: "Infernal Resilience",
        abilityType:"Ex",
        fromClass:"Hamatulatsu Master Monk",
        shortDesc: "You gain immunity to all spells, and effects with the pain descriptor, as well as a +2 bonus on saving throws against effects that would sicken, nauseate, stagger, or stun you.",
    },
    {
        name: "Defensive Aid",
        abilityType:"Ex",
        fromClass:"Nimble Guardian",
        shortDesc: "As an immediate action for 2 spell points you can interpose yourself between one adjacent ally and an attack or damage dealt in an area of effect. If an adjacent ally is the target of the attack or is required to make a Reflex saving throw against a damaging effect, as an immediate action the nimble guardian can grant that ally a +4 circumstance bonus to AC or on the saving throw against the effect. The nimble guardian must use this ability before the attack roll or saving throw is made. The nimble guardian can only use this ability if he is wearing light or no armor. If an ally that gained the benefit of a use of defensive aid succeeds their Reflex saving throw, and the effect still deals damage on a successful saving throw, the nimble guardian can spend level spell points to negate that damage. Doing so is not an action.",
    },
    {
        name: "Insightful Strike",
        abilityType:"Ex",
        fromClass:"Sensei",
        shortDesc: "You may use your highest mental bonus in lieu of your Strength or Dexterity on attack rolls and combat maneuver checks with unarmed strikes or monk weapons.",
    },
    {
        name: "Idiot Strike",
        abilityType:"Su",
        fromClass:"Harrow Warden",
        shortDesc: `When making an unarmed attack you can spend level/2 spell points to make the attack curse the creature with bad luck. Foes damaged by an idiot strike must succeed at a Will save (DC 10 + 1/2 level + highest mental modifier) or become jinxed. A jinxed creature must roll twice whenever it attempts an attack roll, a saving throw, a skill check, or a caster level check for 1 round, taking the lower result in each instance. You must declare that you are using an idiot strike before making the attack roll; thus, a failed roll wastes the attempt. At 4th level and again at 12th level, the jinx effect lasts an additional round.`,
    },
    {
        name: "Lightning Finish",
        abilityType:"Ex",
        fromClass:"Monk of the Seven Winds",
        shortDesc: `As an immediate action for level/2 spell points, you can make a single attack with a manufactured light or one-handed slashing weapon you are currently wielding against any target you have successfully hit at least twice with unarmed strikes during your turn. This attack deals normal damage but without the normal ability score bonus to damage. At 4th level, you can take a 5-foot step before or after performing a lightning finish so long as you end adjacent to your target, though if you take this step, you cannot perform a 5-foot step during your next turn. At 8th level, you applies your full Strength bonus to your damage roll for the extra attack, even if you made the attack with an off-hand weapon or with a weapon wielded in two hands. At 12th level, if you hit the target at least three times with your unarmed strike during your turn, taking the 5-foot step granted by lightning finish does not prevent you from taking a 5-foot step during your next turn.`,
    },
    {
        name: "Feinting Flurry",
        abilityType:"Ex",
        fromClass:"Sage Counselor",
        prereq:"Flurry of Blows",
        shortDesc: `You can spend level/2 spell points when using flurry of blows to feint an opponent as a swift action, or you can replace your first attack during a flurry of blows with a feint check.`,
    },
    {
        name: "Mute Hag Stance",
        abilityType:"Su",
        fromClass:"Harrow Warden",
        shortDesc: `The harrow warden can block opponents' metaphysical ties to one another. Enemies threatened by the harrow warden do not gain the effects of any morale or insight bonuses on attack rolls or skill checks as long as they are within the harrow warden's threatened area.`,
    },
    {
        name: "Eclipse Strike",
        abilityType:"Su",
        fromClass:"Harrow Warden",
        shortDesc: `When making an unarmed attack you can spend 15 spell points to make the attack strike a target with enough force to realign its place in the world. Foes damaged by the attack can attempt a Fortitude save (DC 10 + 1/2 level + highest mental modifier). Those that fail are transmuted into a harmless form, as per the baleful polymorph spell. You must declare that you are using an ecplise strike before making the attack roll; thus, a failed roll wastes the attempt.`,
    },
    {
        name: "Big Sky Stance",
        abilityType:"Su",
        fromClass:"Harrow Warden",
        shortDesc: `You gain immunity to curses and polymorph effects.`,
    },
    {
        name: "Flurry of Manevuers",
        abilityType:"Ex",
        fromClass:"Maneuver Master Monk",
        shortDesc: `When using flurry of blows you can replace unarmed attacks with a combat maneuver, regardless of whether the maneuver normally replaces a melee attack or requires a standard action. You can use your level in place of your base attack bonus to determine your CMB for these maneuvers.`,
    },
    {
        name: "Maneuver Defense",
        abilityType:"Ex",
        fromClass:"Maneuver Master Monk",
        shortDesc: `You gain an improved combat maneuver feat. Any creature attempting to use that maneuver against you provokes an attack of opportunity from you, even if would not normally do so.`,
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context, self, contextSelf)=>{
            let choices = []
            let combatManeuvers = ["Grapple", "Disarm", "Dirty Trick", "Bull Rush", "Drag", "Overrun", "Reposition", "Sunder", "Trip"]
            combatManeuvers.forEach(maneuver =>{                                 
                if(context.stats.lists.feats.filter(feat=> feat.name=="Improved " + maneuver).length > 0){
                    if(context.stats.lists.feats.filter(feat=> feat.name=="Greater " + maneuver).length > 0){
                        choices.push({
                            name:maneuver + " Expert",
                            prereq: "",
                            type:"martial",
                            longDesc:"Gain +1 to " + maneuver + " combat maneuvers, increasing by 1 every 5 levels. This feat stacks with everything including itself."
                        })                        
                    } else{
                        choices.push(feats.filter(feat=>feat.name=="Greater " + maneuver)[0])
                    }
                }else{
                    choices.push(feats.filter(feat=>feat.name=="Improved " + maneuver)[0])
                }                
            })
            self.getFeatChoice(context, choices, contextSelf)
            
        },
        getFeatChoice:(context, choices, contextSelf)=>{
            let options = []
            for(let x = 0; x < choices.length; x++){               
                options.push(
                    {
                        title:choices[x].name,
                        id: x+1,
                        description: choices[x].longDesc ? choices[x].longDesc : choices[x].shortDesc,
                        feat:choices[x],
                        method:()=>{
                            contextSelf.shortDesc += `\n\nChosen: ` + choices[x].name
                            context.stats.lists.feats.push(choices[x])
                        }
                    }
                )
            }
            context.customDialogArray.push({ title:"Combat Maneuver Defense Choice",  options})
        }
    },
    {
        name: "Karmic Strike",
        abilityType:"Su",
        fromClass:"Karmic Monk",
        shortDesc: `You gain bonuses against creatures that attack you first. If a creature you have not attacked yet makes an attack roll against you or casts an offensive spell that affects you, you receive a +2 bonus on attack rolls and damage rolls against that creature. If you hit such a target, this bonus lasts until the end of your turn (or until the beginning of your next turn, if it isn't your turn). Otherwise, the bonus against a particular creature lasts for 1 minute after the creature's last attack against you.`,
    },
    {
        name: "The First Steps of Enlightenment",
        shortDesc: `You begin your path down the enlightened path, you will gain two random elemental enlighted path finishers along with their basic strikes, then you will choose a philosophy and gain its basic finisher. At first and every three levels you will gain an enlightened path maneuver.
        \nEnlightened Path Finishers: In order to activate a finisher, the most recent maneuvers you used must have tags that match the type and order of the tags on the finisher. Activating a finisher costs level/2 spell points. After you use a finisher, your finisher combo resets. Entering a stance or using a finisher does not count towards being able to use your next finisher.`,
        hasCustomMethod:true,
        customMethod:(context,self,contextSelf)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{enlightenedPath:true}, subSchool:contextSelf.pathChosen, level:self.getManeuverLevels(context.stats.characterStats.misc.level), type:{Strike:true,Boost:true,Stance:true,Counter:true,Finisher:true}}}))
            }
        },
        catchUpMethod:(context,self,contextSelf)=>{
            self.addManeuverFreedom(context)
            let maneuverNames = [["The Gathering Storm","Storm Strike"],["The Trembling Earth", "Strike of the Enduring"],["The Raging Sea", "Flowing Water Strike"], ["Breath of the Fire Dragon", "Fires of Purity"]]
            maneuverNames = maneuverNames.sort(()=> 0.5 - Math.random())
            let selected = maneuverNames.slice(0, 2);
            selected.forEach(elements=>{
                elements.forEach(maneuverName=>{
                    let maneuver = maneuvers.find(maneuver => maneuver.name == maneuverName)
                    maneuver.id = Math.random()
                    context.stats.lists.maneuver.push(maneuver)
                })
            })
            self.getPath(context,self,contextSelf)
        },
        getPath(context, self, contextSelf){
            let optionNames = ["Path of Balance","Path of Dominion","Path of Emptiness"]
            let paths = [];paths["Path of Balance"] = "light"; paths["Path of Dominion"] = "dark"; paths["Path of Emptiness"] = "void";
            let options = []                
            for(let x = 0; x < 3; x++){
                let option = {
                    title:optionNames[x],
                    id:x-1,
                    description: self.paths[x].description,
                    method:()=>{                        
                        let maneuver = maneuvers.find(maneuver => maneuver.name == self.paths[x].maneuverList)
                        maneuver.id = Math.random()
                        context.stats.lists.maneuver.push(maneuver)
                        contextSelf.shortDesc += `\n\nChosen: ` + optionNames[x] + `\n` + option.description
                        contextSelf.pathChosen = paths[optionNames[x]]
                        for(let y = 1; y <= context.stats.characterStats.misc.level; y++){
                            if(y%3 ==0 || y==1){
                                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{enlightenedPath:true}, subSchool:contextSelf.pathChosen, level:self.getManeuverLevels(y), type:{Strike:true,Boost:true,Stance:true,Counter:true,Finisher:true}}}))
                            }
                        }
                    }
                }
                options.push(option)
            }               
            context.customDialogArray.push({title:"Enlightened Path Philosophy Choice", options})                
        },
        addManeuverFreedom:(context)=>{
            let text = `Iron Tortoise maneuvers count as [earth], and you can use your unarmed attacks as a shield for its maneuvers.
            \nHeart of the Maelstrom maneuvers count as [air], and you heart of the maelstrom maneuvers that include an attack even when not using dexterity for attack or damage.
            \nBurning Citadel maneuvers count as [fire] and you can initiate any of them with unarmed strikes.
            \nMithral Current maneuvers count as [water]. If you are in a water stance, you can sheathe an unarmed weapon once per round as a free action that you can take even when not your turn.
            \nElemental Flux maneuvers count as your active element
            \nSilver Crane and Radiant Dawn maneuvers count as [light].
            \nBlack Seraph and Unquiet Grave maneuvers count as [dark], and you can initiate any Black Seraph maneuver even with an unarmed attacks.
            \nVeiled Moon and Sleeping Goddess maneuvers count as [void].`
            let newPerk = {name:"Maneuver Freedom",rarity:"unique", uitType:"perks", type:"martial", id:Math.random(), shortDesc:text}
            context.stats.lists.perks.push(newPerk)
        },
        paths:[
            {
                name:"Path of Balance",
                type:["Enlightened Path"],
                description:`The path of balance is a path that focuses on healing and protecting allies.`,
                maneuverList:"Healing Ki"
            },
            {
                name:"Path of Dominion",
                type:["Enlightened Path"],
                description:`The path of dominion focuses on death and offense.`,
                maneuverList:"Touch of Despair"
            },
            {
                name:"Path of Emptiness",
                type:["Enlightened Path"],
                description:`The path of emptiness focuses unique powers that bend and warp reality.`,
                maneuverList:"Infinite Force Strike"
            }
        ],
        getManeuverLevels(lvlNum){
            lvlNum = Math.floor(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let levels = {}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    levels[levelString]=true;
                }
            }
            return levels
        },
    },
    {
        name: "True Sacrifice",
        abilityType:"Su",
        fromClass:"Monk of the Healing Hand",
        shortDesc: `in a final selfless act, a monk of the healing hand can draw in his entire ki, which then explodes outward in a 50-foot-radius emanation. All dead allies within the emanation are brought back to life, as if they were the subject of a true resurrection spell with a caster level equal to the monk's level. When the monk does this, he is truly and utterly destroyed. A monk destroyed in this way can never come back to life, not even by way of a wish or miracle spell or by the power of a deity. Furthermore, the monk's name can never be spoken or written down again. All written mentions of his name become nothing more than a blank space.`,
    },
    {
        name: "Exploit Weakness",
        abilityType:"Ex",
        fromClass:"Martial Artist",
        shortDesc: `As a swift action for 4 spell points, a martial artist can observe a creature or object to find its weak point by making a Wisdom check and adding his level against a DC of 10 + the object's hardness or the target's CR. If the check succeeds, the martial artist gains a +2 bonus on attack rolls until the end of his turn, and any attacks he makes until the end of his turn ignore the creature or object's DR or hardness. A martial artist may instead use this ability as a swift action for 4 spell points to analyze the movements and expressions of one creature within 30 feet, granting a bonus on Sense Motive checks and Reflex saves and a dodge bonus to AC against that opponent equal to 1/2 his level until the start of his next turn.`,
    },
    {
        name: "Bastion Stance",
        abilityType:"Ex",
        fromClass:"Monk of the Iron Mountain",
        shortDesc: `If the monk starts and ends his turn in the same space, he cannot be knocked prone or forcibly moved until the start of his next turn, except by mind-affecting or teleportation effects. At 15th level, he is immune to any attempts to force him to move, even mind-affecting and teleportation effects.`,
    },
    {
        name: "Iron Limb Defense",
        abilityType:"Ex",
        fromClass:"Monk of the Iron Mountain",
        shortDesc: `If the monk starts and ends his turn in the same space, he cannot be knocked prone or forcibly moved until the start of his next turn, except by mind-affecting or teleportation effects. At 4th level you also gain a +2 shield bonus to your AC and CMD until the start of his next turn. As a swift action you can increase the bonus to +4. At 15th level, he is immune to any attempts to force him to move, even mind-affecting and teleportation effects.`,
    },
    {
        name: "Physical Resistance",
        abilityType:"Ex",
        fromClass:"Martial Artist",
        shortDesc: `When you suffer any effect that causes ability damage, ability drain, or temporary ability score penalties, the effect is reduced by 1 point. This reduction increases by 1 for every three levels beyond 7th.`,
    },
    {
        name: "Reliable Maneuver",
        abilityType:"Ex",
        fromClass:"Maneuver Expert",
        shortDesc: `As a swift action, you may spend 4 spell points before attempting a combat maneuver. You can roll your combat maneuver check for that maneuver twice and use the better result.`,
    },
    {
        name: "Meditative Maneuver",
        abilityType:"Ex",
        fromClass:"Maneuver Expert",
        shortDesc: `As a swift action for 5 spell points, you can add your highest mental modifier on any combat maneuver check you makes before the beginning of you next turn. You must choose which combat maneuver check to grant the bonus to before making the combat maneuver check.`,
    },
    {
        name: "Whirlwind Maneuver",
        abilityType:"Ex",
        fromClass:"Maneuver Expert",
        shortDesc: `You gain two special maneuver options:
        \n1: As a standard action you can make two combat maneuvers, as long as neither maneuver requires you to move. You may perform two identical maneuvers against two adjacent enemies, or perform two different combat maneuvers against the same target.
        \n2: As a full-round action for 10 spell points, a you can attempt a single combat maneuver against every opponent you threaten, as long as the combat maneuver does not require movement. You make a single combat maneuver check, and it applies to all targets.`,
    },
    {
        name: "Mystic Persistence",
        abilityType:"Su",
        fromClass:"Ki Mystic Monk",
        shortDesc: `As a swift action for 10 + level spell points you create a 20 foot aura around you. You and all allies within the aura can roll two dice when making an attack roll or a saving throw and take the better result. The aura lasts for 1 round, plus an additional round for every level spell points spent when you created the aura. You can dismiss the aura at any time as a free action, but the spell points for the full duration of the aura are lost.`,
    },
    {
        name: "Ki Mystic",
        abilityType:"Su",
        fromClass:"Ki Mystic Monk",
        shortDesc: `Gain 2 additional spell points per level. As long as you have at least level spell points you gain a +2 bonus on all knowledge checks. You can spend 3 spell points as a swift action immediately before making an ability, or skill check to gain a +4 insight bonus on the check.`,
        hasCustomMethod:true,
        catchUpMethod:(context)=>{
            context.stats.characterStats.misc.spPerLevel += 2
        },
        customMethod:()=>{
        }
    },
    {
        name: "Karmic Disruption",
        abilityType:"Su",
        fromClass:"Karmic Monk",
        shortDesc: `You gain spend 8 spell points as a swift action to add 1d6 points of damage to your unarmed strikes against creatures of either chaotic, evil, good, or lawful alignment for 1 round. Creatures that are of the appropriate alignment and are struck by this attack must succeed at a Will save (DC = 10 + 1/2 level + highest mental modifier) or lose any damage reduction based on alignment for a number of rounds equal to your highest mental modifier (minimum 1 round). A creature that succeeds at this save is immune to further attempts to disrupt its DR with this ability. This attack disrupts only alignment components of damage reduction, not any other components; for example, DR/cold iron and good becomes DR/cold iron.`,
    },
    {
        name: "Life Funnel",
        abilityType:"Su",
        fromClass:"Hungry Ghost Monk",
        shortDesc: `When you score a confirmed critical hit against a living enemy or reduces a living enemy to 0 or fewer hit points, you heal a number of hit points equal to your level.`,
    },
    {
        name: "Life from a Stone",
        abilityType:"Su",
        fromClass:"Hungry Ghost Monk",
        prereq:"Life Funnel",
        shortDesc: `You can use life funnel from any creature, not just living creatures. You also increase the amount of healing gained by your highest mental modifier.`,
    },
    {
        name: "Sipping Demon",
        abilityType:"Su",
        fromClass:"Hungry Ghost Monk",
        shortDesc: `You gain 1 temporary hit point each time you hit an enemy with a melee attack. You gain a number of temporary hit points equal to your highest mental modifier when you scores a critical hit. The maximum number of temporary hit points you can have is equal to your level. The temporary hit points disappear 1 hour later. You can only use this ability when you have at least level spell points.`,
    },
    {
        name: "Far Strike Flurry",
        fromClass:"Far Strike Monk",
        abilityType:"Ex",
        prereq:"Flurry of Blows",
        shortDesc: "You can now use throwing weapons as a part of flurry of blows. You can draw light throwing weapons as free actions when doing so. You cannot use rapid shot while using flurry of blows this way.",
    },
    {
        name: "Flowing Dodge",
        fromClass:"Flowing Monk",
        abilityType:"Ex",
        shortDesc: "You gain a +1 dodge bonus to AC for each enemy adjacent to you, up to a maximum bonus equal to your highest mental modifier (minimum 1).",
    },
    {
        name: "Elusive Target",
        fromClass:"Flowing Monk",
        abilityType:"Ex",
        shortDesc: "As an immediate action you can spend 4 spell points to attempt a Reflex save opposed by an attacker's attack roll to halve damage from that attack. If the attacker is flanking the monk, the flanking opponent who is not attacking becomes the target of the attack. Use the same attack roll, and if the attack hits the new target, that creatures takes half damage (or full damage if the attack is completely avoided). Any associated effects from the attack (such as bleed, poison, or spell effects) apply fully even if the attack deals only half damage.",
    },
    {
        name: "Improved Elusive Target",
        fromClass:"Flowing Monk",
        abilityType:"Ex",
        prereq:"Elusive Target",
        shortDesc: "When you use elusive target, you can increase the spell point cost to 11 to completely negate the damage if you succeed the save, or take half if you fail the save.",
    },
    
    {
        name: "Unbalancing Counter",
        fromClass:"Flowing Monk",
        abilityType:"Ex",
        shortDesc: "Your attacks of opportunity render a struck creature flat-footed until the end of your next turn (Reflex DC 10 + 1/2 level + highest mental modifier negates).",
    },
    {
        name: "Redirection",
        fromClass:"Flowing Monk",
        abilityType:"Ex",
        shortDesc: "As an immediate action by spending level/2 spell points, a flowing monk can attempt a reposition or trip combat maneuver against a creature that the flowing monk threatens and that attacks him. If the combat maneuver is successful, the attacker is sickened for 1 round (Reflex DC = 10 + 1/2 level + highest menal modifier to halve the duration), plus 1 additional round at 4th level and for every four levels afterward. The monk gains a +2 bonus on the reposition or trip combat maneuver check and the save DC for redirection increases by 2 if the attacker is using Power Attack to deal damage or is charging when attacking him.",
    },
    {
        name: "Improved Redirection",
        fromClass:"Flowing Monk",
        abilityType:"Ex",
        prereq:"Redirection",
        shortDesc: "A flowing monk can use redirection against an opponent that the flowing monk threatens and that attacks an ally with a melee attack. At 8th level, a flowing monk can make both a reposition and a trip maneuver as part of a single immediate action with this ability. At 12th level, a flowing monk can use redirection against any opponent that attacks him in melee, even if the flowing monk is not threatening the opponent who attacks him.",
    },
    {
        name: "Trick Throw",
        abilityType:"Su",
        shortDesc: "As a swift action you can spend 6 spell points to ignore concealment, by spending 12 you can instead ignore total concealment and cover, by spending 18 you can ignore total cover, even throwing weapons around corners. The weapons must ",
    },
    {
        type:"universal",
        name: "Evasion",
        abilityType:"Ex",
        shortDesc: "If you make a successful Reflex saving throw against an attack that normally deals half damage on a successful save, you instead take no damage. Evasion can be used only if you are wearing light or no armor, and you are not helpless. Gaining This perk additional times will grant the improved versions.",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let evasions = context.stats.lists.perks.filter(perk => perk.name == "Evasion")       
            if(evasions.length > 1){
                let evasions = context.stats.lists.perks.filter(perk => perk.name == "Improved Evasion")  
                if(evasions.length > 0){
                    evasions = context.stats.lists.perks.filter(perk => perk.name == "Greater Evasion")  
                    if(evasions.length > 0) context.stats.characterStats.misc.reflex += 4
                    let evasion = perks.filter(perk => perk.name == "Greater Evasion")[0]
                    evasions = context.stats.lists.perks.filter(perk => perk.name == "Evasion")
                    let specific = evasions[evasions.length-1]
                    specific.name = "Greater Evasion"
                    specific.shortDesc = evasion.shortDesc
                }
                else{
                    let evasion = perks.filter(perk => perk.name == "Improved Evasion")[0]
                    let evasions = context.stats.lists.perks.filter(perk => perk.name == "Evasion")
                    let specific = evasions[evasions.length-1]
                    specific.name = "Improved Evasion"
                    specific.shortDesc = evasion.shortDesc
                }
            }
        },
    },
    {
        type: "universal",
        name: "Improved Evasion",            
        shortDesc: "When making a reflex saving throw to avoid damage, you take half damage even if you fail the saving throw, and none of you succeed on the saving throw. You must not be helpess or wearing armor heavier than light to use this ability. Having this ability additional times instead will grant greater evasion.",
        prereq:"Evasion",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let evasions = context.stats.lists.perks.filter(perk => perk.name == "Improved Evasion")  
            if(evasions.length > 1){
                evasions = context.stats.lists.perks.filter(perk => perk.name == "Greater Evasion")  
                if(evasions.length > 0){
                    context.stats.characterStats.misc.reflex += 4
                }
                let evasion = perks.filter(perk => perk.name == "Greater Evasion")[0]
                evasions = context.stats.lists.perks.filter(perk => perk.name == "Improved Evasion")
                let specific = evasions[evasions.length-1]
                specific.name = "Greater Evasion"
                specific.shortDesc = evasion.shortDesc
            }
        },
    },
    {
        type: "universal",
        name: "Greater Evasion",            
        shortDesc: "When making a reflex save to avoid damage while wearing medium or heavier armor, if you pass the DC you take half damage, if you beat the DC by more than your armor check penalty, you take no damage. Having this ability additional times instead will grant a +4 to reflex saving throws.",
        prereq:"Improved Evasion",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let evasionCount = context.stats.lists.perks.filter(perk => perk.name == "Greater Evasion")            
            if(evasionCount.length > 1){
                context.stats.characterStats.misc.reflex += 4
            }
        },
    },
    {
        name: "Purity of Body",
        abilityType:"Su",
        shortDesc: "You become immune to disease, including supernatural and magical diseases.",
    },
    {
        name: "Diamond Soul",
        abilityType:"Ex",
        shortDesc: "You gain spell resistance of level + 10.",
    },
    {
        name: "Ki Volley",
        abilityType:"Su",
        shortDesc: "Increase your spell resistance by +1 per 6 levels. When a targeted spell or spell-like ability fails to overcome the monk's spell resistance, he can spend 16 spell points as an immediate action to send that spell back at its caster as spell turning.",
        rateUp:"Diamond Soul"
    },
    {
        name: "Still Mind",
        shortDesc: "You gain a +2 bonus on saving throws against enchantment spells and effects. Every 6 levels this increases by +1.",
    },
    {
        name: "Perfect Self",
        shortDesc: "You are treated as an outsider rather than humanoid for the purpose of spells and magical effects. Additionally, the monk gains damage reduction 10/chaotic. Unlike other outsiders, the monk can still be brought back from the dead as if he were a member of his previous creature type.",
    },
    {
        name: "Timeless Body",
        shortDesc: "A monk no longer takes penalties to his ability scores for aging and cannot be magically aged. Any such penalties that he has already taken, however, remain in place, and he can gain bonuses from his age. He can still die of old age however.",
    },
    {
        name: "Old Master",
        shortDesc: "When making a full-attack using only unarmed strikes and unarmed augmenting weapons, you can make an additional attack at your highest base attack bonus, though all attacks in the round take an additional -2 penalty.",
    },
    {
        name: "Living Weapon",
        shortDesc: "When not using any unarmed augmenting weapons to make an unarmed attack, you increase its damage by 1 dice step, plus an additional dice step every 4 levels.",
    },
    {
    name: "Fuse Styles",
    shortDesc: "A master of many styles can fuse two of the styles he knows into a more perfect style. The master of many styles can have an additional style feat active at once. Starting a stance provided by a style feat is still a swift action, but when the master of many styles switches to another style feat, he can choose one style whose stance is already active to persist. At level 8 he gains a bonus to attacks equal to as many styles as he has active.",
    },
    {
    name: "Dragon's Force",
    shortDesc: "Increase the damage you deal with unarmed attacks by half of your strength modifier.",
    },
    {
        name: "Iron Fists",
        abilityType:"Ex",
        shortDesc: "Increase the damage you deal with your unarmed attacks by 1 dice step, plus an additional step every 8 levels.",
    },
    {
    name: "Action Before Thought",
    shortDesc: "A monk with this ability can spend 3 spell points as a free action as part of rolling initiative to roll twice on the initiative check and take the higher result",
    },
    {        
    name: "AC Bonus",
    shortDesc: "You add your highest mental stat as an untyped bonus to your AC and CMD while not wearing armor, or an armor that has no maximum dexterity bonus. This bonus is not lost while flat-footed, but is lost when you cannot move.",
    },
    {
    name: "Insightful Wisdom",
    shortDesc: "You can spend 6 spell points as an immediate action to give another ally within 30 feet just the right word of advice to prevent disaster. If the ally can hear the monk, they can reroll a single attack roll or saving throw. The ally must take the second result, even if it is worse.",
    },
    {
    name: "Quivering Palm",
    shortDesc: "Using this ability is a standard action that costs 15 spell points and requires you to make a melee unarmed strike against a target, and you must announce your intent to use this ability (and spend the spell points) before making the attack roll. Creatures immune to critical hits cannot be affected. Otherwise, if the attack hits and the target takes damage from the blow, they must also succeed a Fortitude saving throw (DC = 10 + 1/2 level + highest mental stat modifier), or die.",
    },
    {
    name: "Ki Guardian",
    shortDesc: "As an immediate action before he rolls a saving throw against a targeted effect that also targets other allies or an area effect whose area includes other allies, a monk with this ability can spend any number of spell points and designate a number of adjacent allies equal to 1/3 the number of the spell points spent. Roll one saving throw for each designated ally, using his bonus instead of the ally's. For each successful saving throw, the corresponding ally treats the effect as if that ally had succeeded at the saving throw, and for each saving throw failed, the corresponding ally treats the effect as if that ally had failed the saving throw. If the monk fails any of the saving throws (including his own original saving throw), the monk treats the effect as if he had failed the saving throw.",
    },
    {
    name: "Ki Hurricane",
    shortDesc: "As a full-round action you can move up to twice your speed. At any point in that movement, you can spend level/2 spell points to make the first attack from your full-round attack. You can later spend another level/2 spell points to make the next attack in your full-round attack, and so on, until you either stops spending spell points or has exhausted all the attacks from your full-attack action.",
    },
    {
    name: "Wholeness of Body",
    shortDesc: "As a standard action you can spend 7 spell points to heal 1d4+level/2 hit points immediately, and then again at the start of each of your turns for rounds equal to your highest mental modifier. Re-activating this ability only extends the duration. This is not positive energy.",
    },
    {
    name: "Diamond Resilience",
    shortDesc: "By spending 4 spell points as a swift action, the monk gains DR 4/—. At 6th level, the damage reduction increases to 6/— and the cost to 6. At 12th level, it increases to DR 8/— and the cost to 8. And at 16th this improves to 10/- and the cost to 10. This DR lasts for a full round",
    },
    {
    name: "High Jump",
    shortDesc: "Add your level as a bonus on all acrobatics checks to jump. In addition, you always count as having a running start when attempting Acrobatics checks to jump. By spending 4 spell points as a swift action, you gain a +20 bonus on Acrobatics checks to jump for 1 round.",
    },
    {
    name: "Ki Range",
    shortDesc: "Spend 4 spell points as a swift action to increase the range increment of any thrown weapon by 20 feet for 1 round.",
    },
    {
    name: "Furious Defense",
    shortDesc: "By spending 2 spell point as an immediate action, you gain a +4 dodge bonus to AC until the end of your next turn. Every 3 levels, the cost increases by 2 spell points to increase the dodge bonus by +2.",
    },
    {
    name: "Ki Vampirism",
    shortDesc: "Whenever you reduce a creature to negative hitpoints or confirm a critical hit you gain level spell points.",
    },
    {
    name: "Elemental Fury",
    shortDesc: "Select one type of energy: acid, cold, electricity, or fire. Once this choice is made, it cannot be changed. Expend 6 spell points as a swift action to imbue your melee attacks with this energy, causing them to deal 1d6 points of damage of the chosen type for a number of rounds equal to 1/2 his level. This stacks with other elemental damage, but not itself.",
    },
    {
    name: "Elemental Burst",
    shortDesc: `Select one type of energy: acid, cold, electricity, or fire. Once this choice is made, it cannot be changed. As a standard action you can spend levelx2 spell points to unleash a gout of this energy in a 30-foot cone. Creatures within the cone take 1d6 points of damage per level. A Reflex save (DC = 10 + 1/2 level + highest mental) halves the damage. Depending on which element you choose, this also has an additional effect:
    Acid: Their armor bonus to armor class lowers by your highest mental modifier for 1 round. Cannot reduce it below 0.
    Cold: They take a penalty to their attack rolls equal to your highest mental modifier for 1 round. 
    Electricity: If they fail the save, they must also make a fortitude save at the same DC or be stunned for 1 round.
    Fire: They receive immolation stacks (see burning citadel) equal to your highest mental modifier (reflex halves), and if they fail the save they also catch on fire. The DC to remove the fire is equal to this abilities DC instead of the normal one.`,
    },
    {
    name: "Breaking Down Koan",
    shortDesc: "Spend 8 spell points as a swift action to present a paradox, riddle, or complicated question to a creature within 30 feet. The creature must succeed at a Will save (DC = 10 + 1/2 level + highest mental) or be confused for 1 round. This is a mind-affecting, language-dependent effect, and can only affect a target once.",
    },
    {
    name: "Abundant Step",
    abilityType:"Su",
    shortDesc: "Slip magically between spaces, as if using the spell dimension door. Using this ability is a move action that consumes 8 spell point. You cannot take other creatures with you when you uses this ability.",
    },
    {
        name: "Flawless Mind",
        shortDesc: "A monk gains total control over his mental faculties. Whenever he attempts a Will save, he can roll twice and take the better result. If he fails a Will saving throw against a spell or effect that is permanent, the monk can attempt a new saving throw at the end of each floor.",
    },
    {
    name: "Wind Jump",
    shortDesc: "A monk with this ki power can spend 4 spell points as a move action to grant himself a fly speed (with perfect maneuverability) equal to his base land speed. He must end his movement each round on solid ground (or some other surface that can support his weight) or fall as normal. Once activated, this ability lasts for level rounds.",
    },
    {
        name: "Aspect Master",
        shortDesc: `You choose one of the great spirits of the world, this grants you a new appearance and abilities. The options are:
        \nAspect of the Carp: Breath water and gain a swim speed equal to your land speed.
        \nAspect of the Ki-Rin: Gain a fly speed equal to your land speed, but you must end each turn on the ground. If you do not land by the end of your turn, your falls from whatever height you have attained.
        \nAspect of the Monkey: Grow a prehensile tail. you can pick up objects and make unarmed attacks with your tail (though the tail does not grant additional unarmed attacks or natural attacks). In addition, you gain a climb speed equal to your land speed.
        \nAspect of the Owl: Gain a fly speed of 30 feet.
        \nAspect of the Tiger: For level x2 spell points you can move at 10 times your normal speed when you make a charge attack and you gain the pounce ability.`,
        hasCustomMethod:true,
        catchUpMethod:(context, self, contextSelf)=>{
            let options = []
            for(let x = 0; x < self.aspects.length; x++){               
                options.push(
                    {
                        title:self.aspects[x].name,
                        id: x+1,
                        description: self.aspects[x].description,
                        method:()=>{
                            contextSelf.shortDesc = `You chose one of the great spirits of the world, this grants you a new appearance and abilities.\n\nChosen: ` + self.aspects[x].name + `:\n\n`+self.aspects[x].description
                        }
                    }
                )
            }
            context.customDialogArray.push({ title:"Aspect Master Choice",  options})

        },
        aspects:[
            {
            name: "Aspect of the Carp",
            description: "He can breathe water and gains a swim speed equal to his land speed.",
            },
            {
            name: "Aspect of the Ki-Rin",
            description: "Gain a fly speed equal to your land speed, but you must end each turn on the ground. If you do not land by the end of your turn, your falls from whatever height you have attained.",
            },
            {
            name: "Aspect of the Monkey",
            description: "Grow a prehensile tail. you can pick up objects and make unarmed attacks with your tail (though the tail does not grant additional unarmed attacks or natural attacks). In addition, you gain a climb speed equal to your land speed.",
            },
            {
            name: "Aspect of the Owl",
            description: "Gain a fly speed of 30 feet.",
            },
            {
            name: "Aspect of the Tiger",
            description: "For level x2 spell points you can move at 10 times your normal speed when you make a charge attack and you gain the pounce ability.",
            },
        ],
        customMethod:()=>{},
    },
    {
    name: "Slow Time",
    shortDesc: "A monk of the four winds can use his ki to slow time or quicken his movements. As a swift action, the monk can expend 12 spell points to gain three standard actions during his turn instead of just one. The monk can use these actions to do the following: take a melee attack action, use a skill, use an extraordinary ability, or take a move action. The monk cannot use these actions to cast spells or use spell-like abilities, and cannot combine them to take full-attack actions. Any move actions the monk makes this turn do not provoke attacks of opportunity.",
    abilityType:"Ex",
    },
    {
    name: "Sudden Speed",
    shortDesc: "You can spend 6 spell points as a swift action to increase your base movement speed by 30 feet for 1 minute. If youre wearing heavy or medium armor this only increases your speed by 15 feet instead.",
    },
    {
    name: "Bare-Hand Block",
    shortDesc: "A monk with this ability can spend 4 spell points as an immediate action when attacked with a manufactured weapon to attempt an unarmed sunder combat maneuver check against it. If he successfully sunders the weapon and grants it the broken condition, the attack deals no damage.",
    abilityType:"Ex",
    },
    {
    name: "Ki Sunder",
    shortDesc: "A monk with this ability can spend 2 spell points when attempting a sunder combat maneuver check to add his level as a bonus to the damage roll and the sunder attempt does not provoke an attack of opportunity. If it did already not provoke you gain a +2 bonus to the attempt.",
    abilityType:"Ex",
    },
    {
    name: "One Touch",
    shortDesc: "For 4 spell points as a standard action you can can make a single unarmed strike against a foe as a touch attack with a bonus to damage equal to half your level. You can spend an additional 4 spell points to increase the damage to your level. Every 4 levels you reduce the cost of the activation of this ability by 1 spell point (This modifies the total cost, meaning if you activate both uses of this ability at level 4 it costs 7 spell points)",
    abilityType:"Ex",
    },
    {
    name: "Breaking Strike",
    shortDesc: "[style strike]Once per round for 5 spell points while making an unarmed attack, you combine a writhing twist with a violent strike against a foe that is grappling you. If your attack is successful, you can attempt a grapple combat maneuver check or Escape Artist check as a free action to escape a grapple, adding the strike's damage as a bonus on your check",
    abilityType:"Ex",
    },
    {
    name: "Defensive Spin",
    shortDesc: "[style strike]Once per round for 3 spell points while making an unarmed attack, The monk spins about, confounding his foe. If the attack hits, the monk gains a +4 dodge bonus to AC against any attacks made by the target of the style strike until the start of his next turn. This bonus does not stack with itself.",
    abilityType:"Ex",
    },
    {
    name: "Elbow Smash",
    shortDesc: "[style strike]Once per round for 5 spell points while making an unarmed attack, The monk follows up a punch with a strike from his elbow. If the attack hits, the monk can make an additional attack using the same attack bonus as the punch at a -5 penalty, and the attack cannot use any unarmed weapons. If this second attack hits, it deals damage as normal, but all of the damage is nonlethal.",
    abilityType:"Ex",
    },
    {
    name: "Flying Kick",
    shortDesc: "[style strike]Once per round for 5 spell points while making an unarmed attack, during a full-round attack The monk leaps through the air to strike a foe with a kick. Before the attack, the monk can move a 10 feet per 4 levels (minimum 10), this is reduced by half if you are wearing medium or heavy armor. This movement is made as during the full-round attack and requires no additional action. At the end of this movement, the monk must make an attack against an adjacent foe. This movement may be between attacks. This movement provokes an attack of opportunity as normal.",
    abilityType:"Ex",
    },
    {
    name: "Foot Stomp",
    shortDesc: "[style strike]Once per round for 5 spell points while making an unarmed attack, the monk stomps on a foe's foot, preventing the opponent from escaping. If the attack hits and the monk ends his turn adjacent to that foe, the foe's movement is restricted. Until the start of the monk's next turn, the target of this attack can move only in such a way that the space it occupies is adjacent to the monk. Alternatively, it can attempt a combat maneuver check (against the monk's CMD) as a standard action to break free. This strike does not work against foes that cannot be tripped.",
    abilityType:"Ex",
    },
    {
    name: "Hammerblow",
    shortDesc: "[style strike]Once per round for 3 spell points while making an unarmed attack, The monk links his hands together, swinging both arms like a club and dealing tremendous damage. If the attack hits, the monk rolls his unarmed strike damage twice, adding both rolls together before applying Strength and other modifiers to the damage. This bonus damage is not multiplied on a critical hit. You can only use this strike once per turn, and you must have both hands free to do so.",
    abilityType:"Ex",
    },
    {
    name: "Headbutt",
    shortDesc: "[style strike]Once per round for 5 spell points while making an unarmed attack, The monk slams his head into his enemy's head, leaving his foe reeling. If the attack hits and the foe is of the same size or one size smaller than the monk, the monk can make a free combat maneuver check against the target of this strike (using the base attack bonus of the attack used to hit the foe). If the foe is not of the same creature type as the monk, the monk takes a -8 penalty on this check. If the check is successful, the target is staggered for 1 round. Creatures without a discernible head are not affected by this style strike (subject to GM discretion)",
    abilityType:"Ex",
    },
    {
    name: "Knockback Kick",
    shortDesc: "[style strike]Once per round for 5 spell points while making an unarmed attack, The monk attempts to knock his foe back with a powerful kick. If the attack hits, the monk can attempt a free combat maneuver check against the foe (using the base attack bonus of the attack used to hit the foe). If the check is successful, the foe is knocked 10 feet directly away from the monk. This distance increases by 10 feet for every 5 by which the check exceeds the foe's CMD, to a maximum distance of 10 feet plus 10 per 4 levels. This movement does not provoke an attack of opportunity. The foe stops moving if it strikes another creature, barrier, or otherwise solid object. The creature is not knocked prone by this movement.",
    abilityType:"Ex",
    },
    {
    name: "Leg Sweep",
    shortDesc: "[style strike]Once per round for 5 spell points while making an unarmed attack, The monk attempts to sweep his foe's leg, knocking the opponent down. If the attack hits, the monk can make a free trip attempt against the target of this strike (using the base attack bonus of the attack used to hit the foe). This trip attempt does not provoke an attack of opportunity.",
    abilityType:"Ex",
    },
    {
    name: "Rabbit Punch",
    shortDesc: "[style strike]Once per round for 5 spell points while making an unarmed attack, the monk gives a sharp blow to the back of a foe's head. The critical threat range and critical multiplier of this strike increase by 1, and the monk gains a +2 bonus on attack rolls to confirm a critical hit with this strike. This increase is not doubled by Improved Critical or similar effects. Creatures without a discernible head are unaffected by this style strike (subject to GM discretion).",
    abilityType:"Ex",
    },
    {
    name: "Shattering Punch",
    shortDesc: "[style strike]Once per round for 5 spell points while making an unarmed attack, The monk delivers a brutal punch that can penetrate defenses. If the attack hits, it bypasses any damage reduction or hardness possessed by the target of that attack.",
    abilityType:"Ex",
    },
    {
    name: "Spin Kick",
    shortDesc: "[style strike]Once per round for 5 spell points while making an unarmed attack, The monk spins about, delivering a kick his foe did not expect. The monk makes his attack against the foe's flat-footed AC. Creatures with the uncanny dodge class feature or a similar effect cannot be caught flat-footed by this style strike.",
    abilityType:"Ex",
    },
    {
    name: "Throat Crush",
    shortDesc: "Once per round for 5 spell points while making an unarmed attack, The monk gives a sharp blow to a foe's throat, hampering its ability to speak for 1 round as if it had the caster croak spellblight. Creatures without a discernible throat, or with multiple vocal organs, are unaffected (subject to GM discretion)",
    abilityType:"Ex",
    },
]

export const recoveryPerks = [
    {
        name: "Third Eye Shot",
        fromClass:"Mind's Eye Disciple",
        shortDesc: `As a full-round action, select one creature you can see, recovering a number of expended maneuvers equal to your initiation modifier (minimum 2). Your next ranged attack against that creature ignores any miss chance possessed by the target (including that of total concealment) and does not take penalties on attack rolls from attacking that creature from beyond your weapon's first range increment. In addition, you gain an insight bonus on that attack roll equal to your initiation modifier.`,
    },
    {
        name: "Primal Surge",
        fromClass:"Primal Disciple",
        shortDesc: `You draw on the strength of your ancestors as a full-round action. Recover a number of expended maneuvers equal to your initiation modifier (minimum 2) and restore your constitution modifier of spell points. You only regain these spell points if you are in combat.`,
    },
    {
        name: "Silent Reaper",
        fromClass:"Silent Reaper",
        shortDesc: `As a full-round action recover a number of expended maneuvers equal to your initiation modifier (minimum 2) and you may move up to your movement speed and make a Stealth check (with a -5 penalty) to hide even if you lack cover or concealment. On your next turn, you gain additional sneak attack damage equal to your initiation modifier.`,
    },
    {
        name: "Ambush Pack",
        fromClass:"Ambush Hunter",
        shortDesc: `As a full-round action recover a number of expended maneuvers equal to your initiation modifier (minimum 2) and you may move up to your movement speed and make a Stealth check (with a -5 penalty) to hide even if you lack cover or concealment. If during your movement you are adjacent to any ally, they can also make a stealth check to hide (also with a -5 penalty) as an immediate action.`,
    },
    {
        name: "Sentinel",
        fromClass:"Ferine Sentinel",
        shortDesc: `As a full-round action recover a number of maneuvers equal to your initiation modifier (minimum 2) and you and one ally within 60 feet gain temporary hit points equal to 2x your level. If you and the ally attack the same target on the next round, you both gain +2 circumstance bonus on your attacks against them. These last for the rest of the floor.`,
    },
    {
        name: "Healer's Reassurance",
        fromClass:"Medic",
        shortDesc: `As a full-round action recover a number of expended maneuvers equal to your initiation modifier (minimum 2) and grant all allies within 30 feet (excluding yourself) a number of temporary hit points equal to 3 times your level and a bonus on Fortitude saves equal to your initiation modifier for one round. These temporary hit points last for one minute or until lost.`,
    },
    {
        name: "Command",
        fromClass:"Rajah",
        shortDesc: `As a standard action you can issue a command to one of your allies within close range (25ft. + 5ft./2 levels) that can perceive you. When you do so, you recover half your initiation modifier expended maneuvers (minimum 1), and you can choose one of the following commands that the affected ally can do as a free action that they can take even when it isn't their turn:
        \nAttack: The affected ally makes a melee or ranged attack at their highest attack bonus.
        \nBolster: The affected ally gains a morale bonus equal to your initiation modifier to their AC or on a saving throw of your choice (Fortitude, Reﬂex, or Will) for one round. If they are suffering from an ongoing effect that allows for multiple saving throws over time to negate, or if the effect has its duration measured in rounds, they may make a save against that effect's original DC with a morale bonus to that save equal to your initiation modifier. A successful saving throw ends or reduces this ongoing effect as if they had passed the original saving throw.
        \nMove: The affected ally moves up to their speed, provoking attacks of opportunity as normal.`,
    },
    {
        name: "Center Spirit",
        fromClass:"Stalker",
        shortDesc: `As a full-round action, you can center your spirit. Doing so allows you to recover initiation modifier maneuvers (minimum 2) and then move up to your base speed without provoking attacks of opportunity, and also gaining a +4 insight bonus to your armor class for 1 round. The next attack you make this combat deals an additional 1d6 points of precision damage. Every 4 levels this damage increases by 1d6. This precision damage gains any bonuses your sneak attack damage does.`,
    },
    {
        name: "Defensive Focus",
        fromClass:"Warder",
        shortDesc: `As a full-round action you sets up a defensive perimeter around yourself to defend your allies for 1 round, increasing your threatened area by 5 feet + 5 feet for every five levels you possess. When doing so, you recover initiation modifier expended maneuvers (minimum 2) and until the beginning of your next turn, you may make attacks of opportunity against any opponent in this threatened area that provokes attacks of opportunity. You also gain an additional attack of opportunity that round, plus an additional attack of opportunity every 5 levels. You may move as part of these attacks of opportunity, provided your total movement before your next turn does not exceed your speed (this movement provokes attacks of opportunity as normal). Additionally, while using defensive focus, you add your initiation modifier plus your class level to your CMD for the purposes of defending against enemies trying to use the Acrobatics skill to prevent you from getting attacks of opportunity against them.`,
    },
    {
        name: "Hawkguard",
        fromClass:"Hawkguard",
        shortDesc: `As a full-round action you recover maneuvers equal to your highest mental modifier (minimum 2) while setting up a defensive perimeter around yourself to defend your allies for 1 round. While active you threaten an area within 15 feet of yourself, except for adjacent squares. This area increases by 5 feet for every five levels you possesses. You threaten this space only if you're wielding a ranged weapon, and may make attacks of opportunity with ranged weapons as long as this lasts.`,
    },
    {
        name: "Zeal",
        fromClass:"Zealot",
        shortDesc: `You can use the aid another action as a move action. When you do, you recover initiation modifier expended maneuvers (minimum 2), regardless of whather or not the aid another attempt was successful. Maneuvers initiated during your current turn cannot be recovered this way. If you use a different action to aid another, you recover only a single maneuver, and cannot recover more than 1 maneuver this way per round.`,
    },
    {
        name: "Argent of Light",
        fromClass:"Argent of Light",
        shortDesc: `As a full-round action recover a number of expended maneuvers equal to your initiation modifier (minimum 2) and and each ally within 30 feet gains damage reduction, and a sacred bonus to saving throws, equal to the your initiation modifier (minimum 1) for one round.`,
    },
    {
        name: "Ambush",
        fromClass:"Argent of Light",
        shortDesc: `Whenever you successfully attack a target that is denied its Dexterity bonus to AC (whether the target actually has a Dexterity bonus or not) or that you are flanking, you can recover a single expended maneuver. You cannot recover a maneuver you initiated since the end of your last turn with this ability. At 1st level, you can use this ability once per round. At 5th level and every 5 levels thereafter, you can use this ability an additional time per round.`,
    },
    {
        name: "Bulletwriting",
        fromClass:"Bulletwriter",
        shortDesc: `As a standard action you can load a single piece of ammunition into a firearm. When doing so, you recover half your initiation modifier expended maneuvers (minimum 1) and the ammunition gets a +1 enhancement bonus to it and deals an additional 1d6 points of damage. Every 4 levels the damage enhancement bonus increases by +1.`,
    },
    {
        name: "Dark Claim",
        fromClass:"Harbinger",
        shortDesc: `As a swift action you can claim an enemy within close range (25ft. + 5ft./2 levels). When you do this you recover one maneuver. The claim lasts for rounds equal to half your level. You cannot claim a creature again until the claim has expired. If a creature dark claimed by you is defeated, you recover maneuvers equal to your initiation modifier (minimum 2). While the creature is dark claimed it provokes attacks of opportunity from you when using the withdraw action to leave a square you threaten, and you always know the square the creature occupies, though this does not help you bypass any kind of concealment or miss chance. When you make a strike against a creature you have dark claimed, you gain a +1 bonus on the attack and damage of it. Every 6 levels the bonus increases by +1.`,
    },
    {
        name: "Crimson Claim",
        fromClass:"Crimson Countess",
        shortDesc: `As a swift action you can claim an enemy within close range (25ft. + 5ft./2 levels). When you do this you recover one maneuver. The claim lasts for rounds equal to half your level. You cannot claim a creature again until the claim has expired. If a creature crimson claimed by you is defeated, you recover maneuvers equal to your initiation modifier (minimum 2). At the start of each of your turns, all crimson claimed creatures take 1d4 points of damage, increasing by 1d4 every 6 levels. As a movement action you can damage all creatures you have crimson claimed for points equal to your level and you heal 1d6 points per creature crimson claimed. Every 6 levels the healing increases by 1d6 per creature crimson claimed.`,
    },
    {
        name: "Maven's Claim",
        fromClass:"Bloodmaven",
        shortDesc: `As a swift action you can claim an enemy within close range (25ft. + 5ft./2 levels). When you do this you recover one maneuver. The claim lasts for rounds equal to half your level. You cannot claim a creature again until the claim has expired. If a creature maven claimed by you is defeated, you recover maneuvers equal to your initiation modifier (minimum 2). Maven claimed creatures take a -1 penalty on damage rolls and the save DC's of any abilities they may possess. Every 9 levels the penalty increases by -1. You may spend level/2 spell points as a free action to double the penalties against a creature as long as that maven claim lasts.`,
    },
    {
        name: "Soul Claim",
        fromClass:"Soul Hunter",
        shortDesc: `As a swift action you can soul claim an enemy within close range (25ft. + 5ft./2 levels). The soul claim lasts for rounds equal to half your level, and you cannot have more creature's claimed than your initiation modifier. You cannot soul claim a creature again until the soul claim has expired. If you personally defeat a creature that you have soul claimed, you recover maneuvers equal to your initiation modifier (minimum 2). Whenever you make a successful attack against a creature that you have soul claimed, you deal an additional 1d6 points of untyped damage. Every 5 levels the damage increases by 1d6. This additional damage cannot be done against creaturees that do not have a vital force (eg: constructs, oozes, undead, etc.)`,
    },
    {
        name: "Knight's Ward",
        fromClass:"Knight Diciple",
        shortDesc: `As a full-round action you can protect your nearby allies. When doing so you recover your initiation modifier of expended maneuvers (minimum 2) and all allies within 30 feet gain a sacred bonus equal to your initiation modifier for saves and to armor class for 1 round.`,
    },
    {
        name: "Surging Energies",
        fromClass:"",
        shortDesc: `Once you take this perk, instead of all of your maneuvers being readied at the start of each combat/floor, you instead start with all of them expended except 2 of your choice, plus random maneuvers equal to half your initiation modifier. Then, at the start of each of your turns you recover a single random maneuver.`,
    },
    {
        name: "Offensive Concentration",
        fromClass:"Pathwalker",
        shortDesc: `When making a full-round attack, you can use a swift action to focus on your aggression to recover a single expended maneuver. You cannot recover a maneuver on the same round you have used it.`,
    },
    {
        name: "Polymath",
        fromClass:"Polymath",
        shortDesc: `As a full-round action you can recover initiation modifier (minimum 2) expended maneuvers. While doing this, you can also cast a single known spell as a swift action. This spell must have a casting time of a standard action or less, you must cast it to target yourself, and even if the spell would normally target or effect multiple creatures or affect an area, it now only effects you.`,
    },
    {
        name: "Roildancer",
        fromClass:"Roildancer",
        shortDesc: `As a movement action you can recover a single maneuver. You cannot use a maneuver the round you have recovered it, or recover it the same round you have used it. Alternatively as a full-round action you can spend level/2 spell points to recover initiation modifier maneuvers (minimum 2).`,
    },
    {
        name: "Warmage",
        fromClass:"Warmage",
        shortDesc: `As a full-round action you can center your arcane power, recovering initiation modifier expended maneuvers (minimum 2), and on the next spell you cast, you may roll twice and take the higher result on one die roll made as part of the spell.`,
    },
    {
        name: "Warsoul",
        shortDesc: `As a full-round action you become focus your mind, recovering initiation modifier expended maneuvers (minimum 2). For one round while focused, you react violently to those who would interrupt you. When attacked, you may make an immediate counter-attack against the attacker at your full base attack bonus. You may make one counter-attack against a given enemy per round, and make no more than a total of 1 + initiation modifier counter attacks during the round.`,
    },
    {
        name: "Field Medic",
        shortDesc: `As a full-round action you bandage up yourself or an adjacent ally. While doing so, you recover initiation modifier expended maneuvers (minimum 2), and you make a heal check on an adjacent ally, restoring hit points equal to the result of the check -15. This counts as the bandage up action, and any bonuses that modify that ability, also modify this ability. However, instead of having a single use per ally per floor, you can do it times per floor equal to your initiation modifier, though using this restricts others from using the bandage up action on them. If you use a different action to bandage up, you recover only a single maneuver, and cannot recover more than 1 maneuver this way per round.`,
    },
    {
        name: "Batal's Rage",
        shortDesc: `As a full-round action you can make a ranged touch attack against an enemy within close range (25ft. + 5ft./2 levels). This attack does not provoke attacks of opportunity and you may use your highest mental modifier in place of your dexterity for determining its attack bonus. The attack deals 1d6 points of damage for each of your expended maneuvers (max d6's equal to your level), plus your initiation modifier. The damage increases by 1 step every 5 levels. For every 3 currently expended maneuvers the action to use this ability reduces by 1 step (full-round -> standard -> movement -> swift. minimum swift action). After the attack, you recover half your initiation modifier of expended maneuvers.`,
    },
    {
        name: "Batal's Bolster",
        shortDesc: `As a full-round action you can make a ranged touch attack against an ally within close range (25ft. + 5ft./2 levels) (cannot be used on yourself). This attack does not provoke attacks of opportunity and you may use your highest mental modifier in place of your dexterity for determining its attack bonus. The attack grants the ally 1d8 points of temporary hit points for each of your expended maneuvers (max d8's equal to your level), plus your initiation modifier. The temporary hit points increases by 1 step every 5 levels and lasts for the rest of the encounter. For every 3 currently expended maneuvers the action to use this ability reduces by 1 step (full-round -> standard -> movement -> swift. minimum swift action). After the attack, you recover half your initiation modifier of expended maneuvers.`,
    },
    {
        name: "Unyielding Flesh",
        shortDesc: `As a full-round action you can recover initiation modifier expended maneuvers (minimum 2). When you do, you gain twice your level as temporary hit points, and damage reduction/- equal to your initiation modifier (minimum 0). These both last for 1 round and stack with any other temporary hit points or damage reduction you may have. The next strike you initiate this encounter deals additional bleed damage equal to your initiation modifier.`,
    },
    {
        name: "Night Terror",
        shortDesc: `As a full-round action you can recover initiation modifier expended maneuvers (minimum 2). When you do, you gain a +4 insight bonus to your AC for one round and can move up to to your speed during the action, provoking attacks of opportunity as normal. In addition, the next attack you make this encounter adds your sneak attack damage if it hits, regardless of whether or not the target is flanked or flat-footed.`,
    },
    {
        name: "Fearmonger",
        shortDesc: `You gain the dazzling display feat. Every time you use it, you recover initiation modifier expended maneuvers (minimum 2). If you use dazzling display as an action less than a full-round action, you instead only recover a single maneuver.`,
        hasCustomMethod:true,
        customMethod:()=>{},
        catchUpMethod:(context)=>{
            let feat = JSON.parse(JSON.stringify(feats.find(feat=>feat.name=="Dazzling Display")))
            feat.id = Math.random()
            context.stats.lists.feats.push(feat)
        }
    },    
    {
        name: "Heroic Recovery",
        shortDesc: "As a swift action you can spend spell points equal to the maneuver's level to recover it. You cannot initiate a maneuver the same round you recover it this way, nor recover a maneuver you have used this round..",
    },
    {
        name: "Spark of Inspiration",
        shortDesc: "Once per round when you score a successful critical hit, you can recover a single maneuver. For each multiplier above x2 of the attacks critical damage multiplier, you can recharge an additional maneuver. You cannot initiate a maneuver the same round you recover it this way, nor recover a maneuver you have used this round.",
    },
    {
        name: "Flash of Rage",
        shortDesc: "When a critical hit is scored against an ally that you can see, you can recover a single maneuver. If a critical hit is scored against you, you recover constitution modifier expended maneuvers. Once per ally per floor, if they are slain you recover all expended maneuers.",
    },
    {
        name: "Shielding Fist",
        shortDesc: "As a full-round action you can leap to defend your allies, doing so allows you to recover maneuvers equal to your initiation modifier (minimum 2), and move up to your movement speed. You then can grant yourself or an adjacent ally an insight bonus to their armor class and saves equal to your initiation modifier for 1 round.",
    },
    {
        name: "Defensive Form",
        shortDesc: "As a full-round action you take on a defensive form, doing so allows you to recover maneuvers equal to your initiation modifier (minimum 2), and until the start of your next turn, attacks made against you provoke an attack of opportunity from you (after the attack finishes) and you can take a 5-foot step each time you are attacked (even if you have already taken one this round). In addition, you gains the benefit of the Combat Reflexes feat, and can use your initiation modifier instead of your Dexterity modifier for determining how many additional attacks of opportunity you can make.",
    },
    {
        name: "Spell Surges",
        shortDesc: "Whenever you cast a spell you can recover an expended maneuver that is of a level equal to or lower than the spells as a swift action. If casting the spell had an action of a swift action or lower, then you can recharge it as a free action instead, but it has to be of a level lower than the spells. You can only use this once per round.",
    },
    {
        name: "Iaido",
        fromClass:"Bushi",
        shortDesc: "When you sheathe a weapon (normally a move action), you recovers one maneuver. You cannot recover more than one maneuver per round this way, no matter how many weapons you sheath or how many times you sheath an individual weapon per round. You cannot initiate a maneuver the same round you recover it this way, nor recover a maneuver you have used this round.",
    },
    {
        name: "Blade Focus",
        shortDesc: "As a full-round action, you prepare for the combat ahead. Recover maneuvers equal to your highest mental modifier (minimum 2), and gain counterpoints equal to your highest level maneuver known, and an equal amount of bonus temporary counterpoints that end at the start of your next turn.",
    },
    {
        name: "Gambit (warlord)",
        shortDesc: "gambits",
    },
    {
        name: "Gambit (warlord)",
        shortDesc: "gambits",
    },
    {
        name: "Gambit (warlord)",
        shortDesc: "gambits",
    },
    {
        name: "Gambit (warlord)",
        shortDesc: "gambits",
    },
    {
        name: "Gambit (warlord)",
        shortDesc: "gambits",
    },
]
